
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2rynm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $jmjWc = parcelRequire("jmjWc");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $io723 = parcelRequire("io723");


var $9wGTI = parcelRequire("9wGTI");











const $16e27872478384c0$export$7f1bcb54a9a4d80e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kWSCB",
    name: "ShortcutsSection",
    loader: async ()=>(await (parcelRequire("1tsAd"))).ShortcutsSection
});


/**
 * @generated SignedSource<<c97c5b258e6679cdc97139884146f943>>
 * @relayHash e08c660ac5bdc886bb33b567a945aed4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba
const $4d55e7bf74ef8f79$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e08c660ac5bdc886bb33b567a945aed4",
            "id": "2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba",
            "metadata": {},
            "name": "SpaceViewsControllerQuery",
            "operationKind": "query",
            "text": "query SpaceViewsControllerQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$4d55e7bf74ef8f79$var$node.hash = "d33ab2e8cd8e66319f41302e5bdaa679";
var $4d55e7bf74ef8f79$export$2e2bcd8739ae039 = $4d55e7bf74ef8f79$var$node;






var $aXWIB = parcelRequire("aXWIB");


var $9hlns = parcelRequire("9hlns");


var $bTdbD = parcelRequire("bTdbD");


var $4NZXC = parcelRequire("4NZXC");


var $5izcQ = parcelRequire("5izcQ");


var $1CdLs = parcelRequire("1CdLs");

var $YQCfa = parcelRequire("YQCfa");

var $8INvs = parcelRequire("8INvs");


var $bedQP = parcelRequire("bedQP");


var $3qtLb = parcelRequire("3qtLb");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $b3j2Y = parcelRequire("b3j2Y");














var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9eE57 = parcelRequire("9eE57");

/**
 * @generated SignedSource<<5dba3a144ab42cf95f6adf8ddd214d30>>
 * @relayHash d1f433c5859a639556bc75700750a999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006
const $48c38c534b125c22$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "shouldShowCardOnPageTreeHover"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d1f433c5859a639556bc75700750a999",
            "id": "120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006",
            "metadata": {},
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "operationKind": "query",
            "text": "query useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery{userPreferences{shouldShowCardOnPageTreeHover}}"
        }
    };
}();
$48c38c534b125c22$var$node.hash = "1e92ca51a019c1c7e4b73556b6c593ea";
var $48c38c534b125c22$export$2e2bcd8739ae039 = $48c38c534b125c22$var$node;





/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab = /*#__PURE__*/ function(PageCardInPageTreeHoverPreference) {
    PageCardInPageTreeHoverPreference["NO_OPTION_SELECTED"] = "NO_OPTION_SELECTED";
    PageCardInPageTreeHoverPreference["NO_SHOW_PAGECARD"] = "NO_SHOW_PAGECARD";
    PageCardInPageTreeHoverPreference["SHOW_PAGECARD"] = "SHOW_PAGECARD";
    return PageCardInPageTreeHoverPreference;
}({});



var $jMyy4 = parcelRequire("jMyy4");

const $2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery = (0, $48c38c534b125c22$export$2e2bcd8739ae039);
const $2d41bbac85093ab1$export$f824d805fc04fcb2 = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery, {
        skip: !isLicensed
    });
    // don't render popups for anon users.
    // This is after the useQuery because conditionally running hooks isn't allowed.
    if (!isLicensed) return {
        isHoverPageCardOptedIn: false
    };
    const userPreference = data?.userPreferences?.shouldShowCardOnPageTreeHover;
    return {
        isHoverPageCardOptedIn: userPreference !== (0, $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab).NO_SHOW_PAGECARD
    };
};


const $f35e894e447c6262$export$2de55e286c149cfa = 300;
const $f35e894e447c6262$export$1bbe776c3ae63e35 = 400;
const $f35e894e447c6262$export$3bba19b3f6dc31cd = (source)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn } = (0, $2d41bbac85093ab1$export$f824d805fc04fcb2)();
    // the tree item id and the trigger should be grouped into one state as the trigger always corresponds with the itemID
    // this prevents unnecessary rerenders of the hover page card
    const [showHoverPageCardForItem, setShowHoverPageCardForItem] = (0, $42omo.useState)({
        itemID: null,
        trigger: null
    });
    const openSidebarPopupTimerRef = (0, $42omo.useRef)(null);
    const closeSidebarPopupTimerRef = (0, $42omo.useRef)(null);
    /**
   * Cancel the open sidebar popup cards timer
   */ const clearOpenSidebarPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openSidebarPopupTimerRef?.current) {
            clearTimeout(openSidebarPopupTimerRef.current);
            openSidebarPopupTimerRef.current = null;
        }
    }, [
        openSidebarPopupTimerRef
    ]);
    /**
   * Cancel the close sidebar popup cards timer
   */ const clearCloseSidebarPopupTimer = (0, $42omo.useCallback)(()=>{
        if (closeSidebarPopupTimerRef.current) {
            clearTimeout(closeSidebarPopupTimerRef?.current);
            closeSidebarPopupTimerRef.current = null;
        }
    }, [
        closeSidebarPopupTimerRef
    ]);
    /**
   * On mouse enter/focus of the hover target, create a hover card for that itemId
   * Start the timer which will open the popup if the user hovers on the tree item for HOVER_DELAY_TIME.
   * Clears any closePageCard timers since we don't need to close the popup, we can just replace the showHoverPageCardForItem.
   * This is called onMouseOver of page tree items.
   */ const onEnterHoverTarget = (0, $42omo.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        clearCloseSidebarPopupTimer();
        // only show a hover card if it matches to conditions to show it and it isn't already showing a card for the same itemID
        if (isHoverPageCardOptedIn && !isQuickActionsFocused && !isContextualCreateFocused && showHoverPageCardForItem.itemID !== itemID) {
            if (openSidebarPopupTimerRef.current === null) openSidebarPopupTimerRef.current = setTimeout(()=>{
                // this setstate is the one and only line that causes SpaceHoverPageCard to rerender
                setShowHoverPageCardForItem({
                    itemID: itemID,
                    trigger: hoverPageCardTriggerRef
                });
                experienceTracker.start({
                    name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).SPACE_VIEWS,
                    attributes: {
                        source: source
                    }
                });
                (0, $9eE57.perfMarkStart)({
                    subject: 'HoverPageCard',
                    subjectId: 'rendered'
                });
                openSidebarPopupTimerRef.current = null;
            }, $f35e894e447c6262$export$2de55e286c149cfa);
        }
    }, // adding showHoverPageCardForItem into the dependency array causes the entire page tree to rerender on any item hover.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        clearCloseSidebarPopupTimer,
        experienceTracker,
        isHoverPageCardOptedIn,
        source
    ]);
    /**
   * Closes all popups after CLOSE_DELAY_TIME if the closeSidebarPopupTimerRef timer has not been cleared before then
   * Called on mouse leave of a page tree item
   */ const startCloseHoverPageCardTimer = (0, $42omo.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
        clearOpenSidebarPopupTimer();
        if (closeSidebarPopupTimerRef.current === null) closeSidebarPopupTimerRef.current = setTimeout(()=>{
            setShowHoverPageCardForItem({
                itemID: null,
                trigger: null
            });
            closeSidebarPopupTimerRef.current = null;
        }, $f35e894e447c6262$export$1bbe776c3ae63e35);
    }, [
        experienceTracker,
        clearOpenSidebarPopupTimer
    ]);
    /**
   * Clear all the timers, called when the mouse reenters
   */ const clearHoverPageCardTimers = (0, $42omo.useCallback)(()=>{
        clearOpenSidebarPopupTimer();
        clearCloseSidebarPopupTimer();
    }, [
        clearOpenSidebarPopupTimer,
        clearCloseSidebarPopupTimer
    ]);
    /**
   * Immediately force close all popups when this is called.
   * Called when the popup is clicked on or when the page is redirected
   */ const closeAllHoverPageCards = (0, $42omo.useCallback)(()=>{
        clearHoverPageCardTimers();
        setShowHoverPageCardForItem({
            itemID: null,
            trigger: null
        });
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
    }, [
        experienceTracker,
        clearHoverPageCardTimers
    ]);
    /**
   * On mouseleave of the hover target, start close timer for that item's hover card
   */ const onLeaveHoverTarget = (0, $42omo.useCallback)(()=>{
        startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    /**
   * On blur of the hover target, start close timer for that item's hover card
   */ const onBlurHoverTarget = (0, $42omo.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    return {
        closeAllHoverPageCards: closeAllHoverPageCards,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        showHoverPageCardForItem: showHoverPageCardForItem,
        isHoverPageCardOptedIn: isHoverPageCardOptedIn,
        onEnterHoverTarget: onEnterHoverTarget,
        onLeaveHoverTarget: onLeaveHoverTarget,
        onBlurHoverTarget: onBlurHoverTarget
    };
};



var $lfFzM = parcelRequire("lfFzM");





var $j3kZx = parcelRequire("j3kZx");





const $d9810ba2fa073e42$export$d09f0ee316c3b5c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "06Lgw",
    name: "LazySpaceHoverPageCard",
    loader: async ()=>(await (parcelRequire("98dOx"))).SpaceHoverPageCard
});



var $2vuKf = parcelRequire("2vuKf");





var $6mKj3 = parcelRequire("6mKj3");


var $bOLC6 = parcelRequire("bOLC6");


var $arWla = parcelRequire("arWla");










const $add9014203bde61c$var$stopOrSucceed = (name, attributes, error, experienceTracker)=>{
    if (error) experienceTracker.stopOnError({
        name: name,
        attributes: attributes,
        error: error
    });
    else experienceTracker.succeed({
        name: name,
        attributes: attributes
    });
};
const $add9014203bde61c$export$122d712fe0dbd67 = ({ loading: loading, error: error, persistenceError: persistenceError, persistenceUpdateLoading: persistenceUpdateLoading, persistenceUpdateError: persistenceUpdateError, spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, isSpaceAdmin: isSpaceAdmin })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeTrackedFetchMore = (0, $42omo.useCallback)((fetchMore)=>()=>{
            experienceTracker.start({
                name: (0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE)
            });
            fetchMore();
        }, [
        experienceTracker
    ]);
    const trackedSetSpaceViewsSort = (0, $42omo.useCallback)((newSort)=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE),
            attributes: {
                prevSort: spaceViewsSort
            }
        });
        setSpaceViewsSort(newSort);
    }, [
        experienceTracker,
        spaceViewsSort,
        setSpaceViewsSort
    ]);
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !persistenceUpdateLoading) {
            const attributes = {
                spaceViewsSort: spaceViewsSort
            };
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE), {
                spaceViewsSort: spaceViewsSort,
                isSpaceAdmin: isSpaceAdmin
            }, error || persistenceError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE), attributes, error || persistenceUpdateError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE), attributes, error, experienceTracker);
        }
    }, [
        experienceTracker,
        loading,
        error,
        persistenceError,
        persistenceUpdateLoading,
        persistenceUpdateError,
        spaceViewsSort,
        isSpaceAdmin
    ]);
    return {
        makeTrackedFetchMore: makeTrackedFetchMore,
        trackedSetSpaceViewsSort: trackedSetSpaceViewsSort
    };
};


const $5a12275e9873d32f$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));

const $5a12275e9873d32f$var$SpaceViews = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-2bnv",
    name: "SpaceViews",
    loader: async ()=>(await (parcelRequire("eX2cl"))).SpaceViews
});

const $5a12275e9873d32f$var$PagesItemActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctWVd",
    name: "PagesItemActions",
    loader: async ()=>(await (parcelRequire("lWNKj"))).PagesItemActions
});

const $5a12275e9873d32f$var$ContentTreeSearchLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Dl_eE",
    name: "ContentTreeSearchLoader",
    loader: async ()=>(await (parcelRequire("7S98R"))).ContentTreeSearch
});
const $5a12275e9873d32f$var$i18n = (0, $aXWIB.defineMessages)({
    contentTitle: {
        id: "space-views.collapsible-section.title",
        defaultMessage: "Content"
    },
    multiSelectContentTitle: {
        id: "space-views.collapsible-section.title.multi-select",
        defaultMessage: "Multi-select content"
    }
});
const $5a12275e9873d32f$var$SpaceViewsControllerComponent = ({ onDragDropSuccess: onDragDropSuccess, isPeekingFromBlogs: isPeekingFromBlogs, spaceHasUserContent: spaceHasUserContent, homepageId: homepageId, onContentTreeLoadComplete: onContentTreeLoadComplete, pageTreeFinishedLoading: pageTreeFinishedLoading, relatedContent: relatedContent })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    const { spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, queryLoading: persistenceLoading, queryError: persistenceError, mutationLoading: persistenceUpdateLoading, mutationError: persistenceUpdateError } = (0, $bOLC6.useSpaceViewsOptions)(// @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
    spaceKey, isLicensed);
    const forceExpandBecauseViewingContentTree = pageContextContentType !== 'blogpost';
    const [isPageTreeLoading, setIsPageTreeLoading] = (0, $42omo.useState)(true);
    const [pageTreeError, setPageTreeError] = (0, $42omo.useState)();
    const [isSpaceViewsLoading, setIsSpaceViewsLoading] = (0, $42omo.useState)(true);
    const [contentTreeSize, setContentTreeSize] = (0, $42omo.useState)(0);
    const [spaceViewsError, setSpaceViewsError] = (0, $42omo.useState)();
    const isPageTree = spaceViewsSort === 'TREE';
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    // Ref to the space views menu trigger button in the content header
    const spaceViewsMenuTriggerRef = (0, $42omo.useRef)(null);
    const { data: data, loading: isSpaceAdminQueryLoading, error: isSpaceAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $4d55e7bf74ef8f79$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey ?? ''
        }
    });
    const loading = persistenceLoading || (isPageTree ? isPageTreeLoading : isSpaceViewsLoading) || isSpaceAdminQueryLoading;
    const error = pageTreeError || spaceViewsError || isSpaceAdminQueryError;
    const isSpaceAdmin = Boolean(data?.space?.currentUser?.isAdmin);
    const isSpaceAdminOrSuperAdmin = isSpaceAdmin || isSuperAdmin;
    const { trackedSetSpaceViewsSort: trackedSetSpaceViewsSort, makeTrackedFetchMore: makeTrackedFetchMore } = (0, $add9014203bde61c$export$122d712fe0dbd67)({
        loading: loading,
        error: error,
        persistenceError: persistenceError,
        persistenceUpdateLoading: persistenceUpdateLoading,
        persistenceUpdateError: persistenceUpdateError,
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        isSpaceAdmin: isSpaceAdmin
    });
    const { onEnterHoverTarget: showHoverPageCardOnEnterHoverTarget, closeAllHoverPageCards: closeAllHoverPageCards, startCloseHoverPageCardTimer: startCloseHoverPageCardTimer, clearHoverPageCardTimers: clearHoverPageCardTimers, showHoverPageCardForItem: showHoverPageCardForItem, isHoverPageCardOptedIn: isHoverPageCardOptedIn, onLeaveHoverTarget: onLeaveHoverTarget, onBlurHoverTarget: onBlurHoverTarget } = (0, $f35e894e447c6262$export$3bba19b3f6dc31cd)(spaceViewsSort);
    const [shouldRenderAfterIcon, setShouldRenderAfterIcon] = (0, $42omo.useState)(false);
    const onEnterHoverTarget = (0, $42omo.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        showHoverPageCardOnEnterHoverTarget({
            itemID: itemID,
            isQuickActionsFocused: isQuickActionsFocused,
            hoverPageCardTriggerRef: hoverPageCardTriggerRef,
            isContextualCreateFocused: isContextualCreateFocused
        });
        setShouldRenderAfterIcon(true);
    }, [
        showHoverPageCardOnEnterHoverTarget,
        setShouldRenderAfterIcon
    ]);
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)({
        sectionName: 'contentTree',
        collapsedByDefault: !forceExpandBecauseViewingContentTree,
        forceExpand: forceExpandBecauseViewingContentTree
    });
    const handleSpaceViewCleared = (0, $42omo.useCallback)(()=>{
        // Focus the space views menu trigger button in the content header using React ref
        if (spaceViewsMenuTriggerRef.current) spaceViewsMenuTriggerRef.current.focus();
    }, [
        spaceViewsMenuTriggerRef
    ]);
    const renderContentTree = (0, $42omo.useMemo)(()=>{
        if (persistenceLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arWla.FlexCenter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium"
        }));
        const hoverPageCardProps = {
            onEnterHoverTarget: onEnterHoverTarget,
            closeAllHoverPageCards: closeAllHoverPageCards,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget
        };
        if (isPageTree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$ContentTreeSearchLoader, {
            contentTreeSize: contentTreeSize,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            isLicensed: isLicensed,
            isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin,
            ...hoverPageCardProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3qtLb.PageTree), {
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isPeekingFromBlogs,
            isSuperAdmin: isSuperAdmin,
            setIsPageTreeLoading: setIsPageTreeLoading,
            setPageTreeError: setPageTreeError,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            homepageId: homepageId,
            setContentTreeSize: setContentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            ...hoverPageCardProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$SpaceViews, {
            spaceViewsSort: spaceViewsSort,
            setIsSpaceViewsLoading: setIsSpaceViewsLoading,
            setSpaceViewsError: setSpaceViewsError,
            trackedSetSpaceViewsSort: trackedSetSpaceViewsSort,
            makeTrackedFetchMore: makeTrackedFetchMore,
            spaceKey: spaceKey,
            contentId: contentId,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            contentTreeSize: contentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            onSpaceViewCleared: handleSpaceViewCleared,
            ...hoverPageCardProps
        });
    }, [
        persistenceLoading,
        onEnterHoverTarget,
        closeAllHoverPageCards,
        isHoverPageCardOptedIn,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        isPageTree,
        spaceViewsSort,
        trackedSetSpaceViewsSort,
        makeTrackedFetchMore,
        spaceKey,
        contentId,
        shouldRenderAfterIcon,
        contentTreeSize,
        onContentTreeLoadComplete,
        isLicensed,
        onDragDropSuccess,
        isPeekingFromBlogs,
        isSuperAdmin,
        homepageId,
        isSpaceAdminOrSuperAdmin,
        handleSpaceViewCleared
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CdLs.ExpandableMenuItem), {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$RemovedSpotlightTarget, {
        name: "nav4-spotlight-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8INvs.ExpandableMenuItemTrigger), {
        elemBefore: isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTdbD))), {
            label: "",
            color: "currentColor"
        }),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$PagesItemActions, {
            isLicensed: isLicensed,
            edition: edition ?? undefined,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            spaceKey: spaceKey || '',
            expandContentSection: ()=>onExpansionToggle(true),
            onItemClick: ()=>onExpansionToggle(true),
            spaceHasUserContent: spaceHasUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin,
            spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef
        })
    }, isMultiSelectActive ? formatMessage($5a12275e9873d32f$var$i18n.multiSelectContentTitle) : formatMessage($5a12275e9873d32f$var$i18n.contentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $YQCfa.ExpandableMenuItemContent), null, (0, $6mKj3.expValEquals)('confluence_autonomous_space_curation', 'isEnabled', true) ? relatedContent : null, renderContentTree, isHoverPageCardOptedIn && showHoverPageCardForItem.itemID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d9810ba2fa073e42$export$d09f0ee316c3b5c1), {
        showHoverPageCardForItem: showHoverPageCardForItem,
        closeAllHoverPageCards: closeAllHoverPageCards,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        onBlurHoverTarget: onBlurHoverTarget,
        shouldUseAutomationDiscovery: true,
        key: showHoverPageCardForItem.itemID
    }) : null, persistenceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: persistenceError
    })));
};
const $5a12275e9873d32f$export$5bb6552a789f7a6f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, $5a12275e9873d32f$var$SpaceViewsControllerComponent({
        ...props
    }));









const $2956b96ada85ef60$export$a2e535ad780a85fe = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9L4J0",
    name: "BlogTree",
    loader: async ()=>(await (parcelRequire("gVGbn"))).BlogTree
});















var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $2W0qg = parcelRequire("2W0qg");


var $hmuev = parcelRequire("hmuev");


var $6xdDU = parcelRequire("6xdDU");


var $5nBzc = parcelRequire("5nBzc");





var $7xVCs = parcelRequire("7xVCs");


var $1I9Gw = parcelRequire("1I9Gw");








var $3d6VZ = parcelRequire("3d6VZ");


var $f7B1p = parcelRequire("f7B1p");

var $559b6cb878c71eb1$exports = {};
$559b6cb878c71eb1$exports = new URL("loom.96da19c1.svg", import.meta.url).toString();


var $c5f1592a357e181d$exports = {};
$c5f1592a357e181d$exports = new URL("microsoft-teams.4206e18c.svg", import.meta.url).toString();


var $e4a87a0fae275d2a$exports = {};
$e4a87a0fae275d2a$exports = new URL("google-drive.3a58669c.svg", import.meta.url).toString();


var $9f5abb833c441bee$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["SUGGEST"] = "SUGGEST";
    Action["ACCEPT"] = "ACCEPT";
    Action["REJECT"] = "REJECT";
    return Action;
}({});
const $9f5abb833c441bee$export$f0c7a43b2eefe22f = {
    LOOM: 'loom',
    MICROSOFT_TEAMS: 'teams',
    GOOGLE_DRIVE: 'gdrive'
};
const $9f5abb833c441bee$export$fcdafa222e2a08e2 = Object.values($9f5abb833c441bee$export$f0c7a43b2eefe22f);
const $9f5abb833c441bee$export$defe15004d994007 = {
    [$9f5abb833c441bee$export$f0c7a43b2eefe22f.LOOM]: (0, (/*@__PURE__*/$parcel$interopDefault($559b6cb878c71eb1$exports))),
    [$9f5abb833c441bee$export$f0c7a43b2eefe22f.MICROSOFT_TEAMS]: (0, (/*@__PURE__*/$parcel$interopDefault($c5f1592a357e181d$exports))),
    [$9f5abb833c441bee$export$f0c7a43b2eefe22f.GOOGLE_DRIVE]: (0, (/*@__PURE__*/$parcel$interopDefault($e4a87a0fae275d2a$exports)))
};
const $9f5abb833c441bee$export$51b10001420b4ba3 = [
    {
        pattern: 'docs.google.com/document',
        product: 'Google Docs',
        productKey: 'googleDocs',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'docs.google.com/spreadsheets',
        product: 'Google Sheets',
        productKey: 'googleSheets',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png'
    },
    {
        pattern: 'docs.google.com/presentation',
        product: 'Google Slides',
        productKey: 'googleSlides',
        iconUrl: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico'
    },
    {
        pattern: 'drive.google.com',
        product: 'Google Drive',
        productKey: 'googleDrive',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'loom.com',
        product: 'Loom',
        productKey: 'loom',
        iconUrl: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico'
    },
    {
        pattern: 'teams.microsoft.com',
        product: 'Microsoft Teams',
        productKey: 'microsoftTeams',
        iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c5f1592a357e181d$exports)))
    }
];
function $9f5abb833c441bee$var$getProductIconMapEntryForContentUrl(url) {
    return $9f5abb833c441bee$export$51b10001420b4ba3.find((entry)=>url.includes(entry.pattern));
}
function $9f5abb833c441bee$export$39b141cbf41f04f3(url) {
    return $9f5abb833c441bee$var$getProductIconMapEntryForContentUrl(url)?.productKey ?? 'link';
}
function $9f5abb833c441bee$export$82cacbc9ddf6b54e(url) {
    return $9f5abb833c441bee$var$getProductIconMapEntryForContentUrl(url)?.iconUrl ?? '';
}


// name` values from `search.configuration.thirdPartyProducts
var $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_CONNECTOR_NAME = /*#__PURE__*/ function(SEARCH_THIRD_PARTY_CONNECTOR_NAME) {
    SEARCH_THIRD_PARTY_CONNECTOR_NAME["GOOGLE_DRIVE"] = "google-drive-connector";
    SEARCH_THIRD_PARTY_CONNECTOR_NAME["MICROSOFT_TEAMS"] = "microsoft-teams-connector";
    return SEARCH_THIRD_PARTY_CONNECTOR_NAME;
}($06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_CONNECTOR_NAME || {});
const $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION = 'SearchThirdPartyAuthConfiguration';
const $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_QUERY = `
query SearchThirdPartyAuthConfiguration($cloudId: ID!) {
	search {
		configuration(cloudId: $cloudId) {
			thirdPartyProducts {
				name
				isUserOAuthed
				outboundAuthUrl
				providerId
			}
		}
	}
}
`.trim();
const $06f9e66a9eacf0bf$var$filterAuthenticationStatus = (merged)=>{
    const authenticatedServices = {};
    const unauthenticatedServices = {};
    Object.entries(merged).forEach(([product, status])=>{
        if (status.isAuthenticated) authenticatedServices[product] = status;
        else unauthenticatedServices[product] = status;
    });
    return {
        authenticatedServices: authenticatedServices,
        unauthenticatedServices: unauthenticatedServices
    };
};
const $06f9e66a9eacf0bf$var$getLoomAuthStatus = async ()=>{
    try {
        const loomUserStatus = await (0, $3d6VZ.getAuthState)();
        return {
            isAuthenticated: loomUserStatus !== undefined && loomUserStatus !== 'NOT_FOUND'
        };
    } catch (e) {
        return {
            isAuthenticated: false,
            error: e instanceof Error ? e : new Error('Failed to fetch Loom auth status')
        };
    }
};
async function $06f9e66a9eacf0bf$var$fetchSearchThirdPartyProducts(cloudId) {
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/graphql?q=${$06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_QUERY,
                variables: {
                    cloudId: cloudId
                },
                operationName: $06f9e66a9eacf0bf$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION
            })
        });
        const json = await response.json();
        if (json.errors?.length) return {
            error: new Error(json.errors.map((e)=>e.message ?? 'GraphQL error').join('; '))
        };
        const products = json.data?.search?.configuration?.thirdPartyProducts ?? [];
        return {
            products: products
        };
    } catch (e) {
        return {
            error: e instanceof Error ? e : new Error('Failed to fetch search third-party configuration')
        };
    }
}
function $06f9e66a9eacf0bf$var$authStatusForSearchConnector(products, connectorName, fetchError) {
    const outboundAuthUrl = $06f9e66a9eacf0bf$var$outboundAuthUrlForConnector(products, connectorName);
    if (fetchError) return {
        isAuthenticated: false,
        error: fetchError,
        outboundAuthUrl: outboundAuthUrl
    };
    const matches = products.filter((p)=>p.name === connectorName);
    if (matches.length === 0) return {
        isAuthenticated: false,
        outboundAuthUrl: outboundAuthUrl
    };
    return {
        isAuthenticated: matches.some((p)=>p.isUserOAuthed),
        outboundAuthUrl: outboundAuthUrl
    };
}
function $06f9e66a9eacf0bf$var$outboundAuthUrlForConnector(products, connectorName) {
    const match = products.find((p)=>p.name === connectorName);
    return match?.outboundAuthUrl;
}
const $06f9e66a9eacf0bf$export$3d6949c2295aff10 = ({ products: products, cloudId: cloudId })=>{
    const [mergedByProduct, setMergedByProduct] = (0, $42omo.useState)(null);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const productsKey = products.join(',');
    const stableProductsRef = (0, $42omo.useRef)(products);
    if (stableProductsRef.current.join(',') !== productsKey) stableProductsRef.current = products;
    const refetch = (0, $42omo.useCallback)(async ()=>{
        const products_0 = stableProductsRef.current;
        if (products_0.length === 0) {
            setMergedByProduct(null);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const merged = {};
            let searchProducts = [];
            let searchFetchError;
            if (products_0.includes((0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS) || products_0.includes((0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).GOOGLE_DRIVE)) {
                const searchResult = await $06f9e66a9eacf0bf$var$fetchSearchThirdPartyProducts(cloudId);
                if ('error' in searchResult) searchFetchError = searchResult.error;
                else searchProducts = searchResult.products;
            }
            for (const product of products_0)switch(product){
                case (0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).LOOM:
                    merged[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).LOOM] = await $06f9e66a9eacf0bf$var$getLoomAuthStatus();
                    break;
                case (0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS:
                    merged[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS] = $06f9e66a9eacf0bf$var$authStatusForSearchConnector(searchProducts, "microsoft-teams-connector", searchFetchError);
                    break;
                case (0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).GOOGLE_DRIVE:
                    merged[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).GOOGLE_DRIVE] = $06f9e66a9eacf0bf$var$authStatusForSearchConnector(searchProducts, "google-drive-connector", searchFetchError);
                    break;
            }
            setMergedByProduct(merged);
        } finally{
            setIsLoading(false);
        }
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    const { authenticatedServices: authenticatedServices, unauthenticatedServices: unauthenticatedServices } = (0, $42omo.useMemo)(()=>{
        if (mergedByProduct == null) return {
            authenticatedServices: {},
            unauthenticatedServices: {}
        };
        return $06f9e66a9eacf0bf$var$filterAuthenticationStatus(mergedByProduct);
    }, [
        mergedByProduct
    ]);
    return {
        authenticatedServices: authenticatedServices,
        unauthenticatedServices: unauthenticatedServices,
        isLoading: isLoading,
        refetch: refetch
    };
};












var $jTxSS = parcelRequire("jTxSS");














var $cO1el = parcelRequire("cO1el");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");



var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");







var $9ot3w = parcelRequire("9ot3w");




var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $5tmwS = parcelRequire("5tmwS");


var $eG1e2 = parcelRequire("eG1e2");


var $jdPfT = parcelRequire("jdPfT");





var $7aA9P = parcelRequire("7aA9P");


var $lsxnT = parcelRequire("lsxnT");


var $gqqjz = parcelRequire("gqqjz");


















































const $c5ab38ff0f87742b$var$styles = {
    wrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    iconSlot: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqr5cr _kqswh2mm",
    iconSlotFirst: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqidpf _kqswh2mm"
};
const $c5ab38ff0f87742b$var$ICON_SIZE = {
    small: 16,
    large: 28
};
const $c5ab38ff0f87742b$var$TILT_ANGLE_DEG = 10;
const $c5ab38ff0f87742b$var$iconZIndex = (index, total)=>total - index;
function $c5ab38ff0f87742b$var$getTiltTransform(index) {
    const rotationDeg = index % 2 === 0 ? -$c5ab38ff0f87742b$var$TILT_ANGLE_DEG : $c5ab38ff0f87742b$var$TILT_ANGLE_DEG;
    return `rotate(${rotationDeg}deg)`;
}
const $c5ab38ff0f87742b$export$98526f0dffd4f41b = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { iconUrls: iconUrls, variant: t1, tilted: t2, testId: t3 } = t0;
    const variant = t1 === undefined ? "small" : t1;
    const tilted = t2 === undefined ? false : t2;
    const testId = t3 === undefined ? "stacked-content-type-icons" : t3;
    let T0;
    let t4;
    let t5;
    let t6;
    if ($[0] !== iconUrls || $[1] !== testId || $[2] !== tilted || $[3] !== variant) {
        const displayUrls = (iconUrls ?? []).slice(0, 3);
        T0 = (0, $gdv5Z.default);
        t4 = $c5ab38ff0f87742b$var$styles.wrapper;
        t5 = testId;
        t6 = displayUrls.length > 0 ? displayUrls.map((url, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                key: `${url}-${i}`,
                xcss: i === 0 ? $c5ab38ff0f87742b$var$styles.iconSlotFirst : $c5ab38ff0f87742b$var$styles.iconSlot,
                style: {
                    zIndex: $c5ab38ff0f87742b$var$iconZIndex(i, displayUrls.length),
                    transform: tilted && displayUrls.length > 1 ? $c5ab38ff0f87742b$var$getTiltTransform(i) : undefined
                },
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
                src: url,
                width: $c5ab38ff0f87742b$var$ICON_SIZE[variant],
                height: $c5ab38ff0f87742b$var$ICON_SIZE[variant],
                fallback: $c5ab38ff0f87742b$var$_temp,
                role: "presentation"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "currentColor"
        });
        $[0] = iconUrls;
        $[1] = testId;
        $[2] = tilted;
        $[3] = variant;
        $[4] = T0;
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
    } else {
        T0 = $[4];
        t4 = $[5];
        t5 = $[6];
        t6 = $[7];
    }
    let t7;
    if ($[8] !== T0 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t4,
            testId: t5
        }, t6);
        $[8] = T0;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
};
function $c5ab38ff0f87742b$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}


















var $3uVVG = parcelRequire("3uVVG");
































var $f5Ulo = parcelRequire("f5Ulo");

var $31a1536cc16f9128$exports = {};
$31a1536cc16f9128$exports = new URL("connect-arrow.cec87b81.svg", import.meta.url).toString();



const $5992b073ef8023fa$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "side-navigation.space-navigation.third-party-auth.modal.title",
        defaultMessage: "Connect apps for more suggestions"
    },
    description: {
        id: "side-navigation.space-navigation.third-party-auth.modal.description",
        defaultMessage: "Connect at least one app to see curated suggestions here."
    },
    loom: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.loom",
        defaultMessage: "Loom"
    },
    loomDescription: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.loom.description",
        defaultMessage: "Surface videos, recordings and transcripts"
    },
    microsoftTeams: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.microsoft-teams",
        defaultMessage: "Microsoft Office"
    },
    microsoftTeamsDescription: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.microsoft-teams.description",
        defaultMessage: "Bring in documents, presentations and files"
    },
    googleDrive: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.google-drive",
        defaultMessage: "Google Drive"
    },
    googleDriveDescription: {
        id: "side-navigation.space-navigation.third-party-auth.modal.option.google-drive.description",
        defaultMessage: "Surface docs, sheets, slides and folders"
    },
    connect: {
        id: "side-navigation.space-navigation.third-party-auth.modal.connect",
        defaultMessage: "Connect"
    },
    untitled: {
        id: "side-navigation.space-navigation.third-party-auth.modal.preview.untitled",
        defaultMessage: "Untitled"
    },
    spaceAvatarAlt: {
        id: "side-navigation.space-navigation.third-party-auth.modal.preview.space-avatar-alt",
        defaultMessage: "Avatar for {spaceName}"
    }
});
const $5992b073ef8023fa$var$OPTION_CONFIG = {
    [(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).LOOM]: {
        icon: (0, $9f5abb833c441bee$export$defe15004d994007)[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).LOOM],
        labelMessage: $5992b073ef8023fa$var$i18n.loom,
        descriptionMessage: $5992b073ef8023fa$var$i18n.loomDescription
    },
    [(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS]: {
        icon: (0, $9f5abb833c441bee$export$defe15004d994007)[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS],
        labelMessage: $5992b073ef8023fa$var$i18n.microsoftTeams,
        descriptionMessage: $5992b073ef8023fa$var$i18n.microsoftTeamsDescription
    },
    [(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).GOOGLE_DRIVE]: {
        icon: (0, $9f5abb833c441bee$export$defe15004d994007)[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).GOOGLE_DRIVE],
        labelMessage: $5992b073ef8023fa$var$i18n.googleDrive,
        descriptionMessage: $5992b073ef8023fa$var$i18n.googleDriveDescription
    }
};
const $5992b073ef8023fa$var$ILLUSTRATION_FLOATING_ICONS = [
    (0, $9f5abb833c441bee$export$defe15004d994007)[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS],
    (0, $9f5abb833c441bee$export$defe15004d994007)[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).GOOGLE_DRIVE],
    (0, $9f5abb833c441bee$export$defe15004d994007)[(0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).LOOM]
];
const $5992b073ef8023fa$var$ILLUSTRATION_OVERLAY_ROWS = (0, $9f5abb833c441bee$export$51b10001420b4ba3).slice(0, 6);
const $5992b073ef8023fa$var$styles = {
    layout: "_2rkopb1k _1reo15vq _18m915vq _4t3i1oh5",
    leftPanel: "_zulp1ejb _1reo15vq _18m915vq _1rjc1jfw _18zrxy5q _16jlkb7n _i0dl1ssb _1e0c1txw _2lx21bp4",
    optionRow: "_zulppxbi _2rko1mok _1rjcpxbi _18zrpxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o",
    optionIcon: "_1bsb1tcg _4t3i1tcg _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o",
    optionLabel: "_16jlkb7n",
    rightPanel: "_1reo15vq _18m915vq _16jlkb7n _i0dl1ssb _kqswh2mm _bfhk1ymo _5fbcpb1k _1einpb1k",
    closeButtonWrapper: "_154iu2gc _1ltvu2gc",
    container: "_1reoewfl _18m9ewfl _kqswstnw _154i1epz _1ltv1epz _1xi2ze3t _94n5ze3t _bfhkvuon _1s1gpb1k",
    spaceHeader: "_zulpu2gc _1rjcv47k _18zr1ejb _bfhk1j9a _1doce4h9 _1il9nqa1 _1o3i1l7x _1s1gpb1k _4cvr1h6o _1o9zidpf",
    spaceAvatarWrapper: "_2rko1qi0 _1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _1o9zidpf",
    spaceHeaderTitle: "_1ul9idpf _16jlkb7n",
    previewPanelContent: "_85i5pxbi",
    previewCard: "_1yt4utpp _bfhk1j9a",
    previewFoldersList: "_zulpu2gc _1e0c1txw _2lx21bp4",
    previewRow2Stack: "_kqswh2mm _1bsb1osq _1ul9idpf",
    previewIllustrationTrackOverlay: "_zulpv77o _kqswstnw _rjxp145y _12l2u2gc _154i1ssb _t9ec1i34 _1pbyb4wl _1e0c1txw _2lx2vrvc _4cvr1h6o _lcxvglyw",
    previewListAlignedWithPlaceholders: "_18zr1b66 _1bsb1osq _kqswh2mm _1pbykb7n",
    previewPlaceholderSection: "_18zr1b66 _1rjcu2gc _1e0c1txw _2lx21bp4",
    previewPlaceholderRow: "_1rjcu2gc _1e0c1txw _4cvr1h6o",
    previewPlaceholderDot: "_2rko12b0 _1bsb19bv _4t3i19bv _bfhki8nm _1o9zidpf",
    previewPlaceholderBarLong: "_2rko12b0 _4t3iftgi _1bsb1n8h _bfhki8nm",
    previewPlaceholderBarFull: "_2rko12b0 _4t3iftgi _1bsb1mxx _bfhki8nm",
    previewGroupsSection: "_zulpu2gc _2rko1qi0 _1yt41b66 _189edkaa _1dqonqa1 _1h6d1ymo _1e0c1txw _2lx21bp4 _1bsb1osq _16qssmn1",
    illustrationTrack: "_zulpv77o _1e0c1txw _2lx2vrvc _4cvr1h6o _1o9zidpf",
    connectArrowWrap: "_1o9zidpf _1bsbvbgk _1e0c1txw _4cvr1h6o _1bah1y6m",
    connectArrowIllustration: "_1e0c1ule _1bsb1osq _4t3i1wug _c71l8vuz _5ral1f51 _rsuf2bpp",
    floatingIconsColumn: "_zulpu2gc _1e0c1txw _2lx21bp4 _4cvr1y6m _1o9zidpf",
    floatingIconStagger0: "_ahbqutpp",
    floatingIconStagger1: "_ahbq196n",
    floatingIconStagger2: "_ahbqutpp",
    previewIllustrationFolderHeader: "_zulpu2gc _2rko12b0 _18zrutpp _1rjc12x7 _1e0c1txw _4cvr1h6o _1bah1yb4 _kqswh2mm",
    previewIllustrationFolderTitleRow: "_zulpu2gc _1e0c1txw _4cvr1h6o _1ul9idpf _16jlkb7n",
    previewIllustrationFolderTitleBar: "_2rko12b0 _4t3iftgi _16jlkb7n _1ul9idpf _bfhki8nm",
    illustrationOverlayRow: "_zulpu2gc _1rjc1b66 _1e0c1txw _4cvr1h6o _1ul9idpf _1bsb1osq _bozgxy5q _y4ti12x7",
    illustrationIconSlot: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    illustrationSkeletonBar: "_2rko12b0 _4t3iftgi _16jlkb7n _1ul9idpf _bfhki8nm",
    floatingIconTile: "_2rko1qi0 _1bsb1ylp _4t3i1ylp _bfhkvuon _1e0c1txw _4cvr1h6o _1bah1h6o _16qst7xp"
};
const $5992b073ef8023fa$var$FLOATING_ICON_STAGGER = [
    $5992b073ef8023fa$var$styles.floatingIconStagger0,
    $5992b073ef8023fa$var$styles.floatingIconStagger1,
    $5992b073ef8023fa$var$styles.floatingIconStagger2
];
const $5992b073ef8023fa$var$AuthOptionRow = (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { option: option, onConnect: onConnect } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { icon: icon, labelMessage: labelMessage, descriptionMessage: descriptionMessage } = $5992b073ef8023fa$var$OPTION_CONFIG[option];
    let t1;
    if ($[0] !== intl || $[1] !== labelMessage) {
        t1 = intl.formatMessage(labelMessage);
        $[0] = intl;
        $[1] = labelMessage;
        $[2] = t1;
    } else t1 = $[2];
    const label = t1;
    let t2;
    if ($[3] !== descriptionMessage || $[4] !== intl) {
        t2 = intl.formatMessage(descriptionMessage);
        $[3] = descriptionMessage;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== icon) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.optionIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: icon,
            alt: "",
            width: 24,
            height: 24
        }));
        $[6] = icon;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== label) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, label);
        $[8] = label;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== description) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, description);
        $[10] = description;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t4 || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.optionLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, t4, t5));
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== onConnect || $[16] !== option) {
        t7 = ()=>onConnect?.(option);
        $[15] = onConnect;
        $[16] = option;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== intl) {
        t8 = intl.formatMessage($5992b073ef8023fa$var$i18n.connect);
        $[18] = intl;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== t7 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "default",
            onClick: t7
        }, t8);
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== t3 || $[24] !== t6 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.optionRow,
            role: "listitem"
        }, t3, t6, t9);
        $[23] = t3;
        $[24] = t6;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    return t10;
};
const $5992b073ef8023fa$var$ModalLeftPanel = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { unauthenticatedServices: unauthenticatedServices } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const loomCrossJoinUrl = (0, $f5Ulo.useLoomCrossJoinUrl)();
    let t1;
    if ($[0] !== loomCrossJoinUrl || $[1] !== unauthenticatedServices) {
        t1 = async (option)=>{
            bb2: switch(option){
                case (0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).LOOM:
                    window.open(loomCrossJoinUrl, "_blank", "noreferrer");
                    break bb2;
                case (0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).MICROSOFT_TEAMS:
                case (0, $9f5abb833c441bee$export$f0c7a43b2eefe22f).GOOGLE_DRIVE:
                    {
                        const authUrl = unauthenticatedServices[option]?.outboundAuthUrl;
                        if (authUrl) await (0, $3uVVG.auth)(authUrl);
                        break bb2;
                    }
                default:
            }
        };
        $[0] = loomCrossJoinUrl;
        $[1] = unauthenticatedServices;
        $[2] = t1;
    } else t1 = $[2];
    const handleConnect = t1;
    let t2;
    if ($[3] !== intl) {
        t2 = intl.formatMessage($5992b073ef8023fa$var$i18n.title);
        $[3] = intl;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "medium"
        }, t2);
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== intl) {
        t4 = intl.formatMessage($5992b073ef8023fa$var$i18n.description);
        $[7] = intl;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, t4);
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200"
        }, t3, t5);
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== unauthenticatedServices) {
        t7 = Object.keys(unauthenticatedServices);
        $[14] = unauthenticatedServices;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== handleConnect || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150",
            role: "list"
        }, t7.map((service)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5992b073ef8023fa$var$AuthOptionRow, {
                key: service,
                option: service,
                onConnect: handleConnect
            })));
        $[16] = handleConnect;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t6 || $[20] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.leftPanel,
            testId: "third-party-auth-modal-left-panel"
        }, t6, t8);
        $[19] = t6;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
};
const $5992b073ef8023fa$var$ModalRightPanel = (t0)=>{
    const $ = (0, $frIzR.c)(32);
    const { spaceName: spaceName, iconPath: iconPath } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let resolvedSpaceName;
    let t1;
    if ($[0] !== intl || $[1] !== spaceName) {
        resolvedSpaceName = spaceName || intl.formatMessage($5992b073ef8023fa$var$i18n.untitled);
        t1 = intl.formatMessage($5992b073ef8023fa$var$i18n.spaceAvatarAlt, {
            spaceName: resolvedSpaceName
        });
        $[0] = intl;
        $[1] = spaceName;
        $[2] = resolvedSpaceName;
        $[3] = t1;
    } else {
        resolvedSpaceName = $[2];
        t1 = $[3];
    }
    const avatarAlt = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.closeButtonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }));
        $[4] = t2;
    } else t2 = $[4];
    const t3 = iconPath || "";
    let t4;
    if ($[5] !== avatarAlt) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: avatarAlt
            });
        $[5] = avatarAlt;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== avatarAlt || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.spaceAvatarWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: t3,
            width: "24",
            height: "24",
            alt: avatarAlt,
            fallback: t4
        }));
        $[7] = avatarAlt;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== resolvedSpaceName) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.spaceHeaderTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, resolvedSpaceName));
        $[11] = resolvedSpaceName;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t5 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.spaceHeader
        }, t5, t6);
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderSection,
            testId: "third-party-auth-modal-preview-placeholder-top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarLong
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarFull
        })));
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.floatingIconsColumn
        }, $5992b073ef8023fa$var$ILLUSTRATION_FLOATING_ICONS.map($5992b073ef8023fa$var$_temp));
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewIllustrationTrackOverlay,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.illustrationTrack
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.connectArrowWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($31a1536cc16f9128$exports))),
            alt: "",
            "aria-hidden": "true",
            className: (0, $gMc0m.default)([
                $5992b073ef8023fa$var$styles.connectArrowIllustration
            ])
        }))));
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.previewIllustrationFolderHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.previewIllustrationFolderTitleRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
            label: "",
            color: "var(--ds-icon-selected, #1868DB)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewIllustrationFolderTitleBar
        })));
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewRow2Stack
        }, t10, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewListAlignedWithPlaceholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewGroupsSection,
            testId: "third-party-auth-modal-preview-overlay"
        }, t11, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.075"
        }, $5992b073ef8023fa$var$ILLUSTRATION_OVERLAY_ROWS.map($5992b073ef8023fa$var$_temp2)))));
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    let t14;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarLong
        }));
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarFull
        });
        $[21] = t13;
        $[22] = t14;
    } else {
        t13 = $[21];
        t14 = $[22];
    }
    let t15;
    let t16;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarLong
        }));
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarFull
        });
        $[23] = t15;
        $[24] = t16;
    } else {
        t15 = $[23];
        t16 = $[24];
    }
    let t17;
    let t18;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarLong
        }));
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarFull
        });
        $[25] = t17;
        $[26] = t18;
    } else {
        t17 = $[25];
        t18 = $[26];
    }
    let t19;
    let t20;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarLong
        }));
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarFull
        });
        $[27] = t19;
        $[28] = t20;
    } else {
        t19 = $[27];
        t20 = $[28];
    }
    let t21;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPanelContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewCard
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100",
            xcss: $5992b073ef8023fa$var$styles.previewFoldersList
        }, t8, t12, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderSection,
            testId: "third-party-auth-modal-preview-placeholder-bottom"
        }, t13, t14, t15, t16, t17, t18, t19, t20, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarLong
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.previewPlaceholderBarFull
        }))))));
        $[29] = t21;
    } else t21 = $[29];
    let t22;
    if ($[30] !== t7) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.rightPanel,
            testId: "third-party-auth-modal-right-panel"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5992b073ef8023fa$var$styles.container
        }, t7, t21));
        $[30] = t7;
        $[31] = t22;
    } else t22 = $[31];
    return t22;
};
const $5992b073ef8023fa$export$adba184288a85068 = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { unauthenticatedServices: unauthenticatedServices, onClose: onClose, spaceName: spaceName, iconPath: iconPath } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== unauthenticatedServices) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5992b073ef8023fa$var$ModalLeftPanel, {
            unauthenticatedServices: unauthenticatedServices
        });
        $[0] = unauthenticatedServices;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== iconPath || $[3] !== spaceName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5992b073ef8023fa$var$ModalRightPanel, {
            spaceName: spaceName,
            iconPath: iconPath
        });
        $[2] = iconPath;
        $[3] = spaceName;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5992b073ef8023fa$var$styles.layout
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== Modal || $[9] !== onClose || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            onClose: onClose,
            width: "x-large"
        }, t3);
        $[8] = Modal;
        $[9] = onClose;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
};
function $5992b073ef8023fa$var$_temp(src, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        key: src,
        xcss: (0, $1Whri.cx)($5992b073ef8023fa$var$styles.floatingIconTile, $5992b073ef8023fa$var$FLOATING_ICON_STAGGER[index])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src,
        alt: "",
        width: 24,
        height: 24
    }));
}
function $5992b073ef8023fa$var$_temp2(t0) {
    const { iconUrl: iconUrl, productKey: productKey } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        key: productKey,
        xcss: $5992b073ef8023fa$var$styles.illustrationOverlayRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $5992b073ef8023fa$var$styles.illustrationIconSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: iconUrl,
        alt: "",
        width: 16,
        height: 16
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $5992b073ef8023fa$var$styles.illustrationSkeletonBar
    }));
}



const $da63555f5ab7e779$var$i18n = (0, $aXWIB.defineMessages)({
    cardTitle: {
        id: "side-navigation.review-content-suggestions-modal.connect-apps-card.title",
        defaultMessage: "Connect apps for more suggestions"
    },
    connectApps: {
        id: "side-navigation.review-content-suggestions-modal.connect-apps-card.button",
        defaultMessage: "Connect apps"
    },
    dismiss: {
        id: "side-navigation.review-content-suggestions-modal.connect-apps-card.dismiss",
        defaultMessage: "Dismiss connect apps suggestion"
    }
});
const $da63555f5ab7e779$var$styles = {
    card: "_2rko1mok _zulppxbi _1rjcpxbi _18zrpxbi _bfhki8nm _1e0c1txw _2lx21bp4 _1o9zidpf",
    headerRow: "_zulpu2gc _1e0c1txw _4cvr1y6m _1bah1yb4",
    dismissButton: "_1yt41b66 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk1j28 _irr31j28"
};
const $da63555f5ab7e779$export$5c6f32e304ed3e96 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { unauthenticatedServices: unauthenticatedServices, onThirdPartyAuthRefetch: onThirdPartyAuthRefetch, spaceName: spaceName, iconPath: iconPath } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false);
    const [isAuthModalOpen, setIsAuthModalOpen] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== unauthenticatedServices) {
        t1 = Object.keys(unauthenticatedServices).map($da63555f5ab7e779$var$_temp);
        $[0] = unauthenticatedServices;
        $[1] = t1;
    } else t1 = $[1];
    const iconUrls = t1;
    let t2;
    let t3;
    if ($[2] !== isAuthModalOpen || $[3] !== unauthenticatedServices) {
        t2 = ()=>{
            if (Object.keys(unauthenticatedServices).length === 0 && isAuthModalOpen) setIsAuthModalOpen(false);
        };
        t3 = [
            unauthenticatedServices,
            isAuthModalOpen
        ];
        $[2] = isAuthModalOpen;
        $[3] = unauthenticatedServices;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[6] !== onThirdPartyAuthRefetch) {
        t4 = ()=>{
            setIsAuthModalOpen(false);
            onThirdPartyAuthRefetch();
        };
        $[6] = onThirdPartyAuthRefetch;
        $[7] = t4;
    } else t4 = $[7];
    const handleAuthModalClose = t4;
    if (Object.keys(unauthenticatedServices).length === 0) return null;
    let t5;
    if ($[8] !== iconUrls || $[9] !== intl || $[10] !== isDismissed) {
        t5 = !isDismissed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $da63555f5ab7e779$var$styles.card,
            testId: "review-content-suggestions-connect-apps-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $da63555f5ab7e779$var$styles.headerRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            iconUrls: iconUrls,
            variant: "large",
            tilted: true,
            testId: "review-content-suggestions-connect-apps-icons"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $da63555f5ab7e779$var$styles.dismissButton,
            onClick: ()=>setIsDismissed(true),
            "aria-label": intl.formatMessage($da63555f5ab7e779$var$i18n.dismiss)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: ""
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, intl.formatMessage($da63555f5ab7e779$var$i18n.cardTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "default",
            onClick: ()=>setIsAuthModalOpen(true)
        }, intl.formatMessage($da63555f5ab7e779$var$i18n.connectApps)))) : null;
        $[8] = iconUrls;
        $[9] = intl;
        $[10] = isDismissed;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== handleAuthModalClose || $[13] !== iconPath || $[14] !== isAuthModalOpen || $[15] !== spaceName || $[16] !== unauthenticatedServices) {
        t6 = isAuthModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5992b073ef8023fa$export$adba184288a85068), {
            unauthenticatedServices: unauthenticatedServices,
            onClose: handleAuthModalClose,
            spaceName: spaceName,
            iconPath: iconPath
        });
        $[12] = handleAuthModalClose;
        $[13] = iconPath;
        $[14] = isAuthModalOpen;
        $[15] = spaceName;
        $[16] = unauthenticatedServices;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t6);
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== t5 || $[21] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t7);
        $[20] = t5;
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
function $da63555f5ab7e779$var$_temp(service) {
    return (0, $9f5abb833c441bee$export$defe15004d994007)[service];
}




















var $u9agA = parcelRequire("u9agA");












var $lGgRw = parcelRequire("lGgRw");


var $bCECL = parcelRequire("bCECL");


var $4M98y = parcelRequire("4M98y");




/**
 * @generated SignedSource<<55e3b6bd911631caed95d5747e1febfc>>
 * @relayHash 7c0e4d8486e54ba6e102ec5009505b19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f
const $ffebeb9f14c82074$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
    }, v2 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ], v3 = [
        {
            "alias": "pageContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "folderContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "folder"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "whiteboardContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "databaseContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "database"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "embedContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "embed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTitlesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTitlesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7c0e4d8486e54ba6e102ec5009505b19",
            "id": "3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f",
            "metadata": {},
            "name": "useContentTitlesQuery",
            "operationKind": "query",
            "text": "query useContentTitlesQuery($ids:[ID!]!){pageContent:content(ids:$ids,type:\"page\"){nodes{id,title}},folderContent:content(ids:$ids,type:\"folder\"){nodes{id,title}},whiteboardContent:content(ids:$ids,type:\"whiteboard\"){nodes{id,title}},databaseContent:content(ids:$ids,type:\"database\"){nodes{id,title}},embedContent:content(ids:$ids,type:\"embed\"){nodes{id,title}}}"
        }
    };
}();
$ffebeb9f14c82074$var$node.hash = "503b371610f42e1634360824bac2cefe";
var $ffebeb9f14c82074$export$2e2bcd8739ae039 = $ffebeb9f14c82074$var$node;





const $d765c8713688ab6e$var$ContentTitlesQuery = (0, $ffebeb9f14c82074$export$2e2bcd8739ae039);
const $d765c8713688ab6e$export$7610585fadab893e = (contentIds)=>{
    const $ = (0, $frIzR.c)(23);
    let t0;
    if ($[0] !== contentIds) {
        t0 = new Set(contentIds);
        $[0] = contentIds;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = [
            ...t0
        ].filter(Boolean);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const unique = t1;
    const ids = unique;
    let t2;
    if ($[4] !== ids) {
        t2 = {
            ids: ids
        };
        $[4] = ids;
        $[5] = t2;
    } else t2 = $[5];
    const t3 = ids.length === 0;
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($d765c8713688ab6e$var$ContentTitlesQuery, t4);
    let metaMap;
    let titlesMap;
    if ($[9] !== data?.databaseContent || $[10] !== data?.embedContent || $[11] !== data?.folderContent || $[12] !== data?.pageContent || $[13] !== data?.whiteboardContent) {
        titlesMap = new Map();
        metaMap = new Map();
        const typedGroups = [
            {
                nodes: data?.pageContent ?? null,
                type: "page"
            },
            {
                nodes: data?.folderContent ?? null,
                type: "folder"
            },
            {
                nodes: data?.whiteboardContent ?? null,
                type: "whiteboard"
            },
            {
                nodes: data?.databaseContent ?? null,
                type: "database"
            },
            {
                nodes: data?.embedContent ?? null,
                type: "embed"
            }
        ];
        for (const { nodes: nodes, type: type } of typedGroups){
            for (const node of nodes?.nodes ?? [])if (node?.id != null) {
                const title = node.title ?? "";
                titlesMap.set(node.id, title);
                metaMap.set(node.id, {
                    title: title,
                    type: type
                });
            }
        }
        $[9] = data?.databaseContent;
        $[10] = data?.embedContent;
        $[11] = data?.folderContent;
        $[12] = data?.pageContent;
        $[13] = data?.whiteboardContent;
        $[14] = metaMap;
        $[15] = titlesMap;
    } else {
        metaMap = $[14];
        titlesMap = $[15];
    }
    let t5;
    if ($[16] !== metaMap || $[17] !== titlesMap) {
        t5 = {
            titlesByContentId: titlesMap,
            contentMetaById: metaMap
        };
        $[16] = metaMap;
        $[17] = titlesMap;
        $[18] = t5;
    } else t5 = $[18];
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById } = t5;
    const isLoading = ids.length > 0 && loading;
    let t6;
    if ($[19] !== contentMetaById || $[20] !== isLoading || $[21] !== titlesByContentId) {
        t6 = {
            titlesByContentId: titlesByContentId,
            contentMetaById: contentMetaById,
            isLoading: isLoading
        };
        $[19] = contentMetaById;
        $[20] = isLoading;
        $[21] = titlesByContentId;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};


const $4835e3f9f2ab2337$var$styles = {
    movePopupContent: "_1yt4utpp _1bsb1178",
    searchHint: "_1yt4u2gc _syaz1rpy",
    moveButtonOpen: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
    fallbackSectionLabel: "_1yt41b66",
    fallbackParentRow: "_zulp12x7 _1yt4u2gc _2rko1mok _1e0c1txw _4cvr1h6o _1bsb1osq _bfhk1j28 _irr31dpa _1di6fcek",
    fallbackParentTitle: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf _y3gnv2br",
    fallbackParentIcon: "_1o9zidpf",
    spinnerContainer: "_1yt4utpp _1e0c1txw _1bah1h6o"
};
const $4835e3f9f2ab2337$var$i18n = (0, $aXWIB.defineMessages)({
    moveButton: {
        id: "side-navigation.review-content-suggestions-modal.move-button",
        defaultMessage: "Move"
    },
    moveToTitle: {
        id: "side-navigation.review-content-suggestions-modal.move-to-title",
        defaultMessage: "Move to"
    },
    searchHint: {
        id: "side-navigation.review-content-suggestions-modal.move-search-hint",
        defaultMessage: "Search"
    },
    suggested: {
        id: "side-navigation.review-content-suggestions-modal.move-suggested",
        defaultMessage: "Suggested"
    }
});
const $4835e3f9f2ab2337$var$FallbackParentRow = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { parentId: parentId, meta: meta, title: title, onMoveItemClick: onMoveItemClick } = t0;
    let t1;
    if ($[0] !== onMoveItemClick || $[1] !== parentId) {
        t1 = ()=>{
            onMoveItemClick(parentId);
        };
        $[0] = onMoveItemClick;
        $[1] = parentId;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const t2 = `suggestion-move-fallback-parent-${parentId}`;
    const t3 = meta?.type ?? "page";
    let t4;
    if ($[3] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            xcss: $4835e3f9f2ab2337$var$styles.fallbackParentIcon,
            alignBlock: "center"
        }, /*#__PURE__*/ $42omo.createElement((0, $bCECL.ContentIcon), {
            type: t3
        }));
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = meta?.title ?? title;
    let t6;
    if ($[5] !== t5) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $4835e3f9f2ab2337$var$styles.fallbackParentTitle
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, t5));
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== handleClick || $[8] !== parentId || $[9] !== t2 || $[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ $42omo.createElement((0, $2W0qg.default), {
            key: parentId,
            xcss: $4835e3f9f2ab2337$var$styles.fallbackParentRow,
            onClick: handleClick,
            testId: t2
        }, t4, t6);
        $[7] = handleClick;
        $[8] = parentId;
        $[9] = t2;
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
};
const $4835e3f9f2ab2337$export$de484dae570b7c31 = (t0)=>{
    const $ = (0, $frIzR.c)(45);
    const { suggestionId: suggestionId, spaceKey: spaceKey, isOpen: isOpen, onOpenChange: onOpenChange, onMoveSuggestion: onMoveSuggestion, fallbackParents: fallbackParents, currentParentId: currentParentId } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== fallbackParents) {
        t1 = fallbackParents ?? [];
        $[0] = fallbackParents;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== currentParentId || $[3] !== t1) {
        let t3;
        if ($[5] !== currentParentId) {
            t3 = (id)=>id !== currentParentId;
            $[5] = currentParentId;
            $[6] = t3;
        } else t3 = $[6];
        t2 = t1.filter(t3);
        $[2] = currentParentId;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const filteredFallbackParents = t2;
    let t3;
    if ($[7] !== filteredFallbackParents) {
        t3 = filteredFallbackParents.map(String);
        $[7] = filteredFallbackParents;
        $[8] = t3;
    } else t3 = $[8];
    const fallbackParentIdStrings = t3;
    let t4;
    if ($[9] !== fallbackParentIdStrings || $[10] !== isOpen) {
        t4 = isOpen ? fallbackParentIdStrings : [];
        $[9] = fallbackParentIdStrings;
        $[10] = isOpen;
        $[11] = t4;
    } else t4 = $[11];
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById, isLoading: isLoading } = (0, $d765c8713688ab6e$export$7610585fadab893e)(t4);
    let t5;
    if ($[12] !== onMoveSuggestion || $[13] !== onOpenChange || $[14] !== suggestionId) {
        t5 = (idOrAri)=>{
            const str = String(idOrAri);
            const rawId = str.includes("/") ? str.split("/").pop() ?? str : str;
            const numId = Number(rawId);
            if (!rawId || isNaN(numId)) return;
            onMoveSuggestion(suggestionId, numId);
            onOpenChange(false);
        };
        $[12] = onMoveSuggestion;
        $[13] = onOpenChange;
        $[14] = suggestionId;
        $[15] = t5;
    } else t5 = $[15];
    const handleMoveItemClick = t5;
    let t6;
    if ($[16] !== contentMetaById || $[17] !== filteredFallbackParents || $[18] !== formatMessage || $[19] !== handleMoveItemClick || $[20] !== isLoading || $[21] !== titlesByContentId) {
        t6 = ()=>{
            if (isLoading) return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: $4835e3f9f2ab2337$var$styles.spinnerContainer
            }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
                size: "small"
            }));
            const accessibleParents = filteredFallbackParents.filter((parentId)=>contentMetaById.has(String(parentId)));
            if (accessibleParents.length === 0) return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: $4835e3f9f2ab2337$var$styles.searchHint
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
                color: "color.text.subtlest"
            }, formatMessage($4835e3f9f2ab2337$var$i18n.searchHint)));
            return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: $4835e3f9f2ab2337$var$styles.fallbackSectionLabel
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest",
                weight: "semibold"
            }, formatMessage($4835e3f9f2ab2337$var$i18n.suggested))), accessibleParents.map((parentId_0)=>/*#__PURE__*/ $42omo.createElement($4835e3f9f2ab2337$var$FallbackParentRow, {
                    key: parentId_0,
                    parentId: parentId_0,
                    meta: contentMetaById.get(String(parentId_0)),
                    title: titlesByContentId.get(String(parentId_0)),
                    onMoveItemClick: handleMoveItemClick
                })));
        };
        $[16] = contentMetaById;
        $[17] = filteredFallbackParents;
        $[18] = formatMessage;
        $[19] = handleMoveItemClick;
        $[20] = isLoading;
        $[21] = titlesByContentId;
        $[22] = t6;
    } else t6 = $[22];
    const renderFallbackParentList = t6;
    let t7;
    if ($[23] !== filteredFallbackParents.length || $[24] !== formatMessage || $[25] !== isOpen || $[26] !== renderFallbackParentList) {
        t7 = isOpen && filteredFallbackParents.length > 0 ? renderFallbackParentList() : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $4835e3f9f2ab2337$var$styles.searchHint
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, formatMessage($4835e3f9f2ab2337$var$i18n.searchHint)));
        $[23] = filteredFallbackParents.length;
        $[24] = formatMessage;
        $[25] = isOpen;
        $[26] = renderFallbackParentList;
        $[27] = t7;
    } else t7 = $[27];
    const fallbackParentRows = t7;
    let t8;
    if ($[28] !== onOpenChange) {
        t8 = ()=>onOpenChange(false);
        $[28] = onOpenChange;
        $[29] = t8;
    } else t8 = $[29];
    let t9;
    if ($[30] !== fallbackParentRows || $[31] !== formatMessage || $[32] !== handleMoveItemClick || $[33] !== spaceKey) {
        t9 = ()=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: $4835e3f9f2ab2337$var$styles.movePopupContent
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
                weight: "bold"
            }, formatMessage($4835e3f9f2ab2337$var$i18n.moveToTitle)), /*#__PURE__*/ $42omo.createElement((0, $4M98y.ContentTreeSearchBase), {
                spaceKey: spaceKey ?? "",
                onItemClick: handleMoveItemClick,
                contentId: "",
                placeholder: formatMessage($4835e3f9f2ab2337$var$i18n.searchHint)
            }, fallbackParentRows));
        $[30] = fallbackParentRows;
        $[31] = formatMessage;
        $[32] = handleMoveItemClick;
        $[33] = spaceKey;
        $[34] = t9;
    } else t9 = $[34];
    let t10;
    if ($[35] !== formatMessage || $[36] !== isOpen || $[37] !== onOpenChange || $[38] !== suggestionId) {
        t10 = (triggerProps)=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)(isOpen && $4835e3f9f2ab2337$var$styles.moveButtonOpen)
            }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                onClick: ()=>onOpenChange(!isOpen),
                testId: `review-content-suggestion-move-button-${suggestionId}`
            }, formatMessage($4835e3f9f2ab2337$var$i18n.moveButton)));
        $[35] = formatMessage;
        $[36] = isOpen;
        $[37] = onOpenChange;
        $[38] = suggestionId;
        $[39] = t10;
    } else t10 = $[39];
    let t11;
    if ($[40] !== isOpen || $[41] !== t10 || $[42] !== t8 || $[43] !== t9) {
        t11 = /*#__PURE__*/ $42omo.createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: t8,
            placement: "bottom-start",
            zIndex: 800,
            content: t9,
            trigger: t10
        });
        $[40] = isOpen;
        $[41] = t10;
        $[42] = t8;
        $[43] = t9;
        $[44] = t11;
    } else t11 = $[44];
    return t11;
};












var $imt6g = parcelRequire("imt6g");


var $7yDmn = parcelRequire("7yDmn");







const $5ff49e7a1b080355$var$styles = {
    pressable: "_1rjcutpp _1e0c1txw _4cvr1h6o _1bah1h6o _bozgpxbi _y4tipxbi _bfhk1j28 _1o9zidpf _irr31j28",
    highlightRing: "_2rko1rr0 _1mou196n _195g196n _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _irr3plhp",
    iconWrapper: "_kqswh2mm _1bsb7vkz _4t3i7vkz _1o9zidpf",
    iconLayer: "_v56414mc _kqswstnw _154iidpf _1ltvidpf",
    iconLayerVisible: "_tzy4kb7n _t9ec1h7a",
    iconLayerHidden: "_tzy4idpf _t9ec18p1"
};
const $5ff49e7a1b080355$export$7eb83caae4372066 = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { isSelected: isSelected, onClick: onClick, ariaLabel: ariaLabel } = t0;
    const t1 = isSelected ? $5ff49e7a1b080355$var$styles.iconLayerVisible : $5ff49e7a1b080355$var$styles.iconLayerHidden;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $1Whri.cx)($5ff49e7a1b080355$var$styles.iconLayer, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        });
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t2
        }, t3);
        $[3] = t2;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isSelected ? $5ff49e7a1b080355$var$styles.iconLayerHidden : $5ff49e7a1b080355$var$styles.iconLayerVisible;
    let t6;
    if ($[5] !== t5) {
        t6 = (0, $1Whri.cx)($5ff49e7a1b080355$var$styles.iconLayer, t5);
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t6
        }, t7);
        $[8] = t6;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== t4 || $[11] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5ff49e7a1b080355$var$styles.highlightRing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5ff49e7a1b080355$var$styles.iconWrapper
        }, t4, t8));
        $[10] = t4;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== ariaLabel || $[14] !== onClick || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $5ff49e7a1b080355$var$styles.pressable,
            onClick: onClick,
            "aria-label": ariaLabel
        }, t9);
        $[13] = ariaLabel;
        $[14] = onClick;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
};











const $3b31958c77e1b16d$var$i18n = (0, $aXWIB.defineMessages)({
    successFlagTitle: {
        id: "side-navigation.suggestion-actions.success.title",
        defaultMessage: "{count, plural, one {{count} item added to space} other {{count} items added to space}}"
    },
    successFlagDescription: {
        id: "side-navigation.suggestion-actions.success.description",
        defaultMessage: "Your selected content has been added to this space."
    },
    errorFlagTitle: {
        id: "side-navigation.suggestion-actions.error.title",
        defaultMessage: "Failed to add items to space"
    },
    errorFlagDescription: {
        id: "side-navigation.suggestion-actions.error.description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
const $3b31958c77e1b16d$export$c9239e53ef385494 = ({ spaceKey: spaceKey, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const submitActions = async (allSuggestions, selectedIds)=>{
        if (!spaceKey) return false;
        const actions = allSuggestions.map((s)=>({
                ...s,
                action: selectedIds.has(s.id) ? (0, $9f5abb833c441bee$export$e19cd5f9376f8cee).ACCEPT : (0, $9f5abb833c441bee$export$e19cd5f9376f8cee).REJECT
            }));
        try {
            await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/actions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    actions: actions
                })
            });
            flags?.showSuccessFlag({
                id: 'space-navigation.suggestion-actions.success',
                title: formatMessage($3b31958c77e1b16d$var$i18n.successFlagTitle, {
                    count: selectedIds.size
                }),
                description: formatMessage($3b31958c77e1b16d$var$i18n.successFlagDescription),
                isAutoDismiss: true
            });
            return true;
        } catch  {
            flags?.showErrorFlag({
                id: 'space-navigation.suggestion-actions.error',
                title: formatMessage($3b31958c77e1b16d$var$i18n.errorFlagTitle),
                description: formatMessage($3b31958c77e1b16d$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
            return false;
        }
    };
    return {
        submitActions: submitActions
    };
};
































const $cc28f14084497f84$var$i18n = (0, $aXWIB.defineMessages)({
    hoverCardFallbackDescription: {
        id: "side-navigation.review-content-suggestions-modal.hover-card-fallback-description",
        defaultMessage: "Open this item in a new tab to view it in {product}."
    },
    openHoverCardSuggestion: {
        id: "side-navigation.review-content-suggestions-modal.open-hover-card-suggestion",
        defaultMessage: "Open item"
    },
    productGoogleDocs: {
        id: "side-navigation.review-content-suggestions-modal.product-google-docs.no-translate",
        defaultMessage: "Google Docs"
    },
    productGoogleSheets: {
        id: "side-navigation.review-content-suggestions-modal.product-google-sheets.no-translate",
        defaultMessage: "Google Sheets"
    },
    productGoogleSlides: {
        id: "side-navigation.review-content-suggestions-modal.product-google-slides.no-translate",
        defaultMessage: "Google Slides"
    },
    productGoogleDrive: {
        id: "side-navigation.review-content-suggestions-modal.product-google-drive.no-translate",
        defaultMessage: "Google Drive"
    },
    productLoom: {
        id: "side-navigation.review-content-suggestions-modal.product-loom.no-translate",
        defaultMessage: "Loom"
    },
    productMicrosoftTeams: {
        id: "side-navigation.review-content-suggestions-modal.product-microsoft-teams.no-translate",
        defaultMessage: "Microsoft Teams"
    },
    productLink: {
        id: "side-navigation.review-content-suggestions-modal.product-link",
        defaultMessage: "Link"
    },
    groupHoverCardItemCount: {
        id: "side-navigation.review-content-suggestions-modal.group-hover-card-item-count",
        defaultMessage: "{count, plural, one {# item} other {# items}}"
    }
});
const $cc28f14084497f84$var$PRODUCT_LABEL_MESSAGES = {
    googleDocs: $cc28f14084497f84$var$i18n.productGoogleDocs,
    googleSheets: $cc28f14084497f84$var$i18n.productGoogleSheets,
    googleSlides: $cc28f14084497f84$var$i18n.productGoogleSlides,
    googleDrive: $cc28f14084497f84$var$i18n.productGoogleDrive,
    loom: $cc28f14084497f84$var$i18n.productLoom,
    microsoftTeams: $cc28f14084497f84$var$i18n.productMicrosoftTeams,
    link: $cc28f14084497f84$var$i18n.productLink
};
function $cc28f14084497f84$var$getProductLabelMessage(productKey) {
    return $cc28f14084497f84$var$PRODUCT_LABEL_MESSAGES[productKey];
}
const $cc28f14084497f84$var$styles = {
    hoverCard: "_2rko1mok _1yt4utpp _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsbgx0z _bfhk1j9a _16qs130s",
    hoverCardContent: "_p12f1osq _1ul9idpf",
    hoverCardTitle: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _p12f1osq",
    hoverCardDescription: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _sudp1e54 _syazazsu _1yyjcs5v _p12f1osq",
    hoverCardFooter: "_195g1410 _18zrpxbi _uwhke4h9 _15a5nqa1 _1i531l7x _1q51u2gc _syazazsu",
    hoverCardIcon: "_1bsbdlk8 _4t3idlk8 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf"
};
const $cc28f14084497f84$export$bf0a0c07cf58248c = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { suggestion: suggestion } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let iconUrl;
    let product;
    let t1;
    if ($[0] !== formatMessage || $[1] !== suggestion.description || $[2] !== suggestion.url) {
        const productKey = (0, $9f5abb833c441bee$export$39b141cbf41f04f3)(suggestion.url);
        let t2;
        if ($[6] !== suggestion.url) {
            t2 = (0, $9f5abb833c441bee$export$82cacbc9ddf6b54e)(suggestion.url);
            $[6] = suggestion.url;
            $[7] = t2;
        } else t2 = $[7];
        iconUrl = t2;
        product = formatMessage($cc28f14084497f84$var$getProductLabelMessage(productKey));
        t1 = suggestion.description?.trim() ? suggestion.description : formatMessage($cc28f14084497f84$var$i18n.hoverCardFallbackDescription, {
            product: product
        });
        $[0] = formatMessage;
        $[1] = suggestion.description;
        $[2] = suggestion.url;
        $[3] = iconUrl;
        $[4] = product;
        $[5] = t1;
    } else {
        iconUrl = $[3];
        product = $[4];
        t1 = $[5];
    }
    const description = t1;
    let t2;
    if ($[8] !== iconUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardIcon,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "14",
            height: "14",
            fallback: $cc28f14084497f84$var$_temp,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[8] = iconUrl;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== suggestion.title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025",
            xcss: $cc28f14084497f84$var$styles.hoverCardContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            weight: "medium",
            color: "color.text.accent.blue"
        }, suggestion.title)));
        $[10] = suggestion.title;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== t2 || $[13] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100"
        }, t2, t3);
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== description) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardDescription
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, description));
        $[15] = description;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== iconUrl) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardIcon,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "14",
            height: "14",
            fallback: $cc28f14084497f84$var$_temp2,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[17] = iconUrl;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== product) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, product);
        $[19] = product;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t6 || $[22] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100",
            xcss: $cc28f14084497f84$var$styles.hoverCardFooter
        }, t6, t7);
        $[21] = t6;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t4 || $[25] !== t5 || $[26] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150",
            xcss: $cc28f14084497f84$var$styles.hoverCard,
            testId: "review-content-suggestion-hover-card"
        }, t4, t5, t8);
        $[24] = t4;
        $[25] = t5;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
};
const $cc28f14084497f84$export$89a7edf0c311b93 = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { title: title, itemCount: itemCount } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardIcon,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
            label: "",
            color: "var(--ds-icon-selected, #1868DB)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== title) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $cc28f14084497f84$var$styles.hoverCardTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            weight: "medium",
            color: "color.text.accent.blue"
        }, title));
        $[1] = title;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== formatMessage || $[4] !== itemCount) {
        t3 = formatMessage($cc28f14084497f84$var$i18n.groupHoverCardItemCount, {
            count: itemCount
        });
        $[3] = formatMessage;
        $[4] = itemCount;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150",
            xcss: $cc28f14084497f84$var$styles.hoverCard,
            testId: "review-content-suggestion-group-hover-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025",
            xcss: $cc28f14084497f84$var$styles.hoverCardContent
        }, t2, t4)));
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};
function $cc28f14084497f84$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $cc28f14084497f84$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}


















var $7gpC4 = parcelRequire("7gpC4");








var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");



var $d8eRd = parcelRequire("d8eRd");






var $fVUfS = parcelRequire("fVUfS");






var $9EtP6 = parcelRequire("9EtP6");








const $d20664fd99e4ace3$var$i18n = (0, $aXWIB.defineMessages)({
    modalTitle: {
        id: "side-navigation.suggestion-feedback-modal.title",
        defaultMessage: "Rate suggestion quality"
    },
    part1Header: {
        id: "side-navigation.suggestion-feedback-modal.part1-header",
        defaultMessage: "Part 1: Core Content & Placement"
    },
    part2Header: {
        id: "side-navigation.suggestion-feedback-modal.part2-header",
        defaultMessage: "Part 2: Context & Quality"
    },
    skipLabel: {
        id: "side-navigation.suggestion-feedback-modal.skip-label",
        defaultMessage: "Skip / I do not know"
    },
    submitButton: {
        id: "side-navigation.suggestion-feedback-modal.submit",
        defaultMessage: "Submit"
    },
    cancelButton: {
        id: "side-navigation.suggestion-feedback-modal.cancel",
        defaultMessage: "Cancel"
    },
    topicalRelevanceTitle: {
        id: "side-navigation.suggestion-feedback-modal.topical-relevance.title",
        defaultMessage: "Topical Relevance"
    },
    topicalRelevanceQuestion: {
        id: "side-navigation.suggestion-feedback-modal.topical-relevance.question",
        defaultMessage: "Is the document about the same topic as the space?"
    },
    topicalRelevance3: {
        id: "side-navigation.suggestion-feedback-modal.topical-relevance.3",
        defaultMessage: "Highly Relevant \u2013 Core part of this topic."
    },
    topicalRelevance2: {
        id: "side-navigation.suggestion-feedback-modal.topical-relevance.2",
        defaultMessage: "Related \u2013 Shares the same theme but is tangential."
    },
    topicalRelevance1: {
        id: "side-navigation.suggestion-feedback-modal.topical-relevance.1",
        defaultMessage: "Slightly Related \u2013 Only a small portion fits."
    },
    topicalRelevance0: {
        id: "side-navigation.suggestion-feedback-modal.topical-relevance.0",
        defaultMessage: "Irrelevant \u2013 No logical connection."
    },
    placementTitle: {
        id: "side-navigation.suggestion-feedback-modal.placement.title",
        defaultMessage: "Placement"
    },
    placementQuestion: {
        id: "side-navigation.suggestion-feedback-modal.placement.question",
        defaultMessage: "Is this the right folder suggestion for this content?"
    },
    placement2: {
        id: "side-navigation.suggestion-feedback-modal.placement.2",
        defaultMessage: "Perfect Fit \u2013 Exactly where it belongs."
    },
    placement1: {
        id: "side-navigation.suggestion-feedback-modal.placement.1",
        defaultMessage: "Acceptable \u2013 Not the best spot, but makes sense."
    },
    placement0: {
        id: "side-navigation.suggestion-feedback-modal.placement.0",
        defaultMessage: "Incorrect \u2013 Placement is confusing or wrong."
    },
    usefulnessTitle: {
        id: "side-navigation.suggestion-feedback-modal.usefulness.title",
        defaultMessage: "Usefulness"
    },
    usefulnessQuestion: {
        id: "side-navigation.suggestion-feedback-modal.usefulness.question",
        defaultMessage: "Would this doc actually help someone working in this space?"
    },
    usefulness4: {
        id: "side-navigation.suggestion-feedback-modal.usefulness.4",
        defaultMessage: "Essential \u2013 Crucial; the space is incomplete without it."
    },
    usefulness3: {
        id: "side-navigation.suggestion-feedback-modal.usefulness.3",
        defaultMessage: "Helpful \u2013 Adds clear value and saves time."
    },
    usefulness2: {
        id: "side-navigation.suggestion-feedback-modal.usefulness.2",
        defaultMessage: "Neutral \u2013 Belongs there, but doesn't change much."
    },
    usefulness1: {
        id: "side-navigation.suggestion-feedback-modal.usefulness.1",
        defaultMessage: "Not Very Useful \u2013 Low-value or \"fluff.\""
    },
    usefulness0: {
        id: "side-navigation.suggestion-feedback-modal.usefulness.0",
        defaultMessage: "Counter-productive \u2013 Distracting or adds noise."
    },
    redundancyTitle: {
        id: "side-navigation.suggestion-feedback-modal.redundancy.title",
        defaultMessage: "Redundancy (Uniqueness)"
    },
    redundancyQuestion: {
        id: "side-navigation.suggestion-feedback-modal.redundancy.question",
        defaultMessage: "Does the doc add info not already in the space?"
    },
    redundancy3: {
        id: "side-navigation.suggestion-feedback-modal.redundancy.3",
        defaultMessage: "Entirely New \u2013 Information not found elsewhere in the space."
    },
    redundancy2: {
        id: "side-navigation.suggestion-feedback-modal.redundancy.2",
        defaultMessage: "Mostly New \u2013 Some overlap, but provides new insights."
    },
    redundancy1: {
        id: "side-navigation.suggestion-feedback-modal.redundancy.1",
        defaultMessage: "High Overlap \u2013 Repeats most of what is already there."
    },
    redundancy0: {
        id: "side-navigation.suggestion-feedback-modal.redundancy.0",
        defaultMessage: "Redundant \u2013 Information is already present (duplicate/near-duplicate)."
    },
    explainabilityTitle: {
        id: "side-navigation.suggestion-feedback-modal.explainability.title",
        defaultMessage: "Explainability"
    },
    explainabilityQuestion: {
        id: "side-navigation.suggestion-feedback-modal.explainability.question",
        defaultMessage: "Is it clear why this document was recommended for this space?"
    },
    explainability2: {
        id: "side-navigation.suggestion-feedback-modal.explainability.2",
        defaultMessage: "Very Clear \u2013 I immediately see the connection."
    },
    explainability1: {
        id: "side-navigation.suggestion-feedback-modal.explainability.1",
        defaultMessage: "Vaguely Clear \u2013 I can see a possible link, but it's weak."
    },
    explainability0: {
        id: "side-navigation.suggestion-feedback-modal.explainability.0",
        defaultMessage: "Not Clear \u2013 The suggestion feels random or \"black box.\""
    },
    recencyTitle: {
        id: "side-navigation.suggestion-feedback-modal.recency.title",
        defaultMessage: "Recency & Freshness"
    },
    recencyQuestion: {
        id: "side-navigation.suggestion-feedback-modal.recency.question",
        defaultMessage: "How would you characterize the timeliness of this document?"
    },
    recency2: {
        id: "side-navigation.suggestion-feedback-modal.recency.2",
        defaultMessage: "Current/Evergreen \u2013 Information is up-to-date or foundational (always useful)."
    },
    recency1: {
        id: "side-navigation.suggestion-feedback-modal.recency.1",
        defaultMessage: "Historical Reference \u2013 Older but still holds some context or \"lesson learned\" value."
    },
    recency0: {
        id: "side-navigation.suggestion-feedback-modal.recency.0",
        defaultMessage: "Obsolete \u2013 The information is expired, superseded, or no longer true."
    },
    permissionsPrivacyTitle: {
        id: "side-navigation.suggestion-feedback-modal.permissions-privacy.title",
        defaultMessage: "Permissions & Privacy"
    },
    permissionsPrivacyQuestion: {
        id: "side-navigation.suggestion-feedback-modal.permissions-privacy.question",
        defaultMessage: "Does it feel appropriate for this document to be surfaced here?"
    },
    permissionsPrivacy2: {
        id: "side-navigation.suggestion-feedback-modal.permissions-privacy.2",
        defaultMessage: "Appropriate \u2013 Safe for general viewing within the space's context."
    },
    permissionsPrivacy1: {
        id: "side-navigation.suggestion-feedback-modal.permissions-privacy.1",
        defaultMessage: "Questionable \u2013 Might contain semi-private info that feels \"odd\" to see."
    },
    permissionsPrivacy0: {
        id: "side-navigation.suggestion-feedback-modal.permissions-privacy.0",
        defaultMessage: "Inappropriate \u2013 Contains sensitive or private data that should not be surfaced."
    },
    additionalCommentsLabel: {
        id: "side-navigation.suggestion-feedback-modal.additional-comments.label",
        defaultMessage: "Additional comments (optional)"
    },
    additionalCommentsPlaceholder: {
        id: "side-navigation.suggestion-feedback-modal.additional-comments.placeholder",
        defaultMessage: "Share any other thoughts about this suggestion\u2026"
    }
});
const $d20664fd99e4ace3$var$FEEDBACK_QUESTIONS = [
    {
        key: 'topicalRelevance',
        part: 1,
        title: $d20664fd99e4ace3$var$i18n.topicalRelevanceTitle,
        question: $d20664fd99e4ace3$var$i18n.topicalRelevanceQuestion,
        options: [
            {
                value: 3,
                label: $d20664fd99e4ace3$var$i18n.topicalRelevance3
            },
            {
                value: 2,
                label: $d20664fd99e4ace3$var$i18n.topicalRelevance2
            },
            {
                value: 1,
                label: $d20664fd99e4ace3$var$i18n.topicalRelevance1
            },
            {
                value: 0,
                label: $d20664fd99e4ace3$var$i18n.topicalRelevance0
            }
        ]
    },
    {
        key: 'placement',
        part: 1,
        title: $d20664fd99e4ace3$var$i18n.placementTitle,
        question: $d20664fd99e4ace3$var$i18n.placementQuestion,
        options: [
            {
                value: 2,
                label: $d20664fd99e4ace3$var$i18n.placement2
            },
            {
                value: 1,
                label: $d20664fd99e4ace3$var$i18n.placement1
            },
            {
                value: 0,
                label: $d20664fd99e4ace3$var$i18n.placement0
            }
        ]
    },
    {
        key: 'usefulness',
        part: 1,
        title: $d20664fd99e4ace3$var$i18n.usefulnessTitle,
        question: $d20664fd99e4ace3$var$i18n.usefulnessQuestion,
        options: [
            {
                value: 4,
                label: $d20664fd99e4ace3$var$i18n.usefulness4
            },
            {
                value: 3,
                label: $d20664fd99e4ace3$var$i18n.usefulness3
            },
            {
                value: 2,
                label: $d20664fd99e4ace3$var$i18n.usefulness2
            },
            {
                value: 1,
                label: $d20664fd99e4ace3$var$i18n.usefulness1
            },
            {
                value: 0,
                label: $d20664fd99e4ace3$var$i18n.usefulness0
            }
        ]
    },
    {
        key: 'redundancy',
        part: 1,
        title: $d20664fd99e4ace3$var$i18n.redundancyTitle,
        question: $d20664fd99e4ace3$var$i18n.redundancyQuestion,
        options: [
            {
                value: 3,
                label: $d20664fd99e4ace3$var$i18n.redundancy3
            },
            {
                value: 2,
                label: $d20664fd99e4ace3$var$i18n.redundancy2
            },
            {
                value: 1,
                label: $d20664fd99e4ace3$var$i18n.redundancy1
            },
            {
                value: 0,
                label: $d20664fd99e4ace3$var$i18n.redundancy0
            }
        ]
    },
    {
        key: 'explainability',
        part: 2,
        title: $d20664fd99e4ace3$var$i18n.explainabilityTitle,
        question: $d20664fd99e4ace3$var$i18n.explainabilityQuestion,
        options: [
            {
                value: 2,
                label: $d20664fd99e4ace3$var$i18n.explainability2
            },
            {
                value: 1,
                label: $d20664fd99e4ace3$var$i18n.explainability1
            },
            {
                value: 0,
                label: $d20664fd99e4ace3$var$i18n.explainability0
            }
        ]
    },
    {
        key: 'recency',
        part: 2,
        title: $d20664fd99e4ace3$var$i18n.recencyTitle,
        question: $d20664fd99e4ace3$var$i18n.recencyQuestion,
        options: [
            {
                value: 2,
                label: $d20664fd99e4ace3$var$i18n.recency2
            },
            {
                value: 1,
                label: $d20664fd99e4ace3$var$i18n.recency1
            },
            {
                value: 0,
                label: $d20664fd99e4ace3$var$i18n.recency0
            }
        ]
    },
    {
        key: 'permissionsPrivacy',
        part: 2,
        title: $d20664fd99e4ace3$var$i18n.permissionsPrivacyTitle,
        question: $d20664fd99e4ace3$var$i18n.permissionsPrivacyQuestion,
        options: [
            {
                value: 2,
                label: $d20664fd99e4ace3$var$i18n.permissionsPrivacy2
            },
            {
                value: 1,
                label: $d20664fd99e4ace3$var$i18n.permissionsPrivacy1
            },
            {
                value: 0,
                label: $d20664fd99e4ace3$var$i18n.permissionsPrivacy0
            }
        ]
    }
];
const $d20664fd99e4ace3$var$styles = {
    partHeader: "_1q51pxbi _85i5u2gc _1doce4h9 _1il9nqa1 _1o3i1l7x _6rthu2gc",
    questionBlock: "_85i5pxbi",
    optionRow: "_zulpu2gc _2rko12b0 _v564ij15 _1rjc12x7 _18zru2gc _189ee4h9 _1dqonqa1 _1h6d1j28 _1e0c1txw _4cvr1h6o _80omtlke _irr3i8nm",
    optionRowSelected: "_1h6dq98m _bfhk15s3 _irr3ufnl",
    optionRowDisabled: "_tzy42wxo _80om13gf _irr31j28",
    radioCircle: "_2rko1rr0 _189ee4h9 _1dqonqa1 _1h6d1ihb _1bsb7vkz _4t3i7vkz _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o",
    radioCircleSelected: "_1h6dq98m _bfhkjmqp",
    radioInnerDot: "_2rko1rr0 _1bsbi2wt _4t3ii2wt _bfhk5w2r",
    skipRow: "_1q511b66",
    additionalCommentsSection: "_1q51pxbi _85i5u2gc",
    modalBody: "_1rjcpxbi"
};
const $d20664fd99e4ace3$var$OptionRow = (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { label: label, value: value, questionKey: questionKey, isSelected: isSelected, isDisabled: isDisabled, onSelect: onSelect } = t0;
    let t1;
    if ($[0] !== isDisabled || $[1] !== onSelect || $[2] !== questionKey || $[3] !== value) {
        t1 = ()=>{
            if (!isDisabled) onSelect(questionKey, value);
        };
        $[0] = isDisabled;
        $[1] = onSelect;
        $[2] = questionKey;
        $[3] = value;
        $[4] = t1;
    } else t1 = $[4];
    const handleClick = t1;
    const t2 = isSelected && $d20664fd99e4ace3$var$styles.optionRowSelected;
    const t3 = isDisabled && $d20664fd99e4ace3$var$styles.optionRowDisabled;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = (0, $1Whri.cx)($d20664fd99e4ace3$var$styles.optionRow, t2, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = isSelected && $d20664fd99e4ace3$var$styles.radioCircleSelected;
    let t6;
    if ($[8] !== t5) {
        t6 = (0, $1Whri.cx)($d20664fd99e4ace3$var$styles.radioCircle, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== isSelected) {
        t7 = isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d20664fd99e4ace3$var$styles.radioInnerDot
        });
        $[10] = isSelected;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t6 || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t6
        }, t7);
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== label) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small"
        }, label);
        $[15] = label;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== handleClick || $[18] !== isDisabled || $[19] !== isSelected || $[20] !== t4 || $[21] !== t8 || $[22] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            role: "radio",
            "aria-checked": isSelected,
            "aria-disabled": isDisabled,
            xcss: t4,
            onClick: handleClick
        }, t8, t9);
        $[17] = handleClick;
        $[18] = isDisabled;
        $[19] = isSelected;
        $[20] = t4;
        $[21] = t8;
        $[22] = t9;
        $[23] = t10;
    } else t10 = $[23];
    return t10;
};
const $d20664fd99e4ace3$export$2eae41a486732e13 = (t0)=>{
    const $ = (0, $frIzR.c)(63);
    const { suggestion: suggestion, spaceId: spaceId, onClose: onClose, onSubmit: onSubmit } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [answers, setAnswers] = (0, $42omo.useState)($d20664fd99e4ace3$var$_temp2);
    const [skipped, setSkipped] = (0, $42omo.useState)($d20664fd99e4ace3$var$_temp4);
    const [additionalComments, setAdditionalComments] = (0, $42omo.useState)("");
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (questionKey, value)=>{
            setAnswers((prev)=>({
                    ...prev,
                    [questionKey]: value
                }));
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleSelectOption = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (questionKey_0, checked)=>{
            setSkipped((prev_0)=>({
                    ...prev_0,
                    [questionKey_0]: checked
                }));
            if (checked) setAnswers((prev_1)=>({
                    ...prev_1,
                    [questionKey_0]: null
                }));
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleToggleSkip = t2;
    let t3;
    if ($[2] !== additionalComments || $[3] !== answers.explainability || $[4] !== answers.permissionsPrivacy || $[5] !== answers.placement || $[6] !== answers.recency || $[7] !== answers.redundancy || $[8] !== answers.topicalRelevance || $[9] !== answers.usefulness || $[10] !== createAnalyticsEvent || $[11] !== onClose || $[12] !== onSubmit || $[13] !== spaceId || $[14] !== suggestion.id || $[15] !== suggestion.url || $[16] !== userId) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "submitted",
                    actionSubject: "suggestionFeedback",
                    source: "containerNavigation",
                    attributes: {
                        spaceId: spaceId,
                        userId: userId,
                        suggestionAri: suggestion.id,
                        sourceType: (0, $9f5abb833c441bee$export$39b141cbf41f04f3)(suggestion.url),
                        topicalRelevance: answers.topicalRelevance,
                        placement: answers.placement,
                        usefulness: answers.usefulness,
                        redundancy: answers.redundancy,
                        explainability: answers.explainability,
                        recency: answers.recency,
                        permissionsPrivacy: answers.permissionsPrivacy,
                        additionalComments: additionalComments.trim() || undefined
                    }
                }
            }).fire();
            onSubmit?.();
            onClose();
        };
        $[2] = additionalComments;
        $[3] = answers.explainability;
        $[4] = answers.permissionsPrivacy;
        $[5] = answers.placement;
        $[6] = answers.recency;
        $[7] = answers.redundancy;
        $[8] = answers.topicalRelevance;
        $[9] = answers.usefulness;
        $[10] = createAnalyticsEvent;
        $[11] = onClose;
        $[12] = onSubmit;
        $[13] = spaceId;
        $[14] = suggestion.id;
        $[15] = suggestion.url;
        $[16] = userId;
        $[17] = t3;
    } else t3 = $[17];
    const handleSubmit = t3;
    let t4;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = $d20664fd99e4ace3$var$FEEDBACK_QUESTIONS.map($d20664fd99e4ace3$var$_temp5);
        $[18] = t4;
    } else t4 = $[18];
    const questionsWithPartHeaders = t4;
    let t5;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (questionKey_1)=>(e)=>handleToggleSkip(questionKey_1, e.target.checked);
        $[19] = t5;
    } else t5 = $[19];
    const handleSkipChange = t5;
    let t6;
    if ($[20] !== formatMessage) {
        t6 = formatMessage($d20664fd99e4ace3$var$i18n.modalTitle);
        $[20] = formatMessage;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, t6));
        $[22] = t6;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== answers || $[25] !== formatMessage || $[26] !== skipped) {
        t8 = questionsWithPartHeaders.map((question_0)=>{
            const isSkipped = skipped[question_0.key];
            const selectedValue = answers[question_0.key];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: question_0.key
            }, question_0.showPartHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $d20664fd99e4ace3$var$styles.partHeader
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                size: "xsmall"
            }, question_0.part === 1 ? formatMessage($d20664fd99e4ace3$var$i18n.part1Header) : formatMessage($d20664fd99e4ace3$var$i18n.part2Header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $d20664fd99e4ace3$var$styles.questionBlock
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                space: "space.075"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                weight: "semibold"
            }, formatMessage(question_0.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtle"
            }, formatMessage(question_0.question)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                role: "radiogroup",
                "aria-label": formatMessage(question_0.title)
            }, question_0.options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d20664fd99e4ace3$var$OptionRow, {
                    key: option.value,
                    label: formatMessage(option.label),
                    value: option.value,
                    questionKey: question_0.key,
                    isSelected: !isSkipped && selectedValue === option.value,
                    isDisabled: isSkipped,
                    onSelect: handleSelectOption
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                xcss: $d20664fd99e4ace3$var$styles.skipRow
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
                label: formatMessage($d20664fd99e4ace3$var$i18n.skipLabel),
                isChecked: isSkipped,
                onChange: handleSkipChange(question_0.key)
            })))));
        });
        $[24] = answers;
        $[25] = formatMessage;
        $[26] = skipped;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== formatMessage) {
        t9 = formatMessage($d20664fd99e4ace3$var$i18n.additionalCommentsLabel);
        $[28] = formatMessage;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "semibold"
        }, t9);
        $[30] = t9;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (e_0)=>setAdditionalComments(e_0.target.value);
        $[32] = t11;
    } else t11 = $[32];
    let t12;
    if ($[33] !== formatMessage) {
        t12 = formatMessage($d20664fd99e4ace3$var$i18n.additionalCommentsPlaceholder);
        $[33] = formatMessage;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== additionalComments || $[36] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
            value: additionalComments,
            onChange: t11,
            placeholder: t12,
            maxLength: 500,
            minimumRows: 3
        });
        $[35] = additionalComments;
        $[36] = t12;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== t10 || $[39] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d20664fd99e4ace3$var$styles.additionalCommentsSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.075"
        }, t10, t13));
        $[38] = t10;
        $[39] = t13;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== t14 || $[42] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d20664fd99e4ace3$var$styles.modalBody
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.0"
        }, t8, t14)));
        $[41] = t14;
        $[42] = t8;
        $[43] = t15;
    } else t15 = $[43];
    let t16;
    if ($[44] !== formatMessage) {
        t16 = formatMessage($d20664fd99e4ace3$var$i18n.cancelButton);
        $[44] = formatMessage;
        $[45] = t16;
    } else t16 = $[45];
    let t17;
    if ($[46] !== onClose || $[47] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: onClose
        }, t16);
        $[46] = onClose;
        $[47] = t16;
        $[48] = t17;
    } else t17 = $[48];
    let t18;
    if ($[49] !== formatMessage) {
        t18 = formatMessage($d20664fd99e4ace3$var$i18n.submitButton);
        $[49] = formatMessage;
        $[50] = t18;
    } else t18 = $[50];
    let t19;
    if ($[51] !== handleSubmit || $[52] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleSubmit
        }, t18);
        $[51] = handleSubmit;
        $[52] = t18;
        $[53] = t19;
    } else t19 = $[53];
    let t20;
    if ($[54] !== t17 || $[55] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, t17, t19);
        $[54] = t17;
        $[55] = t19;
        $[56] = t20;
    } else t20 = $[56];
    let t21;
    if ($[57] !== Modal || $[58] !== onClose || $[59] !== t15 || $[60] !== t20 || $[61] !== t7) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            onClose: onClose,
            width: "medium"
        }, t7, t15, t20);
        $[57] = Modal;
        $[58] = onClose;
        $[59] = t15;
        $[60] = t20;
        $[61] = t7;
        $[62] = t21;
    } else t21 = $[62];
    return t21;
};
function $d20664fd99e4ace3$var$_temp(q) {
    return [
        q.key,
        null
    ];
}
function $d20664fd99e4ace3$var$_temp2() {
    return Object.fromEntries($d20664fd99e4ace3$var$FEEDBACK_QUESTIONS.map($d20664fd99e4ace3$var$_temp));
}
function $d20664fd99e4ace3$var$_temp3(q_0) {
    return [
        q_0.key,
        false
    ];
}
function $d20664fd99e4ace3$var$_temp4() {
    return Object.fromEntries($d20664fd99e4ace3$var$FEEDBACK_QUESTIONS.map($d20664fd99e4ace3$var$_temp3));
}
function $d20664fd99e4ace3$var$_temp5(question, index) {
    return {
        ...question,
        showPartHeader: index === 0 || question.part !== $d20664fd99e4ace3$var$FEEDBACK_QUESTIONS[index - 1].part
    };
}


var $384d66bca1d18ea9$exports = {};
$384d66bca1d18ea9$exports = new URL("eyelash.6dc5a5e0.svg", import.meta.url).toString();


const $b84c4cb49dedd5e2$var$SUGGESTION_PREVIEW_DWELL_MS = 500;
const $b84c4cb49dedd5e2$var$PREVIEW_ITEM_COUNT = 5;
function $b84c4cb49dedd5e2$var$useSuggestionPreviewAnalytics(t0) {
    const $ = (0, $frIzR.c)(9);
    const { spaceId: spaceId, suggestion: suggestion } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverStartRef = (0, $42omo.useRef)(null);
    const previewTimeoutRef = (0, $42omo.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>()=>{
                if (previewTimeoutRef.current) clearTimeout(previewTimeoutRef.current);
            };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== createAnalyticsEvent || $[3] !== spaceId || $[4] !== suggestion) {
        t3 = ()=>{
            hoverStartRef.current = Date.now();
            previewTimeoutRef.current = setTimeout(()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "previewed",
                        actionSubject: "suggestion",
                        source: "containerNavigation",
                        attributes: {
                            spaceId: spaceId,
                            suggestionId: suggestion.id,
                            sourceType: (0, $9f5abb833c441bee$export$39b141cbf41f04f3)(suggestion.url),
                            previewDwellMs: Date.now() - (hoverStartRef.current ?? Date.now())
                        }
                    }
                }).fire();
                previewTimeoutRef.current = null;
            }, $b84c4cb49dedd5e2$var$SUGGESTION_PREVIEW_DWELL_MS);
        };
        $[2] = createAnalyticsEvent;
        $[3] = spaceId;
        $[4] = suggestion;
        $[5] = t3;
    } else t3 = $[5];
    const startPreviewAnalytics = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            if (previewTimeoutRef.current) {
                clearTimeout(previewTimeoutRef.current);
                previewTimeoutRef.current = null;
            }
            hoverStartRef.current = null;
        };
        $[6] = t4;
    } else t4 = $[6];
    const cancelPreviewAnalytics = t4;
    let t5;
    if ($[7] !== startPreviewAnalytics) {
        t5 = {
            startPreviewAnalytics: startPreviewAnalytics,
            cancelPreviewAnalytics: cancelPreviewAnalytics
        };
        $[7] = startPreviewAnalytics;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
}
const $b84c4cb49dedd5e2$var$i18n = (0, $aXWIB.defineMessages)({
    bringTogetherTitle: {
        id: "side-navigation.review-content-suggestions-modal.bring-together-title",
        defaultMessage: "Bring together the content that matters"
    },
    bringTogetherDescription: {
        id: "side-navigation.review-content-suggestions-modal.bring-together-description",
        defaultMessage: "Add these suggestions and it\u2019ll be organized in this space."
    },
    addItemsToSpace: {
        id: "side-navigation.review-content-suggestions-modal.add-items-to-space",
        defaultMessage: "Add {count, plural, one {# item} other {# items}} to space"
    },
    expandGroup: {
        id: "side-navigation.review-content-suggestions-modal.expand-group",
        defaultMessage: "Expand {title}"
    },
    collapseGroup: {
        id: "side-navigation.review-content-suggestions-modal.collapse-group",
        defaultMessage: "Collapse {title}"
    },
    openSuggestion: {
        id: "side-navigation.review-content-suggestions-modal.open-suggestion",
        defaultMessage: "Open {title} in a new tab"
    },
    deselectGroup: {
        id: "side-navigation.review-content-suggestions-modal.deselect-group",
        defaultMessage: "Deselect group {title}"
    },
    selectGroup: {
        id: "side-navigation.review-content-suggestions-modal.select-group",
        defaultMessage: "Select group {title}"
    },
    deselectItem: {
        id: "side-navigation.review-content-suggestions-modal.deselect-item",
        defaultMessage: "Deselect {title}"
    },
    selectItem: {
        id: "side-navigation.review-content-suggestions-modal.select-item",
        defaultMessage: "Select {title}"
    },
    untitled: {
        id: "side-navigation.review-content-suggestions-modal.untitled",
        defaultMessage: "Untitled"
    },
    feedbackButtonLabel: {
        id: "side-navigation.review-content-suggestions-modal.feedback-button-label",
        defaultMessage: "Rate suggestion quality for {title}"
    },
    evalButtonLabel: {
        id: "side-navigation.review-content-suggestions-modal.eval-button-label",
        defaultMessage: "Eval"
    },
    loading: {
        id: "side-navigation.review-content-suggestions-modal.loading",
        defaultMessage: "Loading suggestions\u2026"
    },
    submitting: {
        id: "side-navigation.review-content-suggestions-modal.submitting",
        defaultMessage: "Adding items to space\u2026"
    },
    spaceAvatarAlt: {
        id: "side-navigation.review-content-suggestions-modal.space-avatar-alt",
        defaultMessage: "Avatar for {spaceName}"
    }
});
const $b84c4cb49dedd5e2$var$styles = {
    layout: "_2rkopb1k _1reo15vq _18m915vq _4t3i1oh5",
    leftPanel: "_zulp1ejb _1reo15vq _18m915vq _1rjc1jfw _18zroahv _16jlkb7n _i0dl1ssb _1e0c1txw _2lx21bp4",
    rightPanel: "_1reo15vq _18m915vq _16jlkb7n _i0dl1ssb _kqswh2mm _bfhk1ymo _5fbcpb1k _1einpb1k",
    previewPanelContent: "_85i5pxbi",
    previewCard: "_1yt4utpp _bfhk1j9a",
    previewGroupsSection: "_zulpu2gc _2rko1qi0 _1yt41b66 _189edkaa _1dqonqa1 _1h6d1ymo _1e0c1txw _2lx21bp4 _16qssmn1",
    previewFoldersList: "_zulpu2gc _1e0c1txw _2lx21bp4",
    previewFolderPreview: "_19itglyw _bfhk1j9a",
    previewFolderHeader: "_zulpu2gc _v564mvc0 _18zrutpp _1rjc12x7 _1e0c1txw _4cvr1h6o _1bah1yb4 _kqswh2mm _irr3i8nm",
    previewFolderTitleRow: "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1ul9idpf",
    previewGroupTitle: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf",
    previewFolderBody: "_18zrutpp _1e0cglyw _85i5utpp",
    previewFolderBodyExpanded: "_1e0c1ule",
    previewFolderBodyIndented: "_bozgze3t",
    previewSuggestionList: "_zulp12x7 _1e0c1txw _2lx21bp4 _1bsb1osq",
    previewSuggestionRow: "_zulpu2gc _1rjc1b66 _1e0c1txw _4cvr1h6o _1ul9idpf _1bsb1osq _bozgxy5q _y4ti12x7",
    previewSuggestionTitle: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf",
    spaceHeader: "_zulpu2gc _1rjcv47k _18zr1ejb _bfhk1j9a _1doce4h9 _1il9nqa1 _1o3i1l7x _1s1gpb1k _4cvr1h6o _1o9zidpf",
    spaceHeaderTitle: "_1ul9idpf _16jlkb7n",
    spaceAvatarWrapper: "_2rko1qi0 _1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _1o9zidpf",
    stackedContentTypeIconWrapper: "_6rthv47k",
    closeButtonWrapper: "_154iu2gc _1ltvu2gc",
    eyelashWrapper: "_kqswh2mm",
    eyelash: "_y44vjpww _1reoewfl _18m9ewfl _kqswstnw _154i1m4h _1ltv1m4h _1pbyb4wl _lcxvglyw",
    groupListScrollArea: "_16jlkb7n _18m91wug _1fjgglyw _1tkeidpf",
    container: "_1reoewfl _18m9ewfl _kqswstnw _154i1epz _1ltv1epz _1xi2ze3t _94n5ze3t _bfhkvuon _1s1gpb1k",
    groupCard: "_2rko1mok _1reo15vq _18m915vq _v5641po6 _189ee4h9 _1dqonqa1 _1h6d1l7x _4cvx1ihb",
    groupCardExpanded: "_1reoewfl _18m9ewfl _1h6d1ihb _kqswh2mm _1pbyidpf",
    groupCardHovering: "_1h6d1l7x _kqswh2mm _1pby1fw0",
    expandButton: "_zulpu2gc _1rjcutpp _1e0c1txw _4cvr1h6o _1bah1y6m _y3gnv2br _16jlkb7n _bozg1b66 _y4tiutpp _bfhk1j28 _irr31j28",
    groupTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    groupCountText: "_1o9zidpf _o5721q9c",
    groupChevron: "_1o9zidpf _1e0c1txw _4cvr1h6o",
    itemsListOuter: "_v5641i4b _1e0c11p5 _2z0563bf _tzy4idpf",
    itemsListOuterExpanded: "_2z05hkll _tzy4kb7n",
    itemsList: "_1reoewfl _18m9ewfl _1tkeidpf",
    itemRowContainer: "_v564mvc0 _kqswh2mm _1pbyidpf _1bsb1osq _irr3i8nm",
    itemRowContainerHovered: "_1pbykb7n",
    portalHoverCard: "_v564sfsx _kqsw1n9t _1pby9y44 _lcxvglyw _tzy4idpf _t9ec155f",
    portalHoverCardVisible: "_tzy4kb7n _lcxv1wug _t9ec1kli",
    previewPlaceholderSection: "_18zr1b66 _1rjcu2gc _1e0c1txw _2lx21bp4",
    previewPlaceholderRow: "_1rjcu2gc _1e0c1txw _4cvr1h6o",
    previewPlaceholderDot: "_2rko12b0 _1bsb19bv _4t3i19bv _bfhki8nm _1o9zidpf",
    previewPlaceholderBarLong: "_2rko12b0 _4t3iftgi _1bsb1n8h _bfhki8nm",
    previewPlaceholderBarFull: "_2rko12b0 _4t3iftgi _1bsb1mxx _bfhki8nm",
    suggestionLinkWrapper: "_zulpu2gc _1rjc12x7 _16jlkb7n _1ul9idpf _1e0c1txw _4cvr1h6o _bozg1b66 _y4tiutpp",
    suggestionLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _4cvr1h6o _1n261q9c _1ul9idpf _syazi7uo _16jlkb7n _9oik1r31 _1bnx8stv _jf4cnqa1 _9oiki7uo",
    suggestionIconSlot: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    suggestionTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    suggestionLinkExternalIcon: "_1o9zidpf",
    suggestionExternalLinkButton: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjc12x7 _18zr1b66 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _syazi7uo _9oik1r31 _1bnxglyw _jf4cnqa1",
    addButtonRow: "_85i5pxbi",
    itemRow: "_1rjcu2gc _18zru2gc _uwhke4h9 _15a5nqa1 _1i531l7x _irr3i8nm",
    unselectedOpacity: "_tzy42wxo",
    loadingOverlay: "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1oh5",
    feedbackIconButton: "_2rko12b0 _1yt41b66 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _irr3plhp"
};
// Estimated max height of the hover cards (in px) used for flip-up logic
const $b84c4cb49dedd5e2$var$HOVER_CARD_HEIGHT = 160;
const $b84c4cb49dedd5e2$var$HOVER_CARD_OFFSET = 8;
const $b84c4cb49dedd5e2$var$useHoverCardPortal = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const flipUp = t0 === undefined ? false : t0;
    const ref = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [position, setPosition] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] !== flipUp) {
        t1 = ()=>{
            if (ref.current) {
                const rect = ref.current.getBoundingClientRect();
                const spaceBelow = window.innerHeight - rect.bottom;
                const top = !flipUp && spaceBelow > $b84c4cb49dedd5e2$var$HOVER_CARD_HEIGHT ? rect.bottom + $b84c4cb49dedd5e2$var$HOVER_CARD_OFFSET : rect.top - $b84c4cb49dedd5e2$var$HOVER_CARD_HEIGHT - $b84c4cb49dedd5e2$var$HOVER_CARD_OFFSET;
                setPosition({
                    top: top,
                    left: rect.left
                });
            }
            setIsVisible(true);
        };
        $[0] = flipUp;
        $[1] = t1;
    } else t1 = $[1];
    const show = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsVisible(false);
        $[2] = t2;
    } else t2 = $[2];
    const hide = t2;
    let t3;
    if ($[3] !== isVisible || $[4] !== position || $[5] !== show) {
        t3 = {
            ref: ref,
            isVisible: isVisible,
            position: position,
            show: show,
            hide: hide
        };
        $[3] = isVisible;
        $[4] = position;
        $[5] = show;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
const $b84c4cb49dedd5e2$var$SuggestionItemRow = (t0)=>{
    const $ = (0, $frIzR.c)(87);
    const { spaceId: spaceId, spaceKey: spaceKey, suggestion: suggestion, isSelected: isSelected, hasFeedbackBeenSubmitted: hasFeedbackBeenSubmitted, onFeedbackSubmitted: onFeedbackSubmitted, onToggleSelectItem: onToggleSelectItem, onHoverCardVisibilityChange: onHoverCardVisibilityChange, onMoveSuggestion: onMoveSuggestion } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== suggestion.url) {
        t1 = (0, $9f5abb833c441bee$export$82cacbc9ddf6b54e)(suggestion.url);
        $[0] = suggestion.url;
        $[1] = t1;
    } else t1 = $[1];
    const iconUrl = t1;
    const { ref: ref, isVisible: isVisible, position: position, show: show, hide: hide } = $b84c4cb49dedd5e2$var$useHoverCardPortal();
    let t2;
    if ($[2] !== spaceId || $[3] !== suggestion) {
        t2 = {
            spaceId: spaceId,
            suggestion: suggestion
        };
        $[2] = spaceId;
        $[3] = suggestion;
        $[4] = t2;
    } else t2 = $[4];
    const { startPreviewAnalytics: startPreviewAnalytics, cancelPreviewAnalytics: cancelPreviewAnalytics } = $b84c4cb49dedd5e2$var$useSuggestionPreviewAnalytics(t2);
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = (0, $42omo.useState)(false);
    const isFeedbackModalOpenRef = (0, $42omo.useRef)(false);
    const [isMovePopupOpen, setIsMovePopupOpen] = (0, $42omo.useState)(false);
    const isMovePopupOpenRef = (0, $42omo.useRef)(false);
    let t3;
    if ($[5] !== onHoverCardVisibilityChange || $[6] !== show || $[7] !== startPreviewAnalytics) {
        t3 = ()=>{
            if (isMovePopupOpenRef.current || isFeedbackModalOpenRef.current) return;
            show();
            onHoverCardVisibilityChange(true);
            startPreviewAnalytics();
        };
        $[5] = onHoverCardVisibilityChange;
        $[6] = show;
        $[7] = startPreviewAnalytics;
        $[8] = t3;
    } else t3 = $[8];
    const handleShow = t3;
    let t4;
    if ($[9] !== cancelPreviewAnalytics || $[10] !== hide || $[11] !== onHoverCardVisibilityChange) {
        t4 = ()=>{
            hide();
            onHoverCardVisibilityChange(false);
            cancelPreviewAnalytics();
        };
        $[9] = cancelPreviewAnalytics;
        $[10] = hide;
        $[11] = onHoverCardVisibilityChange;
        $[12] = t4;
    } else t4 = $[12];
    const handleHide = t4;
    let t5;
    if ($[13] !== handleHide) {
        t5 = (open)=>{
            isMovePopupOpenRef.current = open;
            setIsMovePopupOpen(open);
            if (open) handleHide();
        };
        $[13] = handleHide;
        $[14] = t5;
    } else t5 = $[14];
    const handleMovePopupOpenChange = t5;
    const t6 = isVisible && $b84c4cb49dedd5e2$var$styles.itemRowContainerHovered;
    let t7;
    if ($[15] !== t6) {
        t7 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemRowContainer, t6);
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== handleHide) {
        t8 = (event)=>{
            if (event.currentTarget.contains(event.relatedTarget)) return;
            handleHide();
        };
        $[17] = handleHide;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = `review-content-suggestion-row-${suggestion.id}`;
    const t10 = !isSelected && $b84c4cb49dedd5e2$var$styles.unselectedOpacity;
    let t11;
    if ($[19] !== t10) {
        t11 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemRow, t10);
        $[19] = t10;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== onToggleSelectItem || $[22] !== suggestion.id) {
        t12 = ()=>onToggleSelectItem(suggestion.id);
        $[21] = onToggleSelectItem;
        $[22] = suggestion.id;
        $[23] = t12;
    } else t12 = $[23];
    const t13 = isSelected ? $b84c4cb49dedd5e2$var$i18n.deselectItem : $b84c4cb49dedd5e2$var$i18n.selectItem;
    let t14;
    if ($[24] !== formatMessage || $[25] !== suggestion.title || $[26] !== t13) {
        t14 = formatMessage(t13, {
            title: suggestion.title
        });
        $[24] = formatMessage;
        $[25] = suggestion.title;
        $[26] = t13;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== isSelected || $[29] !== t12 || $[30] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ff49e7a1b080355$export$7eb83caae4372066), {
            isSelected: isSelected,
            onClick: t12,
            ariaLabel: t14
        });
        $[28] = isSelected;
        $[29] = t12;
        $[30] = t14;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== iconUrl) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionIconSlot,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "16",
            height: "16",
            fallback: $b84c4cb49dedd5e2$var$_temp,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[32] = iconUrl;
        $[33] = t16;
    } else t16 = $[33];
    const t17 = suggestion.url;
    let t18;
    if ($[34] !== formatMessage || $[35] !== suggestion.title) {
        t18 = formatMessage($b84c4cb49dedd5e2$var$i18n.openSuggestion, {
            title: suggestion.title
        });
        $[34] = formatMessage;
        $[35] = suggestion.title;
        $[36] = t18;
    } else t18 = $[36];
    let t19;
    if ($[37] !== suggestion.title) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            maxLines: 1
        }, suggestion.title));
        $[37] = suggestion.title;
        $[38] = t19;
    } else t19 = $[38];
    let t20;
    if ($[39] !== suggestion.url || $[40] !== t18 || $[41] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            href: t17,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": t18,
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLink
        }, t19);
        $[39] = suggestion.url;
        $[40] = t18;
        $[41] = t19;
        $[42] = t20;
    } else t20 = $[42];
    let t21;
    if ($[43] !== t16 || $[44] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLinkWrapper
        }, t16, t20);
        $[43] = t16;
        $[44] = t20;
        $[45] = t21;
    } else t21 = $[45];
    let t22;
    if ($[46] !== formatMessage || $[47] !== handleHide || $[48] !== hasFeedbackBeenSubmitted || $[49] !== suggestion.title) {
        t22 = !hasFeedbackBeenSubmitted && (0, $6mKj3.expVal)("cc-space-curation-feedback-survey", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.feedbackIconButton,
            onClick: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                isFeedbackModalOpenRef.current = true;
                handleHide();
                setIsFeedbackModalOpen(true);
            },
            "aria-label": formatMessage($b84c4cb49dedd5e2$var$i18n.feedbackButtonLabel, {
                title: suggestion.title
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage($b84c4cb49dedd5e2$var$i18n.evalButtonLabel)));
        $[46] = formatMessage;
        $[47] = handleHide;
        $[48] = hasFeedbackBeenSubmitted;
        $[49] = suggestion.title;
        $[50] = t22;
    } else t22 = $[50];
    let t23;
    if ($[51] !== handleMovePopupOpenChange || $[52] !== isMovePopupOpen || $[53] !== isVisible || $[54] !== onMoveSuggestion || $[55] !== spaceKey || $[56] !== suggestion.fallbackParents || $[57] !== suggestion.id || $[58] !== suggestion.parentId) {
        t23 = (isVisible || isMovePopupOpen) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4835e3f9f2ab2337$export$de484dae570b7c31), {
            suggestionId: suggestion.id,
            spaceKey: spaceKey,
            isOpen: isMovePopupOpen,
            onOpenChange: handleMovePopupOpenChange,
            onMoveSuggestion: onMoveSuggestion,
            fallbackParents: suggestion.fallbackParents,
            currentParentId: suggestion.parentId
        });
        $[51] = handleMovePopupOpenChange;
        $[52] = isMovePopupOpen;
        $[53] = isVisible;
        $[54] = onMoveSuggestion;
        $[55] = spaceKey;
        $[56] = suggestion.fallbackParents;
        $[57] = suggestion.id;
        $[58] = suggestion.parentId;
        $[59] = t23;
    } else t23 = $[59];
    let t24;
    if ($[60] !== t11 || $[61] !== t15 || $[62] !== t21 || $[63] !== t22 || $[64] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            xcss: t11
        }, t15, t21, t22, t23);
        $[60] = t11;
        $[61] = t15;
        $[62] = t21;
        $[63] = t22;
        $[64] = t23;
        $[65] = t24;
    } else t24 = $[65];
    let t25;
    if ($[66] !== isFeedbackModalOpen || $[67] !== onFeedbackSubmitted || $[68] !== spaceId || $[69] !== suggestion) {
        t25 = isFeedbackModalOpen && (0, $6mKj3.expVal)("cc-space-curation-feedback-survey", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d20664fd99e4ace3$export$2eae41a486732e13), {
            suggestion: suggestion,
            spaceId: spaceId,
            onClose: ()=>{
                isFeedbackModalOpenRef.current = false;
                setIsFeedbackModalOpen(false);
            },
            onSubmit: ()=>onFeedbackSubmitted?.(suggestion.id)
        });
        $[66] = isFeedbackModalOpen;
        $[67] = onFeedbackSubmitted;
        $[68] = spaceId;
        $[69] = suggestion;
        $[70] = t25;
    } else t25 = $[70];
    let t26;
    if ($[71] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t25);
        $[71] = t25;
        $[72] = t26;
    } else t26 = $[72];
    let t27;
    if ($[73] !== isVisible || $[74] !== position || $[75] !== suggestion) {
        t27 = isVisible && position && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.portalHoverCard, isVisible && $b84c4cb49dedd5e2$var$styles.portalHoverCardVisible),
            style: {
                top: position.top,
                left: position.left
            },
            testId: "review-content-suggestion-hover-card-portal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc28f14084497f84$export$bf0a0c07cf58248c), {
            suggestion: suggestion
        })), document.body);
        $[73] = isVisible;
        $[74] = position;
        $[75] = suggestion;
        $[76] = t27;
    } else t27 = $[76];
    let t28;
    if ($[77] !== handleHide || $[78] !== handleShow || $[79] !== ref || $[80] !== t24 || $[81] !== t26 || $[82] !== t27 || $[83] !== t7 || $[84] !== t8 || $[85] !== t9) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            xcss: t7,
            onMouseEnter: handleShow,
            onMouseLeave: handleHide,
            onFocusCapture: handleShow,
            onBlur: t8,
            testId: t9
        }, t24, t26, t27);
        $[77] = handleHide;
        $[78] = handleShow;
        $[79] = ref;
        $[80] = t24;
        $[81] = t26;
        $[82] = t27;
        $[83] = t7;
        $[84] = t8;
        $[85] = t9;
        $[86] = t28;
    } else t28 = $[86];
    return t28;
};
const $b84c4cb49dedd5e2$var$SuggestionGroupRow = (t0)=>{
    const $ = (0, $frIzR.c)(83);
    const { parentTitle: parentTitle, suggestions: suggestions, isExpanded: isExpanded, isGroupSelected: isGroupSelected, selectedItems: selectedItems, toggleExpand: toggleExpand, spaceId: spaceId, spaceKey: spaceKey, parentId: parentId, toggleSelectGroup: toggleSelectGroup, onToggleSelectItem: onToggleSelectItem, onGroupHoverChange: onGroupHoverChange, submittedFeedbackIds: submittedFeedbackIds, onFeedbackSubmitted: onFeedbackSubmitted, onMoveSuggestion: onMoveSuggestion } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHoverCardVisible, setIsHoverCardVisible] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== selectedItems || $[1] !== suggestions) {
        let t2;
        if ($[3] !== selectedItems) {
            t2 = (suggestion)=>selectedItems.has(suggestion.id);
            $[3] = selectedItems;
            $[4] = t2;
        } else t2 = $[4];
        t1 = suggestions.filter(t2);
        $[0] = selectedItems;
        $[1] = suggestions;
        $[2] = t1;
    } else t1 = $[2];
    const selectedSuggestionCount = t1.length;
    const t2 = isExpanded && $b84c4cb49dedd5e2$var$styles.groupCardExpanded;
    const t3 = isHoverCardVisible && $b84c4cb49dedd5e2$var$styles.groupCardHovering;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.groupCard, t2, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[8] !== onGroupHoverChange || $[9] !== parentId) {
        t5 = ()=>onGroupHoverChange(parentId, true);
        t6 = ()=>onGroupHoverChange(parentId, false);
        t7 = ()=>onGroupHoverChange(parentId, true);
        t8 = (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) onGroupHoverChange(parentId, false);
        };
        $[8] = onGroupHoverChange;
        $[9] = parentId;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else {
        t5 = $[10];
        t6 = $[11];
        t7 = $[12];
        t8 = $[13];
    }
    const t9 = `review-content-suggestion-group-card-${parentId}`;
    const t10 = !isGroupSelected && $b84c4cb49dedd5e2$var$styles.unselectedOpacity;
    let t11;
    if ($[14] !== suggestions || $[15] !== toggleSelectGroup) {
        t11 = ()=>toggleSelectGroup(suggestions);
        $[14] = suggestions;
        $[15] = toggleSelectGroup;
        $[16] = t11;
    } else t11 = $[16];
    const t12 = isGroupSelected ? $b84c4cb49dedd5e2$var$i18n.deselectGroup : $b84c4cb49dedd5e2$var$i18n.selectGroup;
    let t13;
    if ($[17] !== formatMessage || $[18] !== parentTitle || $[19] !== t12) {
        t13 = formatMessage(t12, {
            title: parentTitle
        });
        $[17] = formatMessage;
        $[18] = parentTitle;
        $[19] = t12;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== isGroupSelected || $[22] !== t11 || $[23] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ff49e7a1b080355$export$7eb83caae4372066), {
            isSelected: isGroupSelected,
            onClick: t11,
            ariaLabel: t13
        });
        $[21] = isGroupSelected;
        $[22] = t11;
        $[23] = t13;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== parentId || $[26] !== toggleExpand) {
        t15 = ()=>toggleExpand(parentId);
        $[25] = parentId;
        $[26] = toggleExpand;
        $[27] = t15;
    } else t15 = $[27];
    const t16 = isExpanded ? $b84c4cb49dedd5e2$var$i18n.collapseGroup : $b84c4cb49dedd5e2$var$i18n.expandGroup;
    let t17;
    if ($[28] !== formatMessage || $[29] !== parentTitle || $[30] !== t16) {
        t17 = formatMessage(t16, {
            title: parentTitle
        });
        $[28] = formatMessage;
        $[29] = parentTitle;
        $[30] = t16;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== parentTitle) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.groupTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium",
            maxLines: 1
        }, parentTitle));
        $[32] = parentTitle;
        $[33] = t18;
    } else t18 = $[33];
    let t19;
    if ($[34] !== selectedSuggestionCount) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.groupCountText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, selectedSuggestionCount));
        $[34] = selectedSuggestionCount;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== isExpanded) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.groupChevron
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[36] = isExpanded;
        $[37] = t20;
    } else t20 = $[37];
    let t21;
    if ($[38] !== isExpanded || $[39] !== t15 || $[40] !== t17 || $[41] !== t18 || $[42] !== t19 || $[43] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.expandButton,
            onClick: t15,
            "aria-expanded": isExpanded,
            "aria-label": t17
        }, t18, t19, t20);
        $[38] = isExpanded;
        $[39] = t15;
        $[40] = t17;
        $[41] = t18;
        $[42] = t19;
        $[43] = t20;
        $[44] = t21;
    } else t21 = $[44];
    let t22;
    if ($[45] !== t10 || $[46] !== t14 || $[47] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: t10
        }, t14, t21);
        $[45] = t10;
        $[46] = t14;
        $[47] = t21;
        $[48] = t22;
    } else t22 = $[48];
    const t23 = isExpanded && $b84c4cb49dedd5e2$var$styles.itemsListOuterExpanded;
    let t24;
    if ($[49] !== t23) {
        t24 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemsListOuter, t23);
        $[49] = t23;
        $[50] = t24;
    } else t24 = $[50];
    const t25 = !isExpanded;
    let t26;
    if ($[51] !== onFeedbackSubmitted || $[52] !== onMoveSuggestion || $[53] !== onToggleSelectItem || $[54] !== selectedItems || $[55] !== spaceId || $[56] !== spaceKey || $[57] !== submittedFeedbackIds || $[58] !== suggestions) {
        let t27;
        if ($[60] !== onFeedbackSubmitted || $[61] !== onMoveSuggestion || $[62] !== onToggleSelectItem || $[63] !== selectedItems || $[64] !== spaceId || $[65] !== spaceKey || $[66] !== submittedFeedbackIds) {
            t27 = (suggestion_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionItemRow, {
                    key: suggestion_0.id,
                    suggestion: suggestion_0,
                    isSelected: selectedItems.has(suggestion_0.id),
                    spaceId: spaceId,
                    hasFeedbackBeenSubmitted: submittedFeedbackIds.has(suggestion_0.id),
                    onFeedbackSubmitted: onFeedbackSubmitted,
                    spaceKey: spaceKey,
                    onToggleSelectItem: onToggleSelectItem,
                    onHoverCardVisibilityChange: setIsHoverCardVisible,
                    onMoveSuggestion: onMoveSuggestion
                });
            $[60] = onFeedbackSubmitted;
            $[61] = onMoveSuggestion;
            $[62] = onToggleSelectItem;
            $[63] = selectedItems;
            $[64] = spaceId;
            $[65] = spaceKey;
            $[66] = submittedFeedbackIds;
            $[67] = t27;
        } else t27 = $[67];
        t26 = suggestions.map(t27);
        $[51] = onFeedbackSubmitted;
        $[52] = onMoveSuggestion;
        $[53] = onToggleSelectItem;
        $[54] = selectedItems;
        $[55] = spaceId;
        $[56] = spaceKey;
        $[57] = submittedFeedbackIds;
        $[58] = suggestions;
        $[59] = t26;
    } else t26 = $[59];
    let t27;
    if ($[68] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.itemsList
        }, t26);
        $[68] = t26;
        $[69] = t27;
    } else t27 = $[69];
    let t28;
    if ($[70] !== t24 || $[71] !== t25 || $[72] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t24,
            "aria-hidden": t25
        }, t27);
        $[70] = t24;
        $[71] = t25;
        $[72] = t27;
        $[73] = t28;
    } else t28 = $[73];
    let t29;
    if ($[74] !== t22 || $[75] !== t28 || $[76] !== t4 || $[77] !== t5 || $[78] !== t6 || $[79] !== t7 || $[80] !== t8 || $[81] !== t9) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t4,
            onMouseEnter: t5,
            onMouseLeave: t6,
            onFocusCapture: t7,
            onBlur: t8,
            testId: t9
        }, t22, t28);
        $[74] = t22;
        $[75] = t28;
        $[76] = t4;
        $[77] = t5;
        $[78] = t6;
        $[79] = t7;
        $[80] = t8;
        $[81] = t9;
        $[82] = t29;
    } else t29 = $[82];
    return t29;
};
const $b84c4cb49dedd5e2$var$ModalLeftPanel = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, selectedItems: selectedItems, expandedGroups: expandedGroups, toggleExpand: toggleExpand, toggleSelectGroup: toggleSelectGroup, toggleSelectItem: toggleSelectItem, onGroupHoverChange: onGroupHoverChange, onMoveSuggestion: onMoveSuggestion, spaceId: spaceId, spaceKey: spaceKey } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
    } else t1 = $[0];
    const [submittedFeedbackIds, setSubmittedFeedbackIds] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (suggestionId)=>{
            setSubmittedFeedbackIds((prev)=>new Set([
                    ...prev,
                    suggestionId
                ]));
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleFeedbackSubmitted = t2;
    let t3;
    if ($[2] !== expandedGroups || $[3] !== formatMessage || $[4] !== groupedSuggestionsWithTitles || $[5] !== onGroupHoverChange || $[6] !== onMoveSuggestion || $[7] !== selectedItems || $[8] !== spaceId || $[9] !== spaceKey || $[10] !== submittedFeedbackIds || $[11] !== toggleExpand || $[12] !== toggleSelectGroup || $[13] !== toggleSelectItem) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, [
            ...groupedSuggestionsWithTitles.entries()
        ].map((t4)=>{
            const [parentId, t5] = t4;
            const { parentTitle: parentTitle, suggestions: groupSuggestions } = t5;
            const isGroupSelected = groupSuggestions.some((s)=>selectedItems.has(s.id));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionGroupRow, {
                key: parentId,
                parentTitle: parentTitle || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled),
                suggestions: groupSuggestions,
                isExpanded: expandedGroups.has(parentId),
                isGroupSelected: isGroupSelected,
                selectedItems: selectedItems,
                toggleExpand: toggleExpand,
                parentId: parentId,
                toggleSelectGroup: toggleSelectGroup,
                onToggleSelectItem: toggleSelectItem,
                onGroupHoverChange: onGroupHoverChange,
                onMoveSuggestion: onMoveSuggestion,
                spaceId: spaceId,
                submittedFeedbackIds: submittedFeedbackIds,
                onFeedbackSubmitted: handleFeedbackSubmitted,
                spaceKey: spaceKey
            });
        }));
        $[2] = expandedGroups;
        $[3] = formatMessage;
        $[4] = groupedSuggestionsWithTitles;
        $[5] = onGroupHoverChange;
        $[6] = onMoveSuggestion;
        $[7] = selectedItems;
        $[8] = spaceId;
        $[9] = spaceKey;
        $[10] = submittedFeedbackIds;
        $[11] = toggleExpand;
        $[12] = toggleSelectGroup;
        $[13] = toggleSelectItem;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
};
const $b84c4cb49dedd5e2$var$PreviewFolderHeader = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { title: title, itemCount: itemCount, isFolderExpanded: isFolderExpanded } = t0;
    const { ref: ref, isVisible: isVisible, position: position, show: show, hide: hide } = $b84c4cb49dedd5e2$var$useHoverCardPortal();
    let t1;
    if ($[0] !== isFolderExpanded) {
        t1 = isFolderExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
            label: "",
            color: "var(--ds-icon-selected, #1868DB)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
            label: "",
            color: "var(--ds-icon-selected, #1868DB)"
        });
        $[0] = isFolderExpanded;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== title) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewGroupTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium",
            maxLines: 1
        }, title));
        $[2] = title;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewFolderTitleRow
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== isVisible || $[8] !== itemCount || $[9] !== position || $[10] !== title) {
        t4 = isVisible && position && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.portalHoverCard, isVisible && $b84c4cb49dedd5e2$var$styles.portalHoverCardVisible),
            style: {
                top: position.top,
                left: position.left
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc28f14084497f84$export$89a7edf0c311b93), {
            title: title,
            itemCount: itemCount
        })), document.body);
        $[7] = isVisible;
        $[8] = itemCount;
        $[9] = position;
        $[10] = title;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== hide || $[13] !== ref || $[14] !== show || $[15] !== t3 || $[16] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            xcss: $b84c4cb49dedd5e2$var$styles.previewFolderHeader,
            onMouseEnter: show,
            onMouseLeave: hide
        }, t3, t4);
        $[12] = hide;
        $[13] = ref;
        $[14] = show;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
};
const $b84c4cb49dedd5e2$var$PreviewSuggestionRow = (t0)=>{
    const $ = (0, $frIzR.c)(32);
    const { suggestion: suggestion, spaceId: spaceId } = t0;
    const { ref: ref, isVisible: isVisible, position: position, show: show, hide: hide } = $b84c4cb49dedd5e2$var$useHoverCardPortal();
    let t1;
    if ($[0] !== suggestion.url) {
        t1 = (0, $9f5abb833c441bee$export$82cacbc9ddf6b54e)(suggestion.url);
        $[0] = suggestion.url;
        $[1] = t1;
    } else t1 = $[1];
    const iconUrl = t1;
    let t2;
    if ($[2] !== spaceId || $[3] !== suggestion) {
        t2 = {
            spaceId: spaceId,
            suggestion: suggestion
        };
        $[2] = spaceId;
        $[3] = suggestion;
        $[4] = t2;
    } else t2 = $[4];
    const { startPreviewAnalytics: startPreviewAnalytics, cancelPreviewAnalytics: cancelPreviewAnalytics } = $b84c4cb49dedd5e2$var$useSuggestionPreviewAnalytics(t2);
    let t3;
    if ($[5] !== show || $[6] !== startPreviewAnalytics) {
        t3 = ()=>{
            show();
            startPreviewAnalytics();
        };
        $[5] = show;
        $[6] = startPreviewAnalytics;
        $[7] = t3;
    } else t3 = $[7];
    const handleShow = t3;
    let t4;
    if ($[8] !== cancelPreviewAnalytics || $[9] !== hide) {
        t4 = ()=>{
            hide();
            cancelPreviewAnalytics();
        };
        $[8] = cancelPreviewAnalytics;
        $[9] = hide;
        $[10] = t4;
    } else t4 = $[10];
    const handleHide = t4;
    const t5 = isVisible && $b84c4cb49dedd5e2$var$styles.itemRowContainerHovered;
    let t6;
    if ($[11] !== t5) {
        t6 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemRowContainer, t5);
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const t7 = `review-content-preview-suggestion-row-${suggestion.id}`;
    let t8;
    if ($[13] !== iconUrl) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionIconSlot,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "16",
            height: "16",
            fallback: $b84c4cb49dedd5e2$var$_temp2,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[13] = iconUrl;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== suggestion.title) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewSuggestionTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            maxLines: 1
        }, suggestion.title));
        $[15] = suggestion.title;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t8 || $[18] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            xcss: $b84c4cb49dedd5e2$var$styles.previewSuggestionRow
        }, t8, t9);
        $[17] = t8;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== isVisible || $[21] !== position || $[22] !== suggestion) {
        t11 = isVisible && position && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.portalHoverCard, isVisible && $b84c4cb49dedd5e2$var$styles.portalHoverCardVisible),
            style: {
                top: position.top,
                left: position.left
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc28f14084497f84$export$bf0a0c07cf58248c), {
            suggestion: suggestion
        })), document.body);
        $[20] = isVisible;
        $[21] = position;
        $[22] = suggestion;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== handleHide || $[25] !== handleShow || $[26] !== ref || $[27] !== t10 || $[28] !== t11 || $[29] !== t6 || $[30] !== t7) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            xcss: t6,
            onMouseEnter: handleShow,
            onMouseLeave: handleHide,
            onFocusCapture: handleShow,
            onBlur: handleHide,
            testId: t7
        }, t10, t11);
        $[24] = handleHide;
        $[25] = handleShow;
        $[26] = ref;
        $[27] = t10;
        $[28] = t11;
        $[29] = t6;
        $[30] = t7;
        $[31] = t12;
    } else t12 = $[31];
    return t12;
};
const $b84c4cb49dedd5e2$var$ModalRightPanel = (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, selectedItems: selectedItems, previewParentId: previewParentId, isHoveringGroupList: isHoveringGroupList, hoveredParentId: hoveredParentId, spaceName: spaceName, spaceId: spaceId, iconPath: iconPath } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let resolvedSpaceName;
    let t1;
    if ($[0] !== formatMessage || $[1] !== spaceName) {
        resolvedSpaceName = spaceName || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled);
        t1 = formatMessage($b84c4cb49dedd5e2$var$i18n.spaceAvatarAlt, {
            spaceName: resolvedSpaceName
        });
        $[0] = formatMessage;
        $[1] = spaceName;
        $[2] = resolvedSpaceName;
        $[3] = t1;
    } else {
        resolvedSpaceName = $[2];
        t1 = $[3];
    }
    const spaceAvatarAlt = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.closeButtonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }));
        $[4] = t2;
    } else t2 = $[4];
    const t3 = iconPath || "";
    let t4;
    if ($[5] !== spaceAvatarAlt) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: spaceAvatarAlt
            });
        $[5] = spaceAvatarAlt;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== spaceAvatarAlt || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.spaceAvatarWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: t3,
            width: "24",
            height: "24",
            alt: spaceAvatarAlt,
            fallback: t4
        }));
        $[7] = spaceAvatarAlt;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== resolvedSpaceName) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.spaceHeaderTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, resolvedSpaceName));
        $[11] = resolvedSpaceName;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t5 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.spaceHeader
        }, t5, t6);
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderSection,
            testId: "review-content-suggestions-modal-preview-placeholder-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarLong
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarFull
        }));
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== hoveredParentId || $[18] !== isHoveringGroupList) {
        t9 = isHoveringGroupList && hoveredParentId !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($384d66bca1d18ea9$exports))),
            alt: "",
            "aria-hidden": "true",
            className: (0, $gMc0m.default)([
                $b84c4cb49dedd5e2$var$styles.eyelash
            ])
        }) : null;
        $[17] = hoveredParentId;
        $[18] = isHoveringGroupList;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== formatMessage || $[21] !== groupedSuggestionsWithTitles || $[22] !== previewParentId || $[23] !== selectedItems || $[24] !== spaceId) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewGroupsSection,
            testId: "review-content-suggestions-modal-preview-groups-section"
        }, [
            ...groupedSuggestionsWithTitles.entries()
        ].filter((t11)=>{
            const [, t12] = t11;
            const { suggestions: groupSuggestions } = t12;
            return groupSuggestions.some((s)=>selectedItems.has(s.id));
        }).map((t13)=>{
            const [parentId, t14] = t13;
            const { parentTitle: parentTitle, suggestions: groupSuggestions_0 } = t14;
            const isFolderExpanded = previewParentId === parentId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                key: parentId,
                xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.previewFolderPreview)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$PreviewFolderHeader, {
                title: parentTitle || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled),
                itemCount: groupSuggestions_0.length,
                isFolderExpanded: isFolderExpanded
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.previewFolderBody, $b84c4cb49dedd5e2$var$styles.previewFolderBodyIndented, isFolderExpanded && $b84c4cb49dedd5e2$var$styles.previewFolderBodyExpanded)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                space: "space.050",
                xcss: $b84c4cb49dedd5e2$var$styles.previewSuggestionList
            }, groupSuggestions_0.filter((s_0)=>selectedItems.has(s_0.id)).slice(0, $b84c4cb49dedd5e2$var$PREVIEW_ITEM_COUNT).map((suggestion)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$PreviewSuggestionRow, {
                    key: suggestion.id,
                    suggestion: suggestion,
                    spaceId: spaceId
                })))));
        }));
        $[20] = formatMessage;
        $[21] = groupedSuggestionsWithTitles;
        $[22] = previewParentId;
        $[23] = selectedItems;
        $[24] = spaceId;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10 || $[27] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.eyelashWrapper
        }, t9, t10);
        $[26] = t10;
        $[27] = t9;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    let t13;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarLong
        }));
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarFull
        });
        $[29] = t12;
        $[30] = t13;
    } else {
        t12 = $[29];
        t13 = $[30];
    }
    let t14;
    let t15;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarLong
        }));
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarFull
        });
        $[31] = t14;
        $[32] = t15;
    } else {
        t14 = $[31];
        t15 = $[32];
    }
    let t16;
    let t17;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarLong
        }));
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarFull
        });
        $[33] = t16;
        $[34] = t17;
    } else {
        t16 = $[33];
        t17 = $[34];
    }
    let t18;
    let t19;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarLong
        }));
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarFull
        });
        $[35] = t18;
        $[36] = t19;
    } else {
        t18 = $[35];
        t19 = $[36];
    }
    let t20;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderSection,
            testId: "review-content-suggestions-modal-preview-placeholder-section"
        }, t12, t13, t14, t15, t16, t17, t18, t19, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderDot
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarLong
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPlaceholderBarFull
        }));
        $[37] = t20;
    } else t20 = $[37];
    let t21;
    if ($[38] !== t11) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewPanelContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.previewCard
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100",
            xcss: $b84c4cb49dedd5e2$var$styles.previewFoldersList
        }, t8, t11, t20)));
        $[38] = t11;
        $[39] = t21;
    } else t21 = $[39];
    let t22;
    if ($[40] !== t21 || $[41] !== t7) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.rightPanel
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.container
        }, t7, t21));
        $[40] = t21;
        $[41] = t7;
        $[42] = t22;
    } else t22 = $[42];
    return t22;
};
const $b84c4cb49dedd5e2$export$8a4b505874e89d07 = ({ groups: groups, spaceKey: spaceKey, spaceName: spaceName, spaceId: spaceId, iconPath: iconPath, onClose: onClose, onSaveSuccess: onSaveSuccess, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [suggestionOverrides, setSuggestionOverrides] = (0, $42omo.useState)(()=>new Map());
    const allSuggestions = (0, $42omo.useMemo)(()=>groups.flatMap((g)=>g.remoteObjects).map((s)=>{
            const override = suggestionOverrides.get(s.id);
            return override ? {
                ...s,
                ...override
            } : s;
        }), [
        groups,
        suggestionOverrides
    ]);
    const stackedIconUrls = (0, $42omo.useMemo)(()=>Array.from(new Set(allSuggestions.map((s_0)=>(0, $9f5abb833c441bee$export$82cacbc9ddf6b54e)(s_0.url)).filter(Boolean))), [
        allSuggestions
    ]);
    const [expandedGroups, setExpandedGroups] = (0, $42omo.useState)(()=>new Set());
    const [selectedItems, setSelectedItems] = (0, $42omo.useState)(()=>new Set(allSuggestions.map((s_1)=>s_1.id)));
    const [isHoveringGroupList, setIsHoveringGroupList] = (0, $42omo.useState)(false);
    const [hoveredParentId, setHoveredParentId] = (0, $42omo.useState)(null);
    const [previewParentId, setPreviewParentId] = (0, $42omo.useState)(groups[0]?.parentId);
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const parentIds = (0, $42omo.useMemo)(()=>{
        const overriddenIds = [
            ...suggestionOverrides.values()
        ].map((o)=>String(o.parentId));
        return [
            ...new Set([
                ...groups.map((g_0)=>String(g_0.parentId)),
                ...overriddenIds
            ])
        ];
    }, [
        groups,
        suggestionOverrides
    ]);
    const { titlesByContentId: titlesByContentId, isLoading: isLoadingTitles } = (0, $d765c8713688ab6e$export$7610585fadab893e)(parentIds);
    const { submitActions: submitActions } = (0, $3b31958c77e1b16d$export$c9239e53ef385494)({
        spaceKey: spaceKey,
        flags: flags
    });
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { unauthenticatedServices: thirdPartyUnauthenticatedServices, isLoading: isLoadingThirdPartyAuth, refetch: refetchThirdPartyAuth } = (0, $06f9e66a9eacf0bf$export$3d6949c2295aff10)({
        products: (0, $9f5abb833c441bee$export$fcdafa222e2a08e2),
        cloudId: cloudId ?? ''
    });
    const isLoading = isLoadingTitles || isSubmitting || isLoadingThirdPartyAuth;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const openTimestampRef = (0, $42omo.useRef)(Date.now());
    const dismissMethodRef = (0, $42omo.useRef)('close_button');
    const sourceTypes = (0, $42omo.useMemo)(()=>Array.from(new Set(allSuggestions.map((s_2)=>(0, $9f5abb833c441bee$export$39b141cbf41f04f3)(s_2.url)))), [
        allSuggestions
    ]);
    const mountValuesRef = (0, $42omo.useRef)({
        spaceId: spaceId,
        suggestionCount: allSuggestions.length,
        sourceTypes: sourceTypes,
        renderedSuggestions: allSuggestions.map((s_3, rankIndex)=>({
                suggestionId: s_3.id,
                sourceType: (0, $9f5abb833c441bee$export$39b141cbf41f04f3)(s_3.url),
                rankIndex: rankIndex,
                suggestedParentId: s_3.parentId
            })),
        createAnalyticsEvent: createAnalyticsEvent
    });
    (0, $42omo.useEffect)(()=>{
        const { spaceId: si, suggestionCount: sc, sourceTypes: st, renderedSuggestions: rs, createAnalyticsEvent: cae } = mountValuesRef.current;
        cae({
            type: 'sendScreenEvent',
            data: {
                name: 'curationModule',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    suggestionCount: sc,
                    sourceTypes: st
                }
            }
        }).fire();
        cae({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'suggestions',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    suggestions: rs
                }
            }
        }).fire();
    }, []);
    (0, $42omo.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === 'Escape') dismissMethodRef.current = 'escape';
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, []);
    const handleClose = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationModule',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    suggestionCountAtDismiss: allSuggestions.length,
                    dismissMethod: dismissMethodRef.current,
                    timeInModuleMs: Date.now() - openTimestampRef.current
                }
            }
        }).fire();
        dismissMethodRef.current = 'close_button';
        onClose();
    };
    const handleAdd = async ()=>{
        setIsSubmitting(true);
        try {
            const ok = await submitActions(allSuggestions, selectedItems);
            if (ok) {
                const suggestionAcceptancePayload = (s)=>({
                        suggestionId: s.id,
                        sourceType: (0, $9f5abb833c441bee$export$39b141cbf41f04f3)(s.url),
                        targetFolderId: s.parentId,
                        folderWasRecommended: true
                    }); // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                const acceptedSuggestions = allSuggestions.filter((s)=>selectedItems.has(s.id)).map(suggestionAcceptancePayload); // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                const dismissedSuggestions = allSuggestions.filter((s)=>!selectedItems.has(s.id)).map(suggestionAcceptancePayload);
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'accepted',
                        actionSubject: 'suggestions',
                        source: 'containerNavigation',
                        attributes: {
                            spaceId: spaceId,
                            count: acceptedSuggestions.length,
                            acceptedSuggestions: acceptedSuggestions,
                            dismissedSuggestions: dismissedSuggestions
                        }
                    }
                }).fire();
                await onSaveSuccess();
            }
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleMoveSuggestion = (0, $42omo.useCallback)((suggestionId, newParentId)=>{
        setSuggestionOverrides((prev)=>new Map(prev).set(suggestionId, {
                parentId: newParentId
            }));
        setExpandedGroups((prev_0)=>new Set(prev_0).add(newParentId));
        setPreviewParentId(newParentId);
    }, []);
    const groupedSuggestionsWithTitles = (0, $42omo.useMemo)(()=>{
        const originalGroups = new Map();
        const newGroups = new Map();
        const originalParentIds = new Set(groups.map((g_1)=>g_1.parentId));
        allSuggestions.forEach((suggestion)=>{
            const pid = suggestion.parentId;
            const isNewGroup = !originalParentIds.has(pid);
            const target = isNewGroup ? newGroups : originalGroups;
            const existing = target.get(pid);
            if (existing) target.set(pid, {
                ...existing,
                suggestions: [
                    ...existing.suggestions,
                    suggestion
                ]
            });
            else target.set(pid, {
                parentTitle: titlesByContentId.get(String(pid)) ?? '',
                suggestions: [
                    suggestion
                ]
            });
        });
        return new Map([
            ...originalGroups.entries(),
            ...newGroups.entries()
        ]);
    }, [
        allSuggestions,
        titlesByContentId,
        groups
    ]);
    (0, $42omo.useEffect)(()=>{
        if (previewParentId === undefined || groups.length === 0) {
            setPreviewParentId(groups[0]?.parentId);
            return;
        }
        if (!groupedSuggestionsWithTitles.has(previewParentId)) setPreviewParentId(groups[0]?.parentId);
    }, [
        groups,
        previewParentId,
        groupedSuggestionsWithTitles
    ]);
    const handleGroupHoverChange = (parentId, isHovering)=>{
        setIsHoveringGroupList(isHovering);
        setHoveredParentId(isHovering ? parentId : null);
        if (isHovering) setPreviewParentId(parentId);
    };
    const toggleExpand = (parentId_0)=>{
        setExpandedGroups((prev_1)=>{
            const next = new Set(prev_1);
            if (next.has(parentId_0)) next.delete(parentId_0);
            else next.add(parentId_0);
            return next;
        });
    };
    const toggleSelectItem = (itemId)=>{
        setSelectedItems((prev_2)=>{
            const next_0 = new Set(prev_2);
            if (next_0.has(itemId)) next_0.delete(itemId);
            else next_0.add(itemId);
            return next_0;
        });
    };
    const toggleSelectGroup = (groupSuggestions)=>{
        const allSelected = groupSuggestions.every((s_4)=>selectedItems.has(s_4.id));
        setSelectedItems((prev_3)=>{
            const next_1 = new Set(prev_3);
            groupSuggestions.forEach((s_5)=>{
                if (allSelected) next_1.delete(s_5.id);
                else next_1.add(s_5.id);
            });
            return next_1;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: handleClose,
        width: "x-large"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.loadingOverlay,
        testId: "review-content-suggestions-modal-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        label: isSubmitting ? formatMessage($b84c4cb49dedd5e2$var$i18n.submitting) : formatMessage($b84c4cb49dedd5e2$var$i18n.loading)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.layout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.leftPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.stackedContentTypeIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
        iconUrls: stackedIconUrls,
        variant: "large",
        tilted: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, formatMessage($b84c4cb49dedd5e2$var$i18n.bringTogetherTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, formatMessage($b84c4cb49dedd5e2$var$i18n.bringTogetherDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b84c4cb49dedd5e2$var$styles.groupListScrollArea
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$ModalLeftPanel, {
        groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
        selectedItems: selectedItems,
        expandedGroups: expandedGroups,
        toggleExpand: toggleExpand,
        toggleSelectGroup: toggleSelectGroup,
        toggleSelectItem: toggleSelectItem,
        onGroupHoverChange: handleGroupHoverChange,
        onMoveSuggestion: handleMoveSuggestion,
        spaceId: spaceId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $da63555f5ab7e779$export$5c6f32e304ed3e96), {
        unauthenticatedServices: thirdPartyUnauthenticatedServices,
        onThirdPartyAuthRefetch: refetchThirdPartyAuth,
        spaceName: spaceName,
        iconPath: iconPath
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "end",
        xcss: $b84c4cb49dedd5e2$var$styles.addButtonRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: ()=>void handleAdd(),
        isDisabled: selectedItems.size === 0
    }, formatMessage($b84c4cb49dedd5e2$var$i18n.addItemsToSpace, {
        count: selectedItems.size
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$ModalRightPanel, {
        groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
        selectedItems: selectedItems,
        previewParentId: previewParentId,
        isHoveringGroupList: isHoveringGroupList,
        hoveredParentId: hoveredParentId,
        spaceName: spaceName,
        spaceId: spaceId,
        iconPath: iconPath
    })));
};
const $b84c4cb49dedd5e2$export$c9ce09b966ffa4f7 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t0
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$export$8a4b505874e89d07, {
                ...props,
                flags: flags
            }));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
function $b84c4cb49dedd5e2$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $b84c4cb49dedd5e2$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}








const $d3bfb9815ee47511$export$b1532bcf7c9b2548 = (spaceKey)=>{
    const [groups, setGroups] = (0, $42omo.useState)([]);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const refetch = (0, $42omo.useCallback)(async ()=>{
        if (!spaceKey) {
            setGroups([]);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions`, {
                method: 'GET'
            });
            const data = await response.json();
            setGroups(data.suggestions ?? []);
        } catch  {
        // Silently fail — card won't render if there are no suggestions
        } finally{
            setIsLoading(false);
        }
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    return {
        groups: groups,
        isLoading: isLoading,
        refetch: refetch
    };
};















































const $e2f9c8125fdf9a13$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _1yt4utpp _bfhki8nm _19pku2gc _kqswh2mm",
    topRow: "_1e0c1txw _4cvr1y6m _1bah1yb4 _otyr1b66",
    iconsWrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    mainAction: "_zulp1b66 _1yt4ze3t _1e0c1txw _2lx21bp4 _4cvr1y6m _bfhk1j28 _1bsb1osq _y3gnv2br",
    dismissButton: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk1j28 _irr31j28"
};
const $e2f9c8125fdf9a13$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "side-navigation.space-navigation.third-party-auth.title",
        defaultMessage: "Get all your content within reach"
    },
    subtitle: {
        id: "side-navigation.space-navigation.third-party-auth.subtitle",
        defaultMessage: "Connect apps for smarter results and suggestions."
    },
    beta: {
        id: "side-navigation.space-navigation.third-party-auth.beta",
        defaultMessage: "Beta"
    },
    connect: {
        id: "side-navigation.space-navigation.third-party-auth.connect",
        defaultMessage: "Connect"
    },
    dismiss: {
        id: "side-navigation.space-navigation.third-party-auth.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $e2f9c8125fdf9a13$export$55683e4280ace85d = (t0)=>{
    const $ = (0, $frIzR.c)(64);
    const { unauthenticatedServices: unauthenticatedServices, onThirdPartyAuthRefetch: onThirdPartyAuthRefetch, spaceName: spaceName, spaceId: spaceId, iconPath: iconPath } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const hasFiredRenderedRef = (0, $42omo.useRef)(false);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== unauthenticatedServices) {
        t1 = Object.keys(unauthenticatedServices);
        $[0] = unauthenticatedServices;
        $[1] = t1;
    } else t1 = $[1];
    const eligibleConnectors = t1;
    let t2;
    if ($[2] !== eligibleConnectors) {
        t2 = eligibleConnectors.map($e2f9c8125fdf9a13$var$_temp);
        $[2] = eligibleConnectors;
        $[3] = t2;
    } else t2 = $[3];
    const iconUrls = t2;
    let t3;
    if ($[4] !== isVisible || $[5] !== spaceKey) {
        t3 = !(0, $1I9Gw.isPersonalSpace)(spaceKey) && isVisible;
        $[4] = isVisible;
        $[5] = spaceKey;
        $[6] = t3;
    } else t3 = $[6];
    const isRendered = t3;
    let t4;
    let t5;
    if ($[7] !== createAnalyticsEvent || $[8] !== eligibleConnectors || $[9] !== isRendered || $[10] !== spaceId) {
        t4 = ()=>{
            if (isRendered && spaceId && !hasFiredRenderedRef.current) {
                hasFiredRenderedRef.current = true;
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "rendered",
                        actionSubject: "curationEntry",
                        source: "containerNavigation",
                        attributes: {
                            spaceId: spaceId,
                            entryPoint: "authEntry",
                            suggestionCount: 0,
                            eligibleConnectors: eligibleConnectors
                        }
                    }
                }).fire();
            }
        };
        t5 = [
            isRendered,
            spaceId,
            eligibleConnectors,
            createAnalyticsEvent
        ];
        $[7] = createAnalyticsEvent;
        $[8] = eligibleConnectors;
        $[9] = isRendered;
        $[10] = spaceId;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== spaceId) {
        t6 = ()=>{
            if (spaceId) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "dismissed",
                    actionSubject: "curationEntry",
                    source: "containerNavigation",
                    attributes: {
                        spaceId: spaceId,
                        entryPoint: "authEntry",
                        dismissMethod: "close_button"
                    }
                }
            }).fire();
            setIsVisible(false);
        };
        $[13] = createAnalyticsEvent;
        $[14] = spaceId;
        $[15] = t6;
    } else t6 = $[15];
    const handleDismiss = t6;
    let t7;
    if ($[16] !== onThirdPartyAuthRefetch) {
        t7 = ()=>{
            setIsModalOpen(false);
            onThirdPartyAuthRefetch();
        };
        $[16] = onThirdPartyAuthRefetch;
        $[17] = t7;
    } else t7 = $[17];
    const handleAuthModalClose = t7;
    if ((0, $1I9Gw.isPersonalSpace)(spaceKey) || !isVisible) return null;
    let t8;
    if ($[18] !== iconUrls) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.iconsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            iconUrls: iconUrls
        }));
        $[18] = iconUrls;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== intl) {
        t9 = intl.formatMessage($e2f9c8125fdf9a13$var$i18n.dismiss);
        $[20] = intl;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== handleDismiss || $[23] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.dismissButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: $e2f9c8125fdf9a13$var$_temp2,
            appearance: "subtle",
            spacing: "compact",
            label: t9,
            onClick: handleDismiss,
            isTooltipDisabled: false
        }));
        $[22] = handleDismiss;
        $[23] = t9;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== t10 || $[26] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.topRow
        }, t8, t10);
        $[25] = t10;
        $[26] = t8;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>setIsModalOpen(true);
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== intl) {
        t13 = intl.formatMessage($e2f9c8125fdf9a13$var$i18n.title);
        $[29] = intl;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== intl) {
        t14 = intl.formatMessage($e2f9c8125fdf9a13$var$i18n.beta);
        $[31] = intl;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "discovery"
        }, t14);
        $[33] = t14;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== t13 || $[36] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t13, " ", t15);
        $[35] = t13;
        $[36] = t15;
        $[37] = t16;
    } else t16 = $[37];
    let t17;
    if ($[38] !== intl) {
        t17 = intl.formatMessage($e2f9c8125fdf9a13$var$i18n.subtitle);
        $[38] = intl;
        $[39] = t17;
    } else t17 = $[39];
    let t18;
    if ($[40] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, t17);
        $[40] = t17;
        $[41] = t18;
    } else t18 = $[41];
    let t19;
    if ($[42] !== intl) {
        t19 = intl.formatMessage($e2f9c8125fdf9a13$var$i18n.connect);
        $[42] = intl;
        $[43] = t19;
    } else t19 = $[43];
    let t20;
    if ($[44] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            spacing: "compact"
        }, t19);
        $[44] = t19;
        $[45] = t20;
    } else t20 = $[45];
    let t21;
    if ($[46] !== t16 || $[47] !== t18 || $[48] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.mainAction,
            onClick: t12
        }, t16, t18, t20);
        $[46] = t16;
        $[47] = t18;
        $[48] = t20;
        $[49] = t21;
    } else t21 = $[49];
    let t22;
    if ($[50] !== t11 || $[51] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e2f9c8125fdf9a13$var$styles.container,
            testId: "space-navigation-third-party-auth"
        }, t11, t21);
        $[50] = t11;
        $[51] = t21;
        $[52] = t22;
    } else t22 = $[52];
    let t23;
    if ($[53] !== handleAuthModalClose || $[54] !== iconPath || $[55] !== isModalOpen || $[56] !== spaceName || $[57] !== unauthenticatedServices) {
        t23 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5992b073ef8023fa$export$adba184288a85068), {
            unauthenticatedServices: unauthenticatedServices,
            onClose: handleAuthModalClose,
            spaceName: spaceName,
            iconPath: iconPath
        });
        $[53] = handleAuthModalClose;
        $[54] = iconPath;
        $[55] = isModalOpen;
        $[56] = spaceName;
        $[57] = unauthenticatedServices;
        $[58] = t23;
    } else t23 = $[58];
    let t24;
    if ($[59] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t23);
        $[59] = t23;
        $[60] = t24;
    } else t24 = $[60];
    let t25;
    if ($[61] !== t22 || $[62] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t22, t24);
        $[61] = t22;
        $[62] = t24;
        $[63] = t25;
    } else t25 = $[63];
    return t25;
};
function $e2f9c8125fdf9a13$var$_temp(service) {
    return (0, $9f5abb833c441bee$export$defe15004d994007)[service];
}
function $e2f9c8125fdf9a13$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        ...iconProps,
        size: "small"
    });
}


const $e69b9564388a8a7c$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _1yt4utpp _bfhki8nm _19pku2gc _kqswh2mm",
    topRow: "_1e0c1txw _4cvr1y6m _1bah1yb4 _otyr1b66",
    iconsWrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    mainAction: "_zulp1b66 _1yt4ze3t _1e0c1txw _2lx21bp4 _4cvr1y6m _bfhk1j28 _1bsb1osq _y3gnv2br",
    addContentButton: "_2rko12b0 _1rjc1b66 _18zru2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _19pku2gc _1e0c116y _4cvr1h6o _bfhki8nm _irr3plhp",
    dismissButton: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk1j28 _irr31j28"
};
const $e69b9564388a8a7c$var$i18n = (0, $aXWIB.defineMessages)({
    addContent: {
        id: "side-navigation.space-navigation.related-content.add-content",
        defaultMessage: "Add content that matters here"
    },
    addContentSubtitle: {
        id: "side-navigation.space-navigation.related-content.add-content-subtitle",
        defaultMessage: "Get organized with relevant files from your apps."
    },
    dismiss: {
        id: "side-navigation.space-navigation.related-content.dismiss",
        defaultMessage: "Dismiss"
    },
    beta: {
        id: "side-navigation.space-navigation.related-content.beta",
        defaultMessage: "Beta"
    },
    addContentAction: {
        id: "side-navigation.space-navigation.related-content.add-content-action",
        defaultMessage: "Review and add"
    }
});
const $e69b9564388a8a7c$var$SpaceNavigationRelatedContentBody = (t0)=>{
    const $ = (0, $frIzR.c)(60);
    const { spaceKey: spaceKey, suggestionCount: suggestionCount, iconUrls: iconUrls, groups: groups, refetch: refetch, onDismiss: onDismiss, spaceName: spaceName, spaceId: spaceId, iconPath: iconPath } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const pageTreeStateUpdaterRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== spaceId || $[2] !== suggestionCount) {
        t1 = {
            spaceId: spaceId,
            suggestionCount: suggestionCount,
            createAnalyticsEvent: createAnalyticsEvent
        };
        $[0] = createAnalyticsEvent;
        $[1] = spaceId;
        $[2] = suggestionCount;
        $[3] = t1;
    } else t1 = $[3];
    const mountValuesRef = (0, $42omo.useRef)(t1);
    let t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const { spaceId: si, suggestionCount: sc, createAnalyticsEvent: cae } = mountValuesRef.current;
            cae({
                type: "sendUIEvent",
                data: {
                    action: "rendered",
                    actionSubject: "curationEntry",
                    source: "containerNavigation",
                    attributes: {
                        spaceId: si,
                        entryPoint: "suggestionsEntry",
                        suggestionCount: sc
                    }
                }
            }).fire();
        };
        t3 = [];
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[6] !== createAnalyticsEvent || $[7] !== onDismiss || $[8] !== spaceId || $[9] !== suggestionCount) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "dismissed",
                    actionSubject: "curationEntry",
                    source: "containerNavigation",
                    attributes: {
                        spaceId: spaceId,
                        entryPoint: "suggestionsEntry",
                        dismissMethod: "close_button",
                        suggestionCountAtDismiss: suggestionCount
                    }
                }
            }).fire();
            onDismiss();
        };
        $[6] = createAnalyticsEvent;
        $[7] = onDismiss;
        $[8] = spaceId;
        $[9] = suggestionCount;
        $[10] = t4;
    } else t4 = $[10];
    const handleDismiss = t4;
    let t5;
    if ($[11] !== iconUrls) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.iconsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            iconUrls: iconUrls
        }));
        $[11] = iconUrls;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== intl) {
        t6 = intl.formatMessage($e69b9564388a8a7c$var$i18n.dismiss);
        $[13] = intl;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== handleDismiss || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.dismissButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: $e69b9564388a8a7c$var$_temp,
            appearance: "subtle",
            spacing: "compact",
            label: t6,
            onClick: handleDismiss,
            isTooltipDisabled: false
        }));
        $[15] = handleDismiss;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t5 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.topRow
        }, t5, t7);
        $[18] = t5;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>setIsModalOpen(true);
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== intl) {
        t10 = intl.formatMessage($e69b9564388a8a7c$var$i18n.addContent);
        $[22] = intl;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== intl) {
        t11 = intl.formatMessage($e69b9564388a8a7c$var$i18n.beta);
        $[24] = intl;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "discovery"
        }, t11);
        $[26] = t11;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== t10 || $[29] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t10, " ", t12);
        $[28] = t10;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== intl) {
        t14 = intl.formatMessage($e69b9564388a8a7c$var$i18n.addContentSubtitle);
        $[31] = intl;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, t14);
        $[33] = t14;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== intl) {
        t16 = intl.formatMessage($e69b9564388a8a7c$var$i18n.addContentAction);
        $[35] = intl;
        $[36] = t16;
    } else t16 = $[36];
    let t17;
    if ($[37] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            spacing: "compact"
        }, t16);
        $[37] = t16;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== t13 || $[40] !== t15 || $[41] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e69b9564388a8a7c$var$styles.mainAction,
            onClick: t9
        }, t13, t15, t17);
        $[39] = t13;
        $[40] = t15;
        $[41] = t17;
        $[42] = t18;
    } else t18 = $[42];
    let t19;
    if ($[43] !== t18 || $[44] !== t8) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.container,
            testId: "space-navigation-related-content"
        }, t8, t18);
        $[43] = t18;
        $[44] = t8;
        $[45] = t19;
    } else t19 = $[45];
    let t20;
    if ($[46] !== groups || $[47] !== iconPath || $[48] !== isModalOpen || $[49] !== refetch || $[50] !== spaceId || $[51] !== spaceKey || $[52] !== spaceName) {
        t20 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b84c4cb49dedd5e2$export$c9ce09b966ffa4f7), {
            spaceName: spaceName,
            iconPath: iconPath,
            groups: groups,
            spaceKey: spaceKey,
            spaceId: spaceId,
            onClose: ()=>setIsModalOpen(false),
            onSaveSuccess: async ()=>{
                await refetch();
                setIsModalOpen(false);
                if (pageTreeStateUpdaterRef.current && groups[0]?.parentId) pageTreeStateUpdaterRef.current.setForceFetchPageId(String(groups[0].parentId));
            }
        });
        $[46] = groups;
        $[47] = iconPath;
        $[48] = isModalOpen;
        $[49] = refetch;
        $[50] = spaceId;
        $[51] = spaceKey;
        $[52] = spaceName;
        $[53] = t20;
    } else t20 = $[53];
    let t21;
    if ($[54] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t20);
        $[54] = t20;
        $[55] = t21;
    } else t21 = $[55];
    let t22;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>{
            pageTreeStateUpdaterRef.current = pageTreeStateUpdater;
            return null;
        });
        $[56] = t22;
    } else t22 = $[56];
    let t23;
    if ($[57] !== t19 || $[58] !== t21) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t19, t21, t22);
        $[57] = t19;
        $[58] = t21;
        $[59] = t23;
    } else t23 = $[59];
    return t23;
};
const $e69b9564388a8a7c$export$8372b97ddec977cb = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { spaceName: spaceName, spaceId: spaceId, iconPath: iconPath } = t0;
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { groups: groups, isLoading: isLoadingSuggestions, refetch: refetch } = (0, $d3bfb9815ee47511$export$b1532bcf7c9b2548)(spaceKey);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== cloudId) {
        t1 = {
            products: (0, $9f5abb833c441bee$export$fcdafa222e2a08e2),
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    const { unauthenticatedServices: unauthenticatedServices, isLoading: isLoadingThirdPartyAuth, refetch: refetchThirdPartyAuth } = (0, $06f9e66a9eacf0bf$export$3d6949c2295aff10)(t1);
    let t2;
    if ($[2] !== groups) {
        t2 = groups.reduce($e69b9564388a8a7c$var$_temp2, 0);
        $[2] = groups;
        $[3] = t2;
    } else t2 = $[3];
    const suggestionCount = t2;
    let t3;
    if ($[4] !== groups) {
        t3 = Array.from(new Set(groups.flatMap($e69b9564388a8a7c$var$_temp3).map($e69b9564388a8a7c$var$_temp4).filter($e69b9564388a8a7c$var$_temp5)));
        $[4] = groups;
        $[5] = t3;
    } else t3 = $[5];
    const iconUrls = t3;
    if (!isLoadingSuggestions && !isLoadingThirdPartyAuth && groups.length === 0 && Object.keys(unauthenticatedServices).length != 0) {
        let t4;
        if ($[6] !== iconPath || $[7] !== refetchThirdPartyAuth || $[8] !== spaceId || $[9] !== spaceName || $[10] !== unauthenticatedServices) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e2f9c8125fdf9a13$export$55683e4280ace85d), {
                unauthenticatedServices: unauthenticatedServices,
                onThirdPartyAuthRefetch: refetchThirdPartyAuth,
                spaceName: spaceName,
                spaceId: spaceId,
                iconPath: iconPath
            });
            $[6] = iconPath;
            $[7] = refetchThirdPartyAuth;
            $[8] = spaceId;
            $[9] = spaceName;
            $[10] = unauthenticatedServices;
            $[11] = t4;
        } else t4 = $[11];
        return t4;
    }
    if (!spaceKey || (0, $1I9Gw.isPersonalSpace)(spaceKey) || !isVisible || isLoadingSuggestions || groups.length === 0) return null;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsVisible(false);
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== groups || $[14] !== iconPath || $[15] !== iconUrls || $[16] !== refetch || $[17] !== spaceId || $[18] !== spaceKey || $[19] !== spaceName || $[20] !== suggestionCount) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e69b9564388a8a7c$var$SpaceNavigationRelatedContentBody, {
            spaceKey: spaceKey,
            suggestionCount: suggestionCount,
            iconUrls: iconUrls,
            groups: groups,
            refetch: refetch,
            onDismiss: t4,
            spaceName: spaceName,
            spaceId: spaceId,
            iconPath: iconPath
        });
        $[13] = groups;
        $[14] = iconPath;
        $[15] = iconUrls;
        $[16] = refetch;
        $[17] = spaceId;
        $[18] = spaceKey;
        $[19] = spaceName;
        $[20] = suggestionCount;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
};
function $e69b9564388a8a7c$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        ...iconProps,
        size: "small"
    });
}
function $e69b9564388a8a7c$var$_temp2(total, group) {
    return total + group.remoteObjects.length;
}
function $e69b9564388a8a7c$var$_temp3(g) {
    return g.remoteObjects;
}
function $e69b9564388a8a7c$var$_temp4(s) {
    return (0, $9f5abb833c441bee$export$82cacbc9ddf6b54e)(s.url);
}
function $e69b9564388a8a7c$var$_temp5(url) {
    return Boolean(url);
}


const $72da3bb5b7695f3e$export$7716f65eb5d1a3fd = (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { showShortcutsSection: showShortcutsSection, space: space, spaceKey: spaceKey, quick: quick, homepageId: homepageId, loading: loading, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, onContentTreeLoadComplete: onContentTreeLoadComplete, spaceName: spaceName, iconPath: iconPath } = t0;
    let t1;
    if ($[0] !== isSpaceAdmin || $[1] !== quick || $[2] !== showShortcutsSection || $[3] !== space?.id || $[4] !== spaceKey) {
        t1 = showShortcutsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $16e27872478384c0$export$7f1bcb54a9a4d80e), {
            isSpaceAdmin: isSpaceAdmin,
            spaceKey: spaceKey,
            links: quick,
            spaceId: space?.id || null
        });
        $[0] = isSpaceAdmin;
        $[1] = quick;
        $[2] = showShortcutsSection;
        $[3] = space?.id;
        $[4] = spaceKey;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== homepageId || $[7] !== iconPath || $[8] !== isBlogNavigation || $[9] !== loading || $[10] !== onContentTreeLoadComplete || $[11] !== onDragDropSuccess || $[12] !== pageTreeFinishedLoading || $[13] !== space?.didContainUserContent || $[14] !== space?.id || $[15] !== spaceKey || $[16] !== spaceName) {
        t2 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": "pageTree",
            "data-testid": "pageTree",
            onMouseEnter: (0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) ? undefined : (0, $3qtLb.PageTreeLoaderOnHover).hydrateOnHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a12275e9873d32f$export$5bb6552a789f7a6f), {
            key: spaceKey,
            homepageId: homepageId,
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isBlogNavigation,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            spaceHasUserContent: space?.didContainUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            relatedContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e69b9564388a8a7c$export$8372b97ddec977cb), {
                spaceName: spaceName,
                spaceId: space?.id,
                iconPath: iconPath
            })
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[6] = homepageId;
        $[7] = iconPath;
        $[8] = isBlogNavigation;
        $[9] = loading;
        $[10] = onContentTreeLoadComplete;
        $[11] = onDragDropSuccess;
        $[12] = pageTreeFinishedLoading;
        $[13] = space?.didContainUserContent;
        $[14] = space?.id;
        $[15] = spaceKey;
        $[16] = spaceName;
        $[17] = t2;
    } else t2 = $[17];
    let t3;
    if ($[18] !== blogsHidden || $[19] !== loading || $[20] !== pageTreeFinishedLoading || $[21] !== spaceKey) {
        t3 = !loading && !blogsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2956b96ada85ef60$export$a2e535ad780a85fe), {
            spaceKey: spaceKey,
            pageTreeFinishedLoading: pageTreeFinishedLoading
        });
        $[18] = blogsHidden;
        $[19] = loading;
        $[20] = pageTreeFinishedLoading;
        $[21] = spaceKey;
        $[22] = t3;
    } else t3 = $[22];
    let t4;
    if ($[23] !== t1 || $[24] !== t2 || $[25] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2, t3);
        $[23] = t1;
        $[24] = t2;
        $[25] = t3;
        $[26] = t4;
    } else t4 = $[26];
    return t4;
};















var $1Zr9M = parcelRequire("1Zr9M");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");





var $3gadb = parcelRequire("3gadb");


var $jZM59 = parcelRequire("jZM59");








var $9x2sR = parcelRequire("9x2sR");








var $hXDOc = parcelRequire("hXDOc");


var $1NBp8 = parcelRequire("1NBp8");


var $eWwvy = parcelRequire("eWwvy");





var $dPJCf = parcelRequire("dPJCf");














var $jrref = parcelRequire("jrref");




var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $aG6kF = parcelRequire("aG6kF");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");





var $3SChL = parcelRequire("3SChL");


var $3Awqk = parcelRequire("3Awqk");


var $2AgON = parcelRequire("2AgON");


var $35Nok = parcelRequire("35Nok");

var $5ecc3f8934f85e59$exports = {};
$5ecc3f8934f85e59$exports = new URL("Spaces.5611c4bd.gif", import.meta.url).toString();


var $db1162a25db39e60$exports = {};
$db1162a25db39e60$exports = new URL("Spaces-dark.4ceec6cd.gif", import.meta.url).toString();


var $537a412b2964f6f0$exports = {};
$537a412b2964f6f0$exports = new URL("Spaces-placeholder.5b3f2999.png", import.meta.url).toString();


var $a4e38a378b5824d3$exports = {};
$a4e38a378b5824d3$exports = new URL("Spaces-placeholder-dark.1c1d1b34.png", import.meta.url).toString();


const $f37e6d818dab503c$var$STEP_ID = 'nth-user-orientation-editor-space-spotlight';
const $f37e6d818dab503c$export$febddff29c5b0caa = ({ children: children })=>{
    const { reset: reset, next: next, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($f37e6d818dab503c$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isVisible = currentStep === $f37e6d818dab503c$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($5ecc3f8934f85e59$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($db1162a25db39e60$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($537a412b2964f6f0$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($a4e38a378b5824d3$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $f37e6d818dab503c$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrref.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        dismiss: handleDismiss,
        next: handleNext,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $f37e6d818dab503c$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: $f37e6d818dab503c$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next)))));
        return (0, $dh538.fg)('platform-dst-motion-uplift') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, spotlightCard));
    })())));
};












var $euUgw = parcelRequire("euUgw");







var $dcJ7R = parcelRequire("dcJ7R");









var $eGUIL = parcelRequire("eGUIL");

const $39cc7021b1f9471a$export$c915848be66d4457 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { showExCoMessaging: t1 } = t0;
    const showExCoMessaging = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { handleScrollToTop: handleScrollToTop } = (0, $eGUIL.useSideNavigation)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleScrollToTop) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "QuickAccess",
                    source: "spaceNavigation",
                    data: {
                        navigationLayer: "global",
                        navigationContainer: "sidebar",
                        navVersion: "4"
                    }
                }
            }).fire();
            handleScrollToTop();
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleScrollToTop;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    const t3 = showExCoMessaging && $39cc7021b1f9471a$var$additionalOffset;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $39cc7021b1f9471a$var$pressableStyles,
            $39cc7021b1f9471a$var$stickyWrapper,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            borderColor: "transparent"
        };
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050",
            alignInline: "center",
            alignBlock: "center"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            align: "center",
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $39cc7021b1f9471a$var$i18n.scrollToTopButtonLabel)));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== onClick || $[9] !== t4) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: t4,
            id: "scroll-to-top-button",
            onClick: onClick,
            style: t5
        }, t7);
        $[8] = onClick;
        $[9] = t4;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $39cc7021b1f9471a$var$offsetElement
        });
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t9);
        $[12] = t8;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
};
const $39cc7021b1f9471a$var$offsetElement = (0, $ecnYn.xcss)({
    //this element keeps the spacing from he negative top margin tha hides the button
    height: '17px',
    width: `100%`,
    display: 'flex'
});
const $39cc7021b1f9471a$var$additionalOffset = (0, $ecnYn.xcss)({
    top: `76px`
});
const $39cc7021b1f9471a$var$stickyWrapper = (0, $ecnYn.xcss)({
    zIndex: 'card',
    // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
    display: 'flex',
    position: 'sticky',
    top: `62px`,
    // @ts-ignore not assignable to type 'MarginSpace | GlobalValue | undefined'
    marginTop: `-50px`,
    //this hides the button underneath the space header until the ser scrolls down
    marginLeft: `auto`,
    marginRight: 'auto'
});
const $39cc7021b1f9471a$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'radius.full',
    paddingInline: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    width: '125px',
    height: '32px',
    flexShrink: '0',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    },
    ':focus': {
        outline: 'color.border.focused'
    }
});
const $39cc7021b1f9471a$var$i18n = (0, $aXWIB.defineMessages)({
    scrollToTopButtonLabel: {
        id: "side-navigation.global.scroll-to-top.button.label",
        defaultMessage: "Back to top"
    }
});












var $9VJDA = parcelRequire("9VJDA");


var $4kfV4 = parcelRequire("4kfV4");

















const $476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8HXE5",
    name: "LazySpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("9BZ9X"))).SpaceMoreActionsMenuContent
});

const $476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZCfkL",
    name: "LazyRestrictedSpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("9BZ9X"))).RestrictedSpaceMoreActionsMenuContent
});
const $476e0e4b3e7f33df$export$cd488ab2b367186 = (props)=>{
    const $ = (0, $frIzR.c)(20);
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props) {
        t0 = ()=>{
            props.setIsOpen(!props.isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "spaceMoreActionsMenu",
                    source: "spaceNavigation",
                    attributes: {
                        navigationLayer: "container",
                        navigationContainer: "sidebar",
                        navVersion: "4",
                        componentType: "fixedItemButton",
                        itemId: "meatballDropdown",
                        isSpaceAdmin: props.isSpaceAdmin
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    const onClick = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== props) {
        t1 = (selection)=>(e)=>{
                e.stopPropagation();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "spaceMoreActionsMenuItem",
                        source: "spaceMoreActionsMenu",
                        attributes: {
                            navigationLayer: "container",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "fixedItemAction",
                            itemId: selection,
                            isSpaceAdmin: props.isSpaceAdmin
                        }
                    }
                }).fire();
                props.setIsOpen(false);
            };
        $[3] = createAnalyticsEvent;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const onMenuItemClicked = t1;
    let t2;
    if ($[6] !== props) {
        t2 = ()=>props.setIsOpen(false);
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== isLoggedIn || $[9] !== onMenuItemClicked || $[10] !== props) {
        t3 = ()=>isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            });
        $[8] = isLoggedIn;
        $[9] = onMenuItemClicked;
        $[10] = props;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onClick || $[13] !== props) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                icon: $476e0e4b3e7f33df$var$_temp,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $476e0e4b3e7f33df$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                isSelected: props.isOpen
            }), props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "space-more-actions-menu-blanket",
                isTinted: false,
                shouldAllowClickThrough: !props.isOpen,
                onBlanketClicked: ()=>props.setIsOpen(false)
            }) : null);
        $[12] = onClick;
        $[13] = props;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== props.isOpen || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: props.isOpen,
            onClose: t2,
            content: t3,
            trigger: t4,
            placement: "right-start"
        });
        $[15] = props.isOpen;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
const $476e0e4b3e7f33df$var$i18n = (0, $aXWIB.defineMessages)({
    moreActions: {
        id: "side-navigation.space-navigation.more-actions",
        defaultMessage: "More actions"
    }
});
function $476e0e4b3e7f33df$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        ...iconProps,
        size: "small"
    });
}



const $6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6-_i-",
    loader: async ()=>(await (parcelRequire("eYQg6"))).ExternalCollaboratorsSpaceInformationMessage,
    name: 'ExternalCollaboratorsSpaceInformationMessage'
});
const $6f43a2e4204022e9$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $6f43a2e4204022e9$export$533fb76256978163 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let containsExternalCollaborators;
    let isExternalCollaborator;
    let props;
    if ($[0] !== t0) {
        ({ isExternalCollaborator: isExternalCollaborator, containsExternalCollaborators: containsExternalCollaborators, ...props } = t0);
        $[0] = t0;
        $[1] = containsExternalCollaborators;
        $[2] = isExternalCollaborator;
        $[3] = props;
    } else {
        containsExternalCollaborators = $[1];
        isExternalCollaborator = $[2];
        props = $[3];
    }
    const showExCoMessaging = !isExternalCollaborator && containsExternalCollaborators;
    let t1;
    if ($[4] !== props || $[5] !== showExCoMessaging) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            ...props,
            showExCoMessaging: showExCoMessaging
        });
        $[4] = props;
        $[5] = showExCoMessaging;
        $[6] = t1;
    } else t1 = $[6];
    const header = t1;
    return header;
};
const $6f43a2e4204022e9$var$SpaceHeaderInner = (t0)=>{
    const $ = (0, $frIzR.c)(41);
    const { spaceId: spaceId, spaceName: spaceName, spaceKey: spaceKey, homepageId: homepageId, iconPath: iconPath, isStarred: isStarred, isWatched: isWatched, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, isPersonalSpace: isPersonalSpace, showExCoMessaging: showExCoMessaging, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: hasArchiveSpacePermission } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isSelected = (0, $dPJCf.useRouteName)($6f43a2e4204022e9$var$isOnSpaceRouteArgs);
    let t1;
    if ($[0] !== homepageId || $[1] !== spaceKey) {
        t1 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }, homepageId ? {
            query: {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: homepageId
            }
        } : undefined);
        $[0] = homepageId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const spaceOverviewHref = t1;
    let t2;
    if ($[3] !== showExCoMessaging || $[4] !== spaceKey) {
        t2 = showExCoMessaging ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader, {
            analyticsSource: "spaceHeader",
            messageType: "IN_SPACE",
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            isSubtle: true
        })) : undefined;
        $[3] = showExCoMessaging;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== createAnalyticsEvent) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "spaceHeader",
                    source: "sideNavigation",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    const onClick = t3;
    const [isMoreActionsOpen, setIsMoreActionsOpen] = (0, $42omo.useState)(false);
    let t4;
    if ($[8] !== canManageSomeUsers || $[9] !== hasArchiveSpacePermission || $[10] !== hasDeleteSpacePermission || $[11] !== isMoreActionsOpen || $[12] !== isSpaceAdmin || $[13] !== isSpaceArchived || $[14] !== isStarred || $[15] !== isWatched || $[16] !== spaceId || $[17] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $476e0e4b3e7f33df$export$cd488ab2b367186), {
            isOpen: isMoreActionsOpen,
            setIsOpen: setIsMoreActionsOpen,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isStarred: isStarred,
            isWatched: isWatched,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            isSpaceArchived: isSpaceArchived,
            hasDeleteSpacePermission: hasDeleteSpacePermission,
            hasArchiveSpacePermission: hasArchiveSpacePermission
        });
        $[8] = canManageSomeUsers;
        $[9] = hasArchiveSpacePermission;
        $[10] = hasDeleteSpacePermission;
        $[11] = isMoreActionsOpen;
        $[12] = isSpaceAdmin;
        $[13] = isSpaceArchived;
        $[14] = isStarred;
        $[15] = isWatched;
        $[16] = spaceId;
        $[17] = spaceKey;
        $[18] = t4;
    } else t4 = $[18];
    const moreActionsMenu = t4;
    let t5;
    if ($[19] !== iconPath || $[20] !== isPersonalSpace || $[21] !== isSpaceAdmin || $[22] !== spaceId || $[23] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$EditableSpaceIcon, {
            spaceId: spaceId,
            spaceKey: spaceKey,
            iconPath: iconPath,
            isSpaceAdmin: isSpaceAdmin,
            isPersonalSpace: isPersonalSpace
        });
        $[19] = iconPath;
        $[20] = isPersonalSpace;
        $[21] = isSpaceAdmin;
        $[22] = spaceId;
        $[23] = spaceKey;
        $[24] = t5;
    } else t5 = $[24];
    let t6;
    if ($[25] !== description || $[26] !== isSelected || $[27] !== moreActionsMenu || $[28] !== onClick || $[29] !== spaceName || $[30] !== spaceOverviewHref || $[31] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: spaceOverviewHref,
            isSelected: isSelected,
            onClick: onClick,
            elemBefore: t5,
            actions: moreActionsMenu,
            description: description
        }, spaceName);
        $[25] = description;
        $[26] = isSelected;
        $[27] = moreActionsMenu;
        $[28] = onClick;
        $[29] = spaceName;
        $[30] = spaceOverviewHref;
        $[31] = t5;
        $[32] = t6;
    } else t6 = $[32];
    let t7;
    if ($[33] !== spaceOverviewHref || $[34] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$stickyWrapper,
            "data-vc": "Nav4-space-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f37e6d818dab503c$export$febddff29c5b0caa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$RemovedSpotlightTarget, {
            name: "nav4-spotlight-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
            name: "space-header",
            preloadUrl: spaceOverviewHref,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
        }, t6)))));
        $[33] = spaceOverviewHref;
        $[34] = t6;
        $[35] = t7;
    } else t7 = $[35];
    let t8;
    if ($[36] !== showExCoMessaging) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39cc7021b1f9471a$export$c915848be66d4457), {
            showExCoMessaging: showExCoMessaging
        });
        $[36] = showExCoMessaging;
        $[37] = t8;
    } else t8 = $[37];
    let t9;
    if ($[38] !== t7 || $[39] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t7, t8);
        $[38] = t7;
        $[39] = t8;
        $[40] = t9;
    } else t9 = $[40];
    return t9;
};
const $6f43a2e4204022e9$var$EditableSpaceIcon = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { spaceId: spaceId, spaceKey: spaceKey, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, isPersonalSpace: isPersonalSpace } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { leftSidebarState: leftSidebarState, expandLeftSidebar: expandLeftSidebar } = (0, $jZM59.usePageLayoutResize)();
    const [isDialogOpen, setIsDialogOpen] = (0, $42omo.useState)(false);
    const [shouldRenderDialog, setShouldRenderDialog] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== iconPath) {
        t1 = iconPath ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: iconPath,
            alt: "",
            "data-testid": "space-icon",
            "data-vc": "space-header-icon-image",
            "data-ssr-placeholder-ignored": true,
            role: "presentation",
            className: (0, $gMc0m.default)([
                "_2rko1qi0 _1bsb1tcg _4t3i1tcg"
            ])
        }) : null;
        $[0] = iconPath;
        $[1] = t1;
    } else t1 = $[1];
    const image = t1;
    const canEdit = isSpaceAdmin && !isPersonalSpace;
    if (!canEdit) return image;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage($6f43a2e4204022e9$var$i18n.editSpaceDetails);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const editLabel = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== expandLeftSidebar || $[6] !== experienceTracker || $[7] !== leftSidebarState.isFlyoutOpen || $[8] !== spaceId || $[9] !== spaceKey) {
        t3 = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            experienceTracker.start({
                name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
                timeout: 10000
            });
            setShouldRenderDialog(true);
            setIsDialogOpen(true);
            if (leftSidebarState.isFlyoutOpen) expandLeftSidebar();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editSpaceDetails",
                    source: "sideNavSpaceHeader",
                    containerType: "space",
                    containerId: spaceId,
                    attributes: {
                        navVersion: 4,
                        entryPoint: "sideNav",
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = expandLeftSidebar;
        $[6] = experienceTracker;
        $[7] = leftSidebarState.isFlyoutOpen;
        $[8] = spaceId;
        $[9] = spaceKey;
        $[10] = t3;
    } else t3 = $[10];
    const onClick = t3;
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setShouldRenderDialog(true);
        };
        $[11] = t4;
    } else t4 = $[11];
    const onFocus = t4;
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setShouldRenderDialog(true);
        };
        $[12] = t5;
    } else t5 = $[12];
    const onMouseEnter = t5;
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsDialogOpen(true);
        };
        $[13] = t6;
    } else t6 = $[13];
    const onDialogOpen = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsDialogOpen(false);
        };
        $[14] = t7;
    } else t7 = $[14];
    const onDialogClose = t7;
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$editIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }));
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== editLabel || $[17] !== image || $[18] !== onClick) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? $6f43a2e4204022e9$var$iconButton : $6f43a2e4204022e9$var$iconButtonFallback,
            "aria-label": editLabel,
            onClick: onClick,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter
        }, image, t8);
        $[16] = editLabel;
        $[17] = image;
        $[18] = onClick;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== editLabel || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: editLabel
        }, t9);
        $[20] = editLabel;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== isDialogOpen || $[24] !== shouldRenderDialog || $[25] !== spaceKey) {
        t11 = shouldRenderDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            isOpen: isDialogOpen,
            onOpen: onDialogOpen,
            onClose: onDialogClose,
            entryPoint: "sideNav"
        });
        $[23] = isDialogOpen;
        $[24] = shouldRenderDialog;
        $[25] = spaceKey;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== t10 || $[28] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[27] = t10;
        $[28] = t11;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
};
const $6f43a2e4204022e9$var$isOnSpaceRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_INDEX).name || routeName === (0, $1NBp8.SPACE_OVERVIEW).name
};
const $6f43a2e4204022e9$var$stickyWrapper = (0, $ecnYn.xcss)({
    position: 'sticky',
    top: 'space.0',
    zIndex: 'navigation' // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
});
const $6f43a2e4204022e9$var$icon = null;
const $6f43a2e4204022e9$var$iconButton = (0, $ecnYn.xcss)({
    border: "var(--ds-space-0, 0px)",
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$iconButtonFallback = (0, $ecnYn.xcss)({
    border: 'none',
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$editIconWrapper = (0, $ecnYn.xcss)({
    position: 'absolute',
    height: '24px',
    width: '24px',
    top: 'space.0',
    left: 'space.0',
    padding: 'space.050',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    backgroundColor: 'color.blanket',
    borderRadius: 'radius.medium'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f43a2e4204022e9$var$SpaceHeaderContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qutpp _n3td1skh _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6f43a2e4204022e9$var$i18n = (0, $aXWIB.defineMessages)({
    editSpaceDetails: {
        id: "side-navigation.space-navigation.header.edit-space-details",
        defaultMessage: "Edit space details"
    }
});



var $ENihE = parcelRequire("ENihE");











var $euL71 = parcelRequire("euL71");











var $28oQf = parcelRequire("28oQf");

const $078c23c8ca6acb4f$export$5ff3b51f9b84be4d = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { links: links } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPremiumEdition || $[2] !== routeDataRef) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "spaceNavigationItem",
                        source: "containerNavigation",
                        attributes: {
                            navigationLayer: "container",
                            itemId: itemId,
                            selectedItemPageContext: routeDataRef.current?.routeName,
                            navVersion: "4",
                            isPremiumEdition: isPremiumEdition
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = isPremiumEdition;
        $[2] = routeDataRef;
        $[3] = t1;
    } else t1 = $[3];
    const sendItemClickedAnalytics = t1;
    let t2;
    if ($[4] !== sendItemClickedAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$CalendarsLink, {
            key: "calendars-link",
            onClick: sendItemClickedAnalytics("calendars")
        });
        $[4] = sendItemClickedAnalytics;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== sendItemClickedAnalytics) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
            key: "questions-native-link",
            onClick: sendItemClickedAnalytics("questions")
        });
        $[6] = sendItemClickedAnalytics;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== links || $[9] !== t2 || $[10] !== t3) {
        const builtInitemsMapping = {
            [(0, $28oQf.CALENDARS_KEY)]: t2,
            [(0, $28oQf.QUESTIONS_NATIVE_KEY)]: t3
        };
        t4 = links.filter($078c23c8ca6acb4f$var$_temp).sort($078c23c8ca6acb4f$var$_temp2).map((t5)=>{
            const { webItemCompleteKey: webItemCompleteKey } = t5;
            return webItemCompleteKey && builtInitemsMapping[webItemCompleteKey] || null;
        });
        $[8] = links;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    const renderedLinks = t4;
    let t5;
    if ($[12] !== renderedLinks) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderedLinks);
        $[12] = renderedLinks;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
});

const $078c23c8ca6acb4f$var$CalendarsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HaydR",
    name: "CalendarsLink",
    loader: async ()=>(await (parcelRequire("eBq5a"))).CalendarsLink
});

const $078c23c8ca6acb4f$var$QuestionsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8uaMN",
    name: "QuestionsLink",
    loader: async ()=>(await (parcelRequire("8Ai3e"))).QuestionsLink
});
function $078c23c8ca6acb4f$var$_temp(link) {
    return Boolean(link && !link.hidden);
}
function $078c23c8ca6acb4f$var$_temp2(a, b) {
    return Number(a.position) - Number(b.position);
}



var $aWrnw = parcelRequire("aWrnw");


const $c83507daffd5a949$var$ErrorView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "NxOnG",
    name: "ErrorView",
    loader: async ()=>(await (parcelRequire("4vXZ9"))).ErrorView
});

const $c83507daffd5a949$var$SpaceApps = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MuuSQ",
    name: "SpaceApps",
    loader: async ()=>(await (parcelRequire("5rGiF"))).SpaceApps
});
const $c83507daffd5a949$var$spaceLinksStyles = null;
const $c83507daffd5a949$var$SidebarContent = /*#__PURE__*/ (0, $42omo.memo)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n3tdze3t _kqswh2mm _19pk1wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}));
const $c83507daffd5a949$var$separatorStyles = null;
const $c83507daffd5a949$var$separatorStylesFallback = null;
const $c83507daffd5a949$export$ec7f7d400376dc53 = (t0)=>{
    const $ = (0, $frIzR.c)(49);
    const { navigationProps: navigationProps, errorProps: errorProps, spaceDetails: spaceDetails } = t0;
    const { loading: loading, hasSpace: hasSpace, space: space, spaceKey: spaceKey, homepageId: homepageId, main: main, quick: quick, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, showShortcutsSection: showShortcutsSection, shouldRenderSpaceApps: shouldRenderSpaceApps, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, loadingForgeApps: loadingForgeApps, onContentTreeLoadComplete: onContentTreeLoadComplete } = navigationProps;
    const { unhandledError: unhandledError, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, anonymousAccessQueryError: anonymousAccessQueryError } = errorProps;
    if (unhandledError || hasRestrictedError || hasNotFoundError || anonymousAccessQueryError || !loading && !hasSpace) {
        const t1 = unhandledError || anonymousAccessQueryError;
        let t2;
        if ($[0] !== hasNotFoundError || $[1] !== hasRestrictedError || $[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$ErrorView, {
                unhandledError: t1,
                hasRestrictedError: hasRestrictedError,
                hasNotFoundError: hasNotFoundError
            });
            $[0] = hasNotFoundError;
            $[1] = hasRestrictedError;
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] !== spaceDetails) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), spaceDetails);
        $[4] = spaceDetails;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== loading) {
        t2 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[6] = loading;
        $[7] = t2;
    } else t2 = $[7];
    const t3 = spaceDetails?.spaceName;
    const t4 = spaceDetails?.iconPath;
    let t5;
    if ($[8] !== blogsHidden || $[9] !== homepageId || $[10] !== isBlogNavigation || $[11] !== isSpaceAdmin || $[12] !== loading || $[13] !== onContentTreeLoadComplete || $[14] !== onDragDropSuccess || $[15] !== pageTreeFinishedLoading || $[16] !== quick || $[17] !== showShortcutsSection || $[18] !== space || $[19] !== spaceKey || $[20] !== t3 || $[21] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $72da3bb5b7695f3e$export$7716f65eb5d1a3fd), {
            showShortcutsSection: showShortcutsSection,
            space: space,
            spaceKey: spaceKey,
            quick: quick,
            homepageId: homepageId,
            loading: loading,
            isSpaceAdmin: isSpaceAdmin,
            isBlogNavigation: isBlogNavigation,
            blogsHidden: blogsHidden,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            onDragDropSuccess: onDragDropSuccess,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            spaceName: t3,
            iconPath: t4
        });
        $[8] = blogsHidden;
        $[9] = homepageId;
        $[10] = isBlogNavigation;
        $[11] = isSpaceAdmin;
        $[12] = loading;
        $[13] = onContentTreeLoadComplete;
        $[14] = onDragDropSuccess;
        $[15] = pageTreeFinishedLoading;
        $[16] = quick;
        $[17] = showShortcutsSection;
        $[18] = space;
        $[19] = spaceKey;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $gMc0m.default)([
            "_18s8ze3t _1yt4ze3t _qtt8glyw _vjgoze3t"
        ]);
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== loading || $[25] !== main) {
        t7 = loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            header: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            links: main
        });
        $[24] = loading;
        $[25] = main;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== t6 || $[28] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            "data-testid": "space-links",
            className: t6
        }, t7);
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
    } else t8 = $[29];
    let t9;
    if ($[30] !== allAppLinks || $[31] !== allVisibleAppLinks || $[32] !== isSpaceAdmin || $[33] !== loading || $[34] !== loadingForgeApps || $[35] !== shouldRenderSpaceApps || $[36] !== spaceKey) {
        t9 = !loading && !loadingForgeApps && shouldRenderSpaceApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_APPS_METRIC)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SpaceApps, {
            spaceKey: spaceKey,
            isSpaceAdmin: isSpaceAdmin,
            allAppLinks: allAppLinks,
            allVisibleAppLinks: allVisibleAppLinks
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[30] = allAppLinks;
        $[31] = allVisibleAppLinks;
        $[32] = isSpaceAdmin;
        $[33] = loading;
        $[34] = loadingForgeApps;
        $[35] = shouldRenderSpaceApps;
        $[36] = spaceKey;
        $[37] = t9;
    } else t9 = $[37];
    let t10;
    if ($[38] !== t2 || $[39] !== t5 || $[40] !== t8 || $[41] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SidebarContent, {
            "data-vc": "space-navigation-sidebar-content"
        }, t2, t5, t8, t9);
        $[38] = t2;
        $[39] = t5;
        $[40] = t8;
        $[41] = t9;
        $[42] = t10;
    } else t10 = $[42];
    let t11;
    if ($[43] !== loading) {
        t11 = !loading && (0, $9wGTI.fg)("nav4_global_links_confluence") && ((0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itze3t _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itidpf _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }));
        $[43] = loading;
        $[44] = t11;
    } else t11 = $[44];
    let t12;
    if ($[45] !== t1 || $[46] !== t10 || $[47] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t10, t11);
        $[45] = t1;
        $[46] = t10;
        $[47] = t11;
        $[48] = t12;
    } else t12 = $[48];
    return t12;
};
module.exports["SpaceNavigationContent"] = $c83507daffd5a949$export$ec7f7d400376dc53;

});

parcelRegister("1tsAd", function(module, exports) {

let $112eabe910ef05c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $112eabe910ef05c0$var$load("5RR9C"),
    $112eabe910ef05c0$var$load("6wr18"),
    $112eabe910ef05c0$var$load("fLZBc"),
    $112eabe910ef05c0$var$load("bg5OF"),
    $112eabe910ef05c0$var$load("8YSo7"),
    $112eabe910ef05c0$var$load("6jGZ7"),
    $112eabe910ef05c0$var$load("Wowvf"),
    $112eabe910ef05c0$var$load("hhss7"),
    $112eabe910ef05c0$var$load("ffEVr"),
    $112eabe910ef05c0$var$load("jXx9i"),
    $112eabe910ef05c0$var$load("1cktr"),
    $112eabe910ef05c0$var$load("3Oy4g"),
    $112eabe910ef05c0$var$load("hogcU"),
    $112eabe910ef05c0$var$load("31vk5"),
    $112eabe910ef05c0$var$load("dkgtP"),
    $112eabe910ef05c0$var$load("g43Ev"),
    $112eabe910ef05c0$var$load("77NEU"),
    $112eabe910ef05c0$var$load("5wC2D"),
    $112eabe910ef05c0$var$load("7EorR"),
    $112eabe910ef05c0$var$load("1NnjK")
]).then(()=>parcelRequire('eTFt9'));

});

parcelRegister("1CdLs", function(module, exports) {
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6mkwk = parcelRequire("6mkwk");


var $jvL0g = parcelRequire("jvL0g");


var $6BXcn = parcelRequire("6BXcn");

const $417a895b4429e145$var$relativeStyles = {
    root: "_kqswh2mm"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $417a895b4429e145$export$341dea48c30b36ff = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $6mkwk.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            dropIndicator && $417a895b4429e145$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});
module.exports["ExpandableMenuItem"] = $417a895b4429e145$export$341dea48c30b36ff;

});

parcelRegister("YQCfa", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $aJT7b = parcelRequire("aJT7b");


var $6BXcn = parcelRequire("6BXcn");

const $73667a40c01a69a2$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $73667a40c01a69a2$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const level = (0, $6BXcn.useLevel)();
    const hasExpanded = (0, $42omo.useRef)(false);
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aJT7b.List), {
                ref: forwardedRef,
                xcss: (0, $1bHXt.cx)($73667a40c01a69a2$var$styles.content, !isExpanded && $73667a40c01a69a2$var$styles.collapsedContent),
                children: children
            })
        })
    });
});
module.exports["ExpandableMenuItemContent"] = $73667a40c01a69a2$export$bd680a81504a92e9;

});

parcelRegister("aJT7b", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $002d225363d96747$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $002d225363d96747$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $42omo.forwardRef)($002d225363d96747$var$_List);
module.exports["List"] = $002d225363d96747$export$54c2e3dc7acea9f5;

});

parcelRegister("8INvs", function(module, exports) {
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $3hoG4 = parcelRequire("3hoG4");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $dh538 = parcelRequire("dh538");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");


var $6BXcn = parcelRequire("6BXcn");

const $675a107b26f743ab$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $675a107b26f743ab$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $675a107b26f743ab$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $675a107b26f743ab$var$nestedOpenPopupStylesOld = {
    showProvidedElemBefore: "_v9u71txw _1hl9glyw"
}; // Merge back into the `wrapperStyles` after cleanup
const $675a107b26f743ab$var$nestedOpenPopupStylesNew = {
    showProvidedElemBefore: "_1ddp1txw _pnu5glyw"
};
const $675a107b26f743ab$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syazxl6c"
};
const $675a107b26f743ab$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const chevronElem = /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.providedElemBefore,
                    isSelected && $675a107b26f743ab$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $675a107b26f743ab$export$fe6fe51056867f4d = (0, $3hoG4.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $42omo.useId)();
    const onExpansionToggle = (0, $6BXcn.useOnExpansionToggle)();
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const setIsExpanded = (0, $6BXcn.useSetIsExpanded)();
    const itemRef = (0, $42omo.useRef)(null);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: itemRef,
        className: (0, $gMc0m.default)([
            $675a107b26f743ab$var$wrapperStyles.root,
            providedElemBefore && $675a107b26f743ab$var$wrapperStyles.showProvidedElemBefore,
            (0, $dh538.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? $675a107b26f743ab$var$nestedOpenPopupStylesNew.showProvidedElemBefore : $675a107b26f743ab$var$nestedOpenPopupStylesOld.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ExpandableMenuItemTrigger"] = $675a107b26f743ab$export$fe6fe51056867f4d;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("3qtLb", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $4VJDS = parcelRequire("4VJDS");


var $5Abqh = parcelRequire("5Abqh");


var $6mKj3 = parcelRequire("6mKj3");

const $674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';
const $674e09754a51af28$export$19ffb24f8071504 = 2;

const $674e09754a51af28$export$10d5dbd9dd81149f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-KKls",
    name: "PageTreeLoader",
    loader: async ()=>(await (parcelRequire("ktduV"))).PageTree
});

const $674e09754a51af28$export$8ce7795bff922b41 = (0, $jmjWc.LoadableHydrateOnHover)({
    __loadable_id__: "dXqjD",
    name: "PageTreeLoaderOnHover",
    loader: async ()=>(await (parcelRequire("ktduV"))).PageTree,
    hydrateImmediately: ()=>{
        // If page tree was not successfully rendered on server-side, hydrate immediately otherwise user will see a blank page tree
        return !(0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    }
});
const $674e09754a51af28$export$73500bf5f2e2b0c4 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $4VJDS.default).getNumber($674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
        $[0] = t0;
    } else t0 = $[0];
    const delayHydrationOnHoverTimeout = t0;
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !(0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) && delayHydrationOnHoverTimeout > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$8ce7795bff922b41, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$10d5dbd9dd81149f, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ANIMATE_TIME_SEC"] = $674e09754a51af28$export$19ffb24f8071504;
module.exports["PageTreeLoader"] = $674e09754a51af28$export$10d5dbd9dd81149f;
module.exports["PageTreeLoaderOnHover"] = $674e09754a51af28$export$8ce7795bff922b41;
module.exports["PageTree"] = $674e09754a51af28$export$73500bf5f2e2b0c4;

});

parcelRegister("ktduV", function(module, exports) {

let $ee70fc7c3c78da42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee70fc7c3c78da42$var$load("evk5p"),
    $ee70fc7c3c78da42$var$load("6wr18"),
    $ee70fc7c3c78da42$var$load("e4XZ1"),
    $ee70fc7c3c78da42$var$load("5ppK3"),
    $ee70fc7c3c78da42$var$load("an06t"),
    $ee70fc7c3c78da42$var$load("ajt6g"),
    $ee70fc7c3c78da42$var$load("4mgLr"),
    $ee70fc7c3c78da42$var$load("19uFC"),
    $ee70fc7c3c78da42$var$load("28l1x"),
    $ee70fc7c3c78da42$var$load("ffEVr"),
    $ee70fc7c3c78da42$var$load("iNa18"),
    $ee70fc7c3c78da42$var$load("hogcU"),
    $ee70fc7c3c78da42$var$load("31vk5"),
    $ee70fc7c3c78da42$var$load("dkgtP"),
    $ee70fc7c3c78da42$var$load("g43Ev"),
    $ee70fc7c3c78da42$var$load("4izLy"),
    $ee70fc7c3c78da42$var$load("hhss7"),
    $ee70fc7c3c78da42$var$load("Wowvf"),
    $ee70fc7c3c78da42$var$load("7EorR"),
    $ee70fc7c3c78da42$var$load("ltXeo")
]).then(()=>parcelRequire('bbZCI'));

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<addb5e142aa82e94041daec88a20b086>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("j3kZx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $42omo.useState)();
    const isDefaultExpanded = (0, $42omo.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $42omo.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
    const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};
module.exports["useSpacePersistentExpansion"] = $748c02fb00e52ac9$export$a0aa95d2fbef03e8;

});

parcelRegister("98dOx", function(module, exports) {

let $6a5f93987ad5146f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a5f93987ad5146f$var$load("421lv"),
    $6a5f93987ad5146f$var$load("1wM7E"),
    $6a5f93987ad5146f$var$load("203fu"),
    $6a5f93987ad5146f$var$load("dkgtP"),
    $6a5f93987ad5146f$var$load("g43Ev"),
    $6a5f93987ad5146f$var$load("6wr18"),
    $6a5f93987ad5146f$var$load("4dNRa"),
    $6a5f93987ad5146f$var$load("3R2Cd"),
    $6a5f93987ad5146f$var$load("1GCFv"),
    $6a5f93987ad5146f$var$load("1H5IN"),
    $6a5f93987ad5146f$var$load("a9w2G"),
    $6a5f93987ad5146f$var$load("k2R9e"),
    $6a5f93987ad5146f$var$load("7kkP6"),
    $6a5f93987ad5146f$var$load("h4Nf7"),
    $6a5f93987ad5146f$var$load("jbxHq"),
    $6a5f93987ad5146f$var$load("l0dTs"),
    $6a5f93987ad5146f$var$load("7do1E"),
    $6a5f93987ad5146f$var$load("77dkW"),
    $6a5f93987ad5146f$var$load("cyGuT"),
    $6a5f93987ad5146f$var$load("ffEVr"),
    $6a5f93987ad5146f$var$load("hhss7"),
    $6a5f93987ad5146f$var$load("31vk5"),
    $6a5f93987ad5146f$var$load("4izLy"),
    $6a5f93987ad5146f$var$load("7EorR"),
    $6a5f93987ad5146f$var$load("Wowvf"),
    $6a5f93987ad5146f$var$load("5RR9C"),
    $6a5f93987ad5146f$var$load("cQVtz")
]).then(()=>parcelRequire('k8aVt'));

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("bOLC6", function(module, exports) {
/**
 * @generated SignedSource<<894f0475d89546b8f8ba914dd859e916>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3f5a4229d0143cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$a3f5a4229d0143cd$var$node.hash = "9ec903133829a75826057a66a4a62727";
var $a3f5a4229d0143cd$export$2e2bcd8739ae039 = $a3f5a4229d0143cd$var$node;



var $3AeIf = parcelRequire("3AeIf");

/**
 * @generated SignedSource<<c8387b882d3435676c14c949ef15aace>>
 * @relayHash 197595cb76d03c058f5fbb845dc266a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b
const $2bef0e4e0b22cfa3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "persistenceOption"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "persistenceOption",
                                    "variableName": "persistenceOption"
                                },
                                v2 /*: any*/ 
                            ],
                            "kind": "ObjectValue",
                            "name": "spaceViewsPersistence"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "197595cb76d03c058f5fbb845dc266a1",
            "id": "89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b",
            "metadata": {},
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "operationKind": "mutation",
            "text": "mutation useSpaceViewsOptionsSpaceViewsPersistenceMutation($spaceKey:String!,$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey,persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$2bef0e4e0b22cfa3$var$node.hash = "c904b4b947ce0e659a2538aaffec18be";
var $2bef0e4e0b22cfa3$export$2e2bcd8739ae039 = $2bef0e4e0b22cfa3$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


const $c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation = (0, $2bef0e4e0b22cfa3$export$2e2bcd8739ae039);
const $c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery = (0, $3AeIf.default);
const $c39f0c35d43dec0d$export$1723fb5a667b3274 = (0, $aXWIB.defineMessages)({
    TREE: {
        id: "space-views.tree",
        defaultMessage: "Tree"
    },
    RECENTLY_VIEWED: {
        id: "space-views.recently.viewed",
        defaultMessage: "My visits"
    },
    RECENTLY_MODIFIED: {
        id: "space-views.recently.modified.nonfinal",
        // Remove .nonfinal suffix when copy is finalized
        defaultMessage: "Last updated"
    },
    TITLE_AZ: {
        id: "space-views.a-z.desc",
        defaultMessage: "Title - A to Z"
    }
});
const $c39f0c35d43dec0d$export$d285edfa1d91469 = (spaceKey, isLicensed = false)=>{
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !isLicensed
    });
    const [updatePersistence, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation);
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039),
        fragmentSpec: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039)
    });
    const setSpaceViewsSort = (0, $42omo.useCallback)((newSort)=>{
        updatePersistence({
            variables: {
                spaceKey: spaceKey,
                persistenceOption: newSort
            }
        }).catch(()=>{}); // ignoring errors here because we are consuming error from useMutation
        // Update the cache to keep UI updated regardless of whether the mutation succeeds
        writeFragmentInterop({
            fragmentId: `$ROOT_QUERY.userPreferences`,
            data: {
                spaceViewsPersistence: newSort,
                __typename: 'UserPreferences'
            },
            variables: {
                spaceKey: spaceKey
            }
        });
    }, [
        spaceKey,
        updatePersistence,
        writeFragmentInterop
    ]);
    const spaceViewsSort = data?.userPreferences?.spaceViewsPersistence || 'TREE'; //tree is default
    return {
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        queryLoading: queryLoading,
        queryError: queryError,
        mutationLoading: mutationLoading,
        mutationError: mutationError
    };
};
module.exports["sortI18n"] = $c39f0c35d43dec0d$export$1723fb5a667b3274;
module.exports["useSpaceViewsOptions"] = $c39f0c35d43dec0d$export$d285edfa1d91469;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<30b71203151c57c81eb934d688fd9be6>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "cc599626e8f53c4256f22a11dfce92c8";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("arWla", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eEA8O = parcelRequire("eEA8O");

const $c4de3c3a60bbeec4$var$buttonStyle = null;
const $c4de3c3a60bbeec4$var$menuButtonIconColor = (isWhiteboardBetaEnabled)=>{
    return isWhiteboardBetaEnabled ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$266a769812832828 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_s1xtjf": (0, $7sObp.default)($c4de3c3a60bbeec4$var$menuButtonIconColor(__cmplp.isWhiteboardBetaEnabled))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _bfhk1j28 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _i2zu1q3r _19lcplhp",
            __cmplp.isOpen ? "_1efs18pu" : "_1efsdgkc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _11c8wadc _ca0qt94y _u5f31l7b _n3tdt94y _19bv1l7b _bfhki8nm _syazi7uo _k48pwu06",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$74be2ccc72ce5bce = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$11b902a59791d036 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$bbba74ab4c493bc2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8wo40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$851411cf794a4cc4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1y44 _2hwx1y44 _otyr1y44 _18u0ftgi _2rko1rr0 _1yt418iy _19itglyw _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _bfhk1s93 _syaz1oa5 _1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$97bdf39f6b82bb0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4utpp _18s817d0 _11c8fhey _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o _4t3imgvx _syazi7uo",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$b2471e0920d79944 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
module.exports["DefaultLabel"] = $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b;
module.exports["NoIcon"] = $c4de3c3a60bbeec4$export$74be2ccc72ce5bce;
module.exports["FlexCenter"] = $c4de3c3a60bbeec4$export$11b902a59791d036;
module.exports["MoreButtonContainer"] = $c4de3c3a60bbeec4$export$bbba74ab4c493bc2;
module.exports["ErrorContainer"] = $c4de3c3a60bbeec4$export$97bdf39f6b82bb0;
module.exports["ErrorIconWrapper"] = $c4de3c3a60bbeec4$export$b2471e0920d79944;

});

parcelRegister("eX2cl", function(module, exports) {

let $ae2847dd0dcb5dcf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae2847dd0dcb5dcf$var$load("kHOMt"),
    $ae2847dd0dcb5dcf$var$load("5wC2D"),
    $ae2847dd0dcb5dcf$var$load("4izLy"),
    $ae2847dd0dcb5dcf$var$load("5TCys")
]).then(()=>parcelRequire('1wIcl'));

});

parcelRegister("lWNKj", function(module, exports) {

let $ffa59a3f0b1842ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffa59a3f0b1842ca$var$load("6pr2g"),
    $ffa59a3f0b1842ca$var$load("15N8O"),
    $ffa59a3f0b1842ca$var$load("QDkFg"),
    $ffa59a3f0b1842ca$var$load("hhss7"),
    $ffa59a3f0b1842ca$var$load("3DgZV"),
    $ffa59a3f0b1842ca$var$load("6gmSt")
]).then(()=>parcelRequire('5SYww'));

});

parcelRegister("7S98R", function(module, exports) {

let $5bb4aaeea9ea6815$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bb4aaeea9ea6815$var$load("kJLy8"),
    $5bb4aaeea9ea6815$var$load("4mgLr"),
    $5bb4aaeea9ea6815$var$load("hhss7"),
    $5bb4aaeea9ea6815$var$load("7EorR"),
    $5bb4aaeea9ea6815$var$load("eQlG4")
]).then(()=>parcelRequire('32xcy'));

});

parcelRegister("gVGbn", function(module, exports) {

let $c532b0ca38786551$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c532b0ca38786551$var$load("lUs3J"),
    $c532b0ca38786551$var$load("6wr18"),
    $c532b0ca38786551$var$load("e4XZ1"),
    $c532b0ca38786551$var$load("5ppK3"),
    $c532b0ca38786551$var$load("hhss7"),
    $c532b0ca38786551$var$load("ffEVr"),
    $c532b0ca38786551$var$load("iNa18"),
    $c532b0ca38786551$var$load("fZt2F"),
    $c532b0ca38786551$var$load("7EorR"),
    $c532b0ca38786551$var$load("31vk5"),
    $c532b0ca38786551$var$load("dkgtP"),
    $c532b0ca38786551$var$load("g43Ev"),
    $c532b0ca38786551$var$load("4izLy"),
    $c532b0ca38786551$var$load("hDNUK")
]).then(()=>parcelRequire('esUj7'));

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("7aA9P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

class $538583af869725c3$export$b170112dc71045f1 extends (0, $42omo.PureComponent) {
    render() {
        const props = Object.assign({}, this.props);
        if ((this.state.error || !props.src) && props.fallback) {
            if (typeof props.fallback === 'string') props.src = props.fallback;
            else if (typeof props.fallback === 'function') return props.fallback();
        }
        delete props.fallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            ...props,
            alt: props.alt || '',
            onError: this.onError
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
        this.onError = ()=>{
            this.setState({
                error: true
            });
        };
    }
}
$538583af869725c3$export$b170112dc71045f1.propTypes = {
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    ])
};
module.exports["FallbackableImage"] = $538583af869725c3$export$b170112dc71045f1;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $gMc0m.default)([
                        $71feb0a29953fded$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("jZM59", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $42omo.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
const $e6220385bdb59eee$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    return context;
};
const $e6220385bdb59eee$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    (0, $42omo.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};
module.exports["usePageLayoutResize"] = $e6220385bdb59eee$export$10c7104037a7af62;
module.exports["useLeftSidebarFlyoutLock"] = $e6220385bdb59eee$export$94561f6055639ef7;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("3SChL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $9zUhf.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $9zUhf.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $42omo.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $42omo.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("3Awqk", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $aXWIB.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $42omo.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $42omo.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $42omo.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("35Nok", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});

parcelRegister("eGUIL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $42omo.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("9BZ9X", function(module, exports) {

let $6ff702cc5d2be3a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6ff702cc5d2be3a6$var$load("lUs3J"),
    $6ff702cc5d2be3a6$var$load("6wr18"),
    $6ff702cc5d2be3a6$var$load("hHrTM"),
    $6ff702cc5d2be3a6$var$load("ffEVr"),
    $6ff702cc5d2be3a6$var$load("7EorR"),
    $6ff702cc5d2be3a6$var$load("fZt2F"),
    $6ff702cc5d2be3a6$var$load("PkFdp")
]).then(()=>parcelRequire('hSgLQ'));

});

parcelRegister("eYQg6", function(module, exports) {

let $ae7f34c709c89a0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae7f34c709c89a0f$var$load("2Tk6L"),
    $ae7f34c709c89a0f$var$load("6oFhK")
]).then(()=>parcelRequire('iwt54'));

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;

});

parcelRegister("eBq5a", function(module, exports) {

let $aa18c0cad27925d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa18c0cad27925d9$var$load("6wr18"),
    $aa18c0cad27925d9$var$load("ffEVr"),
    $aa18c0cad27925d9$var$load("c08ou")
]).then(()=>parcelRequire('99rcJ'));

});

parcelRegister("8Ai3e", function(module, exports) {

let $63ffb01b27107377$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63ffb01b27107377$var$load("6wr18"),
    $63ffb01b27107377$var$load("ffEVr"),
    $63ffb01b27107377$var$load("8uhuz")
]).then(()=>parcelRequire('ar6Ga'));

});

parcelRegister("4vXZ9", function(module, exports) {

let $34989688401e1317$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34989688401e1317$var$load("6wr18"),
    $34989688401e1317$var$load("ffEVr"),
    $34989688401e1317$var$load("klGUa")
]).then(()=>parcelRequire('8o2bj'));

});

parcelRegister("5rGiF", function(module, exports) {

let $3f70494418328523$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f70494418328523$var$load("6wr18"),
    $3f70494418328523$var$load("ffEVr"),
    $3f70494418328523$var$load("fZt2F"),
    $3f70494418328523$var$load("7EorR"),
    $3f70494418328523$var$load("kZjBp")
]).then(()=>parcelRequire('1xLOH'));

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("85RNG", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7hpmn = parcelRequire("7hpmn");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $6084008f41008b40$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
const $6084008f41008b40$export$84c726b6114f53f8 = ({ duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination width first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.width === prevDimensions.current.width) {
            onFinishMotion?.();
            return;
        }
        const newStyles = {
            width: `${prevDimensions.current.width}px`,
            willChange: 'width',
            transitionProperty: 'width',
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        Object.assign(element.style, newStyles);
        const resolvedDuration = $6084008f41008b40$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.width = `${nextDimensions.width}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $6084008f41008b40$export$5146a620d339842f = ({ children: children, ...props })=>{
    const resizing = $6084008f41008b40$export$84c726b6114f53f8(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children(resizing)
    });
};
module.exports["useResizingWidth"] = $6084008f41008b40$export$84c726b6114f53f8;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<54b68d5aa1c95b977f0cb84ddd5a4477>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("fG32j", function(module, exports) {

var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $6jrkJ = parcelRequire("6jrkJ");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
function $06e8bea7aad8a7b8$export$f1b4255eb8ae314e({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const superAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let data, error, loading;
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            fetchPolicy: superAdminClaim ? 'no-cache' : 'network-only',
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    }
    let isErrorHandled;
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            isErrorHandled = true;
        }
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        if (loading) return null;
        const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
        return children({
            error: error,
            isSpaceNotFound: isSpaceNotFound,
            isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
        });
    } else return children({
        error: isErrorHandled ? undefined : error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted,
        loading: loading
    });
}
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("iKHTh", function(module, exports) {

var $aJT7b = parcelRequire("aJT7b");

const $19720d3977b4df3f$export$d4c4e98c5044dc8 = (0, $aJT7b.List);
module.exports["MenuList"] = $19720d3977b4df3f$export$d4c4e98c5044dc8;

});

parcelRegister("4K4h4", function(module, exports) {
$parcel$export(module.exports, "ContentTreeIcon", () => (parcelRequire("iU0gR")).ContentTreeIcon);

var $jmjWc = parcelRequire("jmjWc");


var $iU0gR = parcelRequire("iU0gR");


const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("iU0gR")))).ContentTreeIcon
});
module.exports["ContentTreeIconLoader"] = $61f85e63c6992485$export$e511f243d20dd25e;

});

parcelRegister("iU0gR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $eG1e2 = parcelRequire("eG1e2");


var $5tmwS = parcelRequire("5tmwS");


var $e0ycV = parcelRequire("e0ycV");


var $g5QRf = parcelRequire("g5QRf");

const $3b6036244b1fd25e$export$160f5c89496b5ea9 = ({ label: label, color: color, spacing: // can override default icon color
spacing, type: type, isExpanded: isExpanded = false })=>{
    const contentTreeIconTypes = {
        page: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        whiteboard: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        slide: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        database: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        folder: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))) : (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        liveDoc: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV)))
    };
    const icon = contentTreeIconTypes[type];
    const testId = `content-tree-icon${spacing !== 'none' ? `-${spacing}` : ''}-${type}${type === 'folder' && isExpanded ? '-open' : ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(icon, {
        spacing: spacing,
        label: label,
        color: color,
        testId: testId
    });
};
module.exports["ContentTreeIcon"] = $3b6036244b1fd25e$export$160f5c89496b5ea9;

});

parcelRegister("6bZDi", function(module, exports) {
const $a8768b1a0c8c67c8$export$ee7a362b3ed8b036 = [
    'page',
    'whiteboard',
    'database',
    'slide',
    'folder',
    'liveDoc'
];
const $a8768b1a0c8c67c8$export$a73714094b2817b7 = (obj)=>typeof obj === 'string' && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(obj);
const $a8768b1a0c8c67c8$export$204659eac14d740b = (obj)=>$a8768b1a0c8c67c8$export$a73714094b2817b7(obj) ? obj : undefined;
const $a8768b1a0c8c67c8$export$c7c48cc42c0546b7 = (contentType)=>{
    const contentTreeType = $a8768b1a0c8c67c8$export$204659eac14d740b(contentType);
    return !!contentTreeType && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(contentTreeType);
};
module.exports["isContentTreeType"] = $a8768b1a0c8c67c8$export$a73714094b2817b7;
module.exports["includesValidContentTreeType"] = $a8768b1a0c8c67c8$export$c7c48cc42c0546b7;

});


//# sourceMappingURL=SpaceNavigationContent.4e9dd321.js.map
